// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Hide the default password reveal and clear icons in Edge */
input[type="password"]::-ms-reveal,
input[type="password"]::-ms-clear {
  display: none;
}

.myconsole {
	display: flex !important;
	flex-direction: row !important;
	overflow: hidden;
	font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif !important;
}

.searchBox {
	display: flex !important;
	flex-direction: row !important;
	justify-content: flex-end !important;
	margin: 20px 0px !important;
}

.p-radiobutton-label {
	font-size: 12px;
	margin-left: 5px;
	color: #757373;
	margin: auto 3px;
}

.radiobutton {
	display: flex;
	width: 71.5%;
	align-items: center;
}

.marginLeft {
	margin: 0px 10px !important;
}

.headerText {
	font-size: 20px !important;
	font-weight: 500 !important;
	color: #2A9235 !important;
}

.searchBoxSize {
	width: 50px !important;
	height: 20px !important;
}

.font13 {
	font-style: italic;
	font-size: 13px;
	color: #757373;
}

.p-inputtext-lg {
	font-size: 12px;
	color: '#9e9e9e'
}


.text-red-500 {
	font-size: 9px;
	/* margin-left: 150px; */
	margin-top: -4px;
	color: rgb(239 68 68);
}

.color-red {
	color: 'red';
}

/* Sidebar */
.sidebar .logo {
	width: 50% !important;
	cursor: pointer;
	margin-left: 27px;
}

.logo-icon {
	margin-left: 7px;
    width: 58% !important;
    cursor: pointer;
    height: 41px;
}

.logo-w-h {
	height: 45px;
	width: 68px;
}

.add-button {
	background-color: #2A9235 !important;
	color: white !important;
}

.sidebar .sm-add-button {
	width: 70%;
	padding: 5px;
	color: #4B5563;
	border-radius: 4px;
	border: 0;
	display: flex;
	/* Use Flexbox for centering */
	align-items: center;
	/* Center items vertically */
	justify-content: center;
	/* Center items horizontally */
	padding-left: 15px;
	cursor: pointer;
}

.sidebar .icons-end {
	position: absolute;
	bottom: 10px;
	right: 0px;
}

.sidebar .p-button-icon {
	padding-left: 5px !important;
	font-size: 14px !important;
	font-weight: 400 !important;
}

.sidebar .p-button-label {
	padding-left: 15px !important;
	font-size: 14px !important;
	font-weight: 400 !important;
	text-align: left !important;
}

.sidebar .p-panelmenu {
	width: 85% !important;
	margin: 0px 12px 0px 12px !important;
	height: 40px;
}

.sidebar .p-panelmenu-panel {
	margin: 5px 0px;
	box-shadow: 0 0 0 0 !important;
}

.sidebar .p-panelmenu-header-content {
	padding: 8px 5px !important;
    border: none;
    background-color: transparent;
    height: 40px;
}

.sidebar .selected-item .p-panelmenu-header-content {
	background-color: #DFF2E1 !important;
}

.sidebar .p-panelmenu-header-link {
	padding: 3px;
}

.sidebar .p-menuitem-icon {
	margin: 0px;
	padding-left: 5px !important;
	font-size: 14px !important;
	font-weight: 400 !important;
	color: #4B5563 !important;
}

.sidebar .p-menuitem-text {
	padding-left: 15px !important;
	font-size: 13px !important;
	font-weight: 400 !important;
	color: #4B5563 !important;
}

/* Header */

.content .header {
	height: 50px !important;
	display: flex;
	flex-direction: row;
	gap: 3rem;
	align-items: center;
	/* background: #2A92351A !important; */
}

@media (max-width: 600px) {
	.content .header {
		height: 50px !important;
		display: flex;
		flex-direction: row;
		gap: 1rem;
		align-items: center;
		background: #2A92351A !important;
	}
}

.header .headerLabel {
	margin: 0px 0px 0px 20px !important;
	font-size: 20px !important;
	font-weight: 500 !important;
	color: #2A9235 !important;
}

@media (max-width: 600px) {
	.header .headerLabel {
		margin: 0px 0px 0px 20px !important;
		font-size: 14px !important;
		font-weight: 500 !important;
		color: #2A9235 !important;
	}
}

.header .headerLabel>p {
	margin: 0px !important;
}

.header .headerSearch .pi {
	padding-top: 0.2rem;
	font-size: 0.75rem;
	font-weight: 400;
}

.header .headerSearch .p-inputtext {
	padding-top: 0.25rem;
	padding-right: 0.25rem;
	padding-bottom: 0.25rem;
	font-weight: 400;
	border: 1px solid rgba(74, 74, 74, 0.2);
	border-radius: 3px;
	color: rgba(0, 0, 0, 0.55);
}

@media (max-width: 720px) {
	.header .headerSearch .p-inputtext {
		padding-top: 0.25rem;
		padding-right: 0.25rem;
		padding-bottom: 0.25rem;
		font-weight: 400;
		width: 230px;
		border: 1px solid rgba(74, 74, 74, 0.2);
		border-radius: 3px;
		color: rgba(0, 0, 0, 0.55);
	}
}

@media (max-width: 600px) {
	.header .headerSearch .p-inputtext {
		padding-top: 0.25rem;
		padding-right: 0.25rem;
		padding-bottom: 0.25rem;
		font-weight: 400;
		width: 150px;
		border: 1px solid rgba(74, 74, 74, 0.2);
		border-radius: 3px;
		color: rgba(0, 0, 0, 0.55);
	}
}

/* Steps */

.p-steps .p-steps-item {
	width: 20%;
}

.portfolio-steps #pr_id_3_6.p-steps-item:before {
	width: 100%;
	position: absolute !important;
	margin: 0px 0px 1.25rem 0px !important;
	left: auto;
	top: auto;
	content: " ";
	border-top: 1px solid rgba(0, 0, 0, 0.12);
	display: block;
}

/* portfolio-cards Portfolio */

.portfolio-cards {
	display: flex !important;
	flex-direction: row !important;
	justify-content: space-between !important;
	margin-top: 20px !important;
}

.portfolio-cards .p-card {
	width: 19%;
	padding: 10px;
}

.portfolio-cards .p-card-body {
	padding: 0px;
}

.portfolio-cards .p-card-content {
	padding: 0px;
}

.portfolio-cards .cardHeader {
	margin: 5px !important;
	display: flex !important;
	flex-direction: row !important;
	justify-content: space-between !important;
}

.portfolio-cards .cardTitle {
	font-size: 12px !important;
	font-weight: 500 !important;
	margin: 0px !important;
	color: #4B5563 !important;
}

.portfolio-cards .progressStatus {
	font-size: 12px !important;
	margin: 0px !important;
	color: #2A9235 !important;
}

.portfolio-cards .cardContent {
	height: 30px !important;
	margin: 5px 5px 5px 5px !important;
	padding-top: 5px !important;
	display: flex !important;
	flex-direction: row !important;
	justify-content: space-between !important;
}

.portfolio-cards .p-progressbar {
	width: 128px !important;
	height: 8px !important;
	margin-top: 8px !important;
	/* border: solid 1px rgba(42, 146, 53, 0.5) !important; */
	border-radius: 4px !important;
	justify-content: center !important;
}

.portfolio-cards .p-progressbar {
	background-color: white;
}

/* .portfolio-cards .p-progressbar-value {
	background-color: #2A9235 !important;
} */

.portfolio-cards .p-progressbar-label {
	color: transparent !important;
}

.portfolio-cards .progressPercentage,
.portfolio-cards .costValue {
	margin: 2px 0px 0px 0px !important;
	font-size: 12px !important;
	font-weight: 500 !important;
	color: #4B5563 !important;
}

.portfolio-menu .p-menuitem {
	padding: 0px 0px 0px 10px !important;
}

.portfolio-menu .p-menuitem-link {
	padding: 10px;
}

/* Portfolio Menu Content */

.portfolio-content .portfolio-menu-content {
	width: 100% !important;
	border-left: 1px solid rgba(94, 189, 104, 0.25) !important;
	padding: 0px 0px 0px 18px;
	height: 100vh !important;
	margin-top: 20px;
}

.portfolio-menu-content .p-scrollpanel {
	margin-top: 20px !important;
	height: 280px !important;
	border: 1px solid rgba(42, 146, 53, 0.25) !important;
	border-radius: 3px;
}

.portfolio-menu-content .p-scrollpanel-content {
	width: 100%;
	height: 100%;
	padding: 0px !important;
}

/* Summary Dropdowns and Inputs */
.summaryTopic {
	width: 100%;
	margin-left: 10px;
	display: flex;
	flex-direction: column;
	gap: 10px;
	justify-content: center;
	align-self: center;
	align-items: flex;
}

.summaryTopic>p {
	width: 94%;
	margin: 0px;
	padding-bottom: 2px;
	font-size: 12px;
	font-weight: 400;
	color: rgba(0, 31, 84, 1);
	border-bottom: 1px solid rgba(94, 189, 104, 0.35);
	border-radius: 2px;
}

.summaryTopic label {
	font-size: 12px;
	width: 130px;
}


.summaryTopic .summary-dropdown {
	display: flex;
	flex-direction: row;
	gap: 1rem;
	align-items: center;
}


/* PasswordChange.css */
.p-inputgroup {
	display: flex;
	align-items: center;
}

.p-inputgroup .p-inputtext {
	flex: 1 1;
	margin-left: 1rem;
}

.p-field {
	margin-bottom: 1.5rem;
}

label {
	display: block;
	margin-bottom: 0.5rem;
}

.p-field-switch {
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100px;
	/* Adjust width as needed */
}


/* app.css */
.custom-multiselect .p-multiselect {
	font-size: 12px;
	height: 30px;
	/* Adjust height as needed */
	line-height: 30px;

	/* Adjust line-height as needed */
}

.custom-multiselect .p-multiselect-label-container {
	font-size: 12px;
	height: 30px;
	/* Adjust height as needed */
	line-height: 30px;
	/* Adjust line-height as needed */
	display: flex;
	align-items: center;
}



.custom-multiselect .p-multiselect-trigger .p-multiselect-trigger-icon {
	font-size: 12px;
	/* Adjust font-size to make the icon smaller */
}

.custom-multiselect .p-multiselect-panel {
	font-size: 12px;
	max-height: 100px;
}

.custom-multiselect .p-multiselect-item {
	font-size: 12px;
	line-height: 30px;

	/* Adjust line-height as needed */
}

.custom-multiselect .p-multiselect-items {
	max-height: 100px;
	overflow-y: auto;
}

.p-multiselect-item span {
	font-size: 12px;
	color: #4B5563;
}

.p-multiselect-checkbox .p-checkbox-box {
	margin-top: 2px;
}

/* Custom styles for chips */
.custom-multiselect .p-multiselect-token {
	font-size: 12px;
	height: 20px;
	/* Adjust height as needed */
	line-height: 20px;
	/* Adjust line-height as needed */
	margin: 2px;
	/* Adjust margin as needed */
	padding: 2px 5px;
	/* Adjust padding as needed */
	border-radius: 5px;
	/* Adjust border-radius as needed */
}

.custom-multiselect .p-multiselect-token-label {
	font-size: 12px;
	height: 16px;
	/* Adjust height as needed */
	line-height: 16px;

	/* Adjust line-height as needed */
}

.custom-multiselect .p-multiselect-token-icon {
	font-size: 12px;
	height: 15px;
	/* Adjust height as needed */
	line-height: 15px;
	/* Adjust line-height as needed */
}

.summaryTopic .summary-dropdown .p-dropdown-label.p-inputtext {
	padding: 0px;
	font-size: 12px;
	color: rgba(74, 74, 74, 0.5);
}

.p-dropdown-label.p-inputtext,
.p-dropdown-item-label {
	font-size: 12px;
	color: #4B5563;
}

.summaryTopic .summary-dropdown .p-dropdown-trigger-icon {
	height: 10px;
	width: 10px;
	color: rgba(74, 74, 74, 0.5);
}

.portfolio-buttons {
	margin-top: 10px;
	margin-left: 600px;
	display: flex;
	flex-direction: row;
	gap: 15px;
}

.portfolio-buttons .p-button {
	padding: 5px;
	height: 28px;
	width: 40px;
	background-color: rgba(255, 255, 255, 1);
	border-radius: 4px;
}

.portfolio-buttons .previous.p-button {
	border: 1px solid rgba(74, 74, 74, 0.5);
}

.portfolio-buttons .next.p-button {
	border: 1px solid rgba(42, 146, 53, 1);
}

.portfolio-buttons .save.p-button {
	background-color: rgba(42, 146, 53, 1);
}

.portfolio-buttons .p-button-label {
	font-size: 12px;
	font-weight: 400;
	background-color: rgba(255, 255, 255, 1);
	color: rgba(74, 74, 74, 0.75);
}

.portfolio-buttons .p-button-label {
	font-size: 12px;
	font-weight: 400;
	background-color: rgba(255, 255, 255, 1);
	color: rgba(74, 74, 74, 0.75);
}

.portfolio-buttons .save .p-button-label {
	background-color: rgba(42, 146, 53, 1);
	color: rgba(255, 255, 255, 1);
}

.form-control-inputnumber {
	width: 100px
}

.custom-increment-button {
	width: 12px !important;
	height: 12px !important;
	margin-left: -20 !important;
	background-color: rgba(42, 146, 53, 1);
}

.custom-decrement-button {
	width: 12px !important;
	height: 12px !important;
	margin-left: -20 !important;
	background-color: rgba(42, 146, 53, 1);
}

.select-button .p-dropdown-item.p-highlight {
	background-color: green !important;
}

/* Alignments */

.ml-0 {
	margin-left: 0px !important;
}

.mt-0 {
	margin-top: 0px !important;
}

.mar-t-5 {
	margin-top: 5px !important;
}

.mar-t-8 {
	margin-top: 8px !important;
}

.mar-16 {
	margin: 16px;
}

.ml-2 {
	margin-left: 2px;
}

.mar-l-5 {
	margin-left: 5px !important;
}

.ml-10 {
	margin-left: 10px;
}

.ml-15 {
	margin-left: 15px;
}

.ml-20 {
	margin-left: 20px;
}

.ml-25 {
	margin-left: 25px;
}

.mr-2 {
	margin-right: 2px;
}

.mr-5 {
	margin-right: 5px !important;
}

.mr-20 {
	margin-right: 20px;
}
.mr-560 {
	margin-right: 560px;
}

.mt-10 {
	margin-top: 10px !important;
}

.mt-13 {
	margin-top: 13px !important;
}

.mt-20 {
	margin-top: 20px !important;
}

.mt-30 {
	margin-top: 30px;
}

.mb-20 {
	margin-bottom: 20px !important;
}

/* .mb-16 {
    margin-bottom: 16px;
} */

.pr-12 {
	padding-right: 12px;
}

.p-0 {
	padding: 0px !important;
}

.pr-0 {
	padding-right: 0px;
}

.w-350 {
	width: 350px;
}

.h-25 {
	height: 25px;
}

.h-27 {
	height: 27px;
}

.h-350 {
	height: 350px !important;
}

.flex {
	display: flex;
}

.flex-wrap {
	flex-wrap: wrap;
}

.justify-center {
	justify-content: center;
}

.justify-space-between {
	justify-content: space-between;
}

.justify-end {
	justify-content: end !important;
}

.align-center {
	align-items: center;
}

.direction-col {
	flex-direction: column;
}

/* Select Button*/

.p-selectbutton .p-button,
.p-selectbutton .p-button:focus {
	font-size: 12px;
	font-family: '-apple-system', 'BlinkMacSystemFont', 'Segoe UI', 'Roboto', 'Oxygen',
		'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif
}

.p-selectbutton .p-button.p-highlight,
.p-selectbutton .p-button:focus.p-highlight {
	color: #ffff;
	font-size: 12px;
	background: #3F51B5 !important;
	border-color: #3F51B5 !important;
}

.text-xs {
	font-size: 12px;
}

/* STAKEHOLDER ASSESSMENT QUESTIONS */

.header-design {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.group-header {
	font-weight: 600;
	font-size: 12px;
	text-align: left;
	background-color: #2A92351A;

}

.group-table-header tr th {
	text-align: left;
}

.group-table-header tr th:nth-child(1) {
	text-align: center;
}

.group-table-row {
	font-size: 14px;
}

.group-datatable {
	min-width: 100%;
	border-collapse: collapse;
}

.group-table-row tr:hover {
	background-color: transparent;
	cursor: pointer;
}

.group-table-row td,
.group-table-header tr th {
	width: 100%;
	border: 1px solid #f8f9fa;
	/* background-color: red; */
	text-align: left;
	padding: 8px 10px !important;
	font-size: 14px;
	/* white-space: nowrap; */
}

.budget-plan .group-table-row td,
.budget-plan .group-table-header tr th  {
	white-space: nowrap;
}

.group-table-header tr th {
	font-weight: 500;
}

.group-table-row td:nth-child(1),
.group-table-header tr th:nth-child(1) {
	text-align: center;
}

.group-table-row td:nth-child(1),
.group-table-row th:nth-child(1) {
	width: 50px;
}

.group-table-row th:nth-child(2),
.group-table-row td:nth-child(2) {
	width: 100%;
	min-width: 100%;
}

.checkbox-header {
	width: 5% !important;

}

.checkbox {
	margin: auto;
}

.group-table-row i {
	font-size: 14px;
}

.group-table-search {
	display: flex;
	justify-content: right;
	align-items: center;
	width: max-content;
}

.group-table-buttons {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: 20px auto 10px auto;
}

.clear-filter-button {
	margin-left: 15px;
	width: 38px;
	height: 34px;
	background-color: #2A9235;
	border-radius: 4px;
	padding: 10px;
	border-color: #2A9235;
}

.export-button {
	margin-left: 15px;
    width: 150px;
    height: 34px;
    background-color: #2A9235;
    border-radius: 4px;
    padding: 10px;
	border-color: #2A9235;
}


.new-button {
	margin-left: 15px;
	width: 100px;
	height: 34px;
	background-color: #2A9235;
	border-radius: 4px;
	padding: 7px;
	border-color: #2A9235;
}

.delete-button-icon {
	width: 38px;
	height: 34px;
	padding: 10px;
	background-color: #2A9235 !important;
	border-color: #2A9235 !important;
	border-radius: 4px;
}

.delete-button {
	background-color: #2A9235 !important;
	border-color: #2A9235 !important;
	border-radius: 4px;
}


.upload-button {
	width: 35px;
	height: 35px;
	background-color: #2A9235;
	border-radius: 4px !important;
}

.upload-button .p-button-icon {
	color: #FFFFFF;
}

.add-button {
	text-align: right;
	width: max-content;
}

.search-input {

	height: 35px;
	width: 300px;
	padding: 10px 40px;
	outline: none;
	font-size: 13px;

}

.p-inputtext:enabled:focus {
	box-shadow: inset 0 0 0 1px #2A9235, inset 0 0 0 1px #2A9235, inset 0 0 0 1px #2A9235, inset 0 0 0 1px #2A9235 !important;
	border-color: #2A9235;
}

.p-input-icon-left i {
	margin-left: 13px;
	font-size: 14px;
	padding-top: 1px;
	color: #4B5563;
}

.p-dropdown-empty-message {
	font-size: 14px;
	color: #4B5563;
}

.group-table-search i {
	margin-right: 20px;
}

.group-table-text-section {
	font-size: 10px;
	color: #666666;
}

.group-table-component {
	margin-top: 20px;
}

.group-table-component h2 {
	margin: 0;
	padding: 0;
	color: #2A9235;
}

.group-table-data {

	overflow-x: auto;
	height: 60vh;
	position: relative;
}

.group-table-header {
	position: sticky;
	/* top: 0; */
	background-color: #f8f9fa;
	color: #2A9235;
	z-index: 1;
}

.group-table-header:first-of-type {
    top: 0;
}

.group-table-header:last-of-type {
    bottom: 0;
    position: sticky;
}

.group-table-data::-webkit-scrollbar {
	width: 0;
}

.group-field-display {
	display: flex;
	flex-wrap: wrap;

}

.input-group {
	display: flex;
	flex-direction: column;
	margin-top: 1px;
	width: 30%;
	margin: 20px auto;

}

.group-button-handle div {

	text-align: left;

}

.input-group label {
	width: 100%;
	font-size: 14px;
	margin: 10px auto;
}

.group-field-handle {
	height: 35px;
	padding: 1px;
	width: 220px;
}

/* 
.dropdown-field-handle {
	height: 35px;
	margin: 0px;
	width: 215px;
} */

.group-option-field {
	width: 100%;
	background: #2A9235 !important;
	font-weight: 600;
	margin-top: 30px !important;
	color: white;
}

.group-option-field p {
	margin: 8px;
}

.group-popup-button {
	justify-content: flex-end !important;
}

.group-popup-button div {
	margin: 2px;
}

.no-data-found {
	color: red;
}

.group-table-row tr:last-child td {
	border-bottom: none;
}

.group-table-row {
	width: calc(100% - 17px);
	/* Adjust for scrollbar width */
}

/* Steps */

.portfolio-steps .p-steps {
	padding: 0px;
}

.portfolio-steps .p-menuitem-link {
	flex-direction: column !important;
	padding: 0px;
	gap: 0.5rem;
}

.portfolio-steps .p-steps-current .p-steps-number {
	border: 2px solid rgba(94, 189, 104, 1) !important;
	background-color: rgba(94, 189, 104, 1) !important;
	color: rgba(255, 255, 255, 1) !important;
	font-size: 0.7rem;
	padding: 7px 10px;
	margin-top: 25px;
}

.portfolio-steps .p-steps-number {
	border: 2px solid rgba(74, 74, 74, 0.2) !important;
	background-color: rgba(255, 255, 255, 1);
	color: rgba(74, 74, 74, 0.5) !important;
	font-size: 0.7rem;
	padding: 7px 10px;
	margin-top: 27px;
}

.portfolio-steps .p-steps-title {
	font-weight: 400;
	font-size: 0.7rem;
	padding: 0px;
	white-space: break-spaces;
}

.portfolio-steps .p-steps-item:last-child::before {
	content: " ";
	border-top: 1px solid #dee2e6;
	width: 100%;
	top: 50%;
	left: 0;
	display: block;
	position: absolute;
	margin-top: -1px;
	/* width: 300px; */
}

.portfolio-steps .p-steps .p-steps-item.p-highlight .p-steps-title {
	font-weight: bold;
}

.portfolio-steps ol,
ul {
	padding-left: 0px !important;
}

.portfolio-steps .p-steps-item:before {
	margin-top: -1px;
}

.portfolio-steps #pr_id_3_6.p-steps-item:before {
	width: 100%;
	position: absolute !important;
	margin: 0px 0px 1.25rem 0px !important;
	left: auto;
	top: auto;
	content: " ";
	border-top: 1px solid rgba(0, 0, 0, 0.12);
	display: block;
}

/* portfolio-cards Portfolio */

.portfolio-cards {
	display: flex !important;
	flex-direction: row !important;
	justify-content: space-between !important;
	margin-top: 20px !important;
}

.portfolio-cards .cardHeader {
	margin: 5px !important;
	display: flex !important;
	flex-direction: row !important;
	justify-content: space-between !important;
}

.portfolio-cards .cardTitle {
	font-size: 12px !important;
	font-weight: 500 !important;
	margin: 0px !important;
	color: rgba(0, 0, 0, 1) !important;
}

.portfolio-cards .progressStatus {
	font-size: 12px !important;
	margin: 0px !important;
	color: #2A9235 !important;
}

.portfolio-cards .cardContent {
	height: 30px !important;
	margin: 5px 5px 5px 5px !important;
	padding-top: 5px !important;
	display: flex !important;
	flex-direction: row !important;
	justify-content: space-between !important;
}

.portfolio-cards .p-progressbar {
	width: 128px !important;
	height: 8px !important;
	margin-top: 8px !important;
	border: solid 1px rgba(42, 146, 53, 0.5) !important;
	border-radius: 4px !important;
	justify-content: center !important;
}

.portfolio-cards .p-progressbar {
	background-color: white;
}

.portfolio-cards .p-progressbar-value {
	background-color: #2A9235 !important;
}

/* .portfolio-cards .p-progressbar-label {
	color: #2A9235 !important;
} */

/* Portfolio Menu */

.portfolio-content {
	display: flex !important;
	flex-direction: row !important;
	height: 100vh;
}

.portfolio-menu {
    position: sticky;
    top: 0;
    height: 100vh;
    overflow: auto;
	width: 19%;
	margin-top: 20px;
}

.custom-tabview {
	overflow: hidden;
}

.custom-tabview .p-tabview-nav-container {
	position: sticky;
    top: 0;
    height: 100vh;
    overflow: auto;
    width: 200px;
    flex-shrink: 0;
}

.collapse-tabs .custom-tabview .p-tabview-nav-container {
	width: 62px !important;
}

.custom-tabview .p-accordion .p-accordion-tab {
	box-shadow: none !important;
}

.portfolio-menu .p-menu {
	width: 195px !important;
	height: auto !important;
	padding: 0px;
	/* margin-top: 20px !important; */
	border-left: 1px solid rgba(94, 189, 104, 0.25) !important;
	border-radius: 0px;
	border-top: 0px;
	border-right: 0px;
	border-bottom: 0px;
}

.portfolio-menu .p-menu ol, ul, dl {
	margin-bottom: 0px !important;
}

.portfolio-menu .p-menuitem {
	padding: 0px 0px 0px 10px !important;
}

.portfolio-menu .p-menuitem-link {
	padding: 10px;
}

.portfolio-menu .p-menuitem-text {
	font-size: 12px !important;
	font-weight: 400 !important;
	color: rgba(74, 74, 74, 1) !important;
}


/* Portfolio Menu Content */

.portfolio-content .portfolio-menu-content {
	width: 100% !important;
	border-left: 1px solid rgba(94, 189, 104, 0.25) !important;
	padding: 0px 0px 0px 18px;
	margin-top: 20px;
	overflow-y: auto;
    height: 100vh;
}

.portfolio-menu-content .p-scrollpanel {
	margin-top: 20px !important;
	height: 280px !important;
	border: 1px solid rgba(42, 146, 53, 0.25) !important;
	border-radius: 3px;
}

.portfolio-menu-content .p-scrollpanel-content {
	width: 100%;
	height: 100%;
	padding: 0px !important;
}

/* Summary Dropdowns and Inputs */
.summaryTopic {
	width: 100%;
	margin-left: 0px;
	display: flex;
	flex-direction: column;
	gap: 10px;
	justify-content: center;
	align-self: center;
	align-items: flex;
}

.summaryTopic>p {
	width: 94%;
	margin: 0px;
	padding-bottom: 2px;
	font-size: 12px;
	font-weight: 400;
	color: rgba(0, 31, 84, 1);
	border-bottom: 1px solid rgba(94, 189, 104, 0.35);
	border-radius: 2px;
}

.summaryTopic label {
	font-size: 12px;
	width: 130px;
}

.summaryTopic .summary-input-text {
	display: flex;
	flex-direction: row;
	gap: 1rem;
	align-items: center;
}

.summaryTopic .summary-dropdown {
	display: flex;
	flex-direction: row;
	gap: 1rem;
	align-items: center;
}

.summaryTopic .summary-input-text .p-inputtext {
	width: 100%;
	height: 30px;
	padding: 0px 0px 0px 15px;
	border: 1px solid rgba(74, 74, 74, 0.15);
	border-radius: 5px;
}

.summaryTopic .summary-input-text-red .p-inputtext {
	width: 100%;
	height: 30px;
	padding: 0px 0px 0px 15px;
	border: 1px solid red;
	border-radius: 5px;
}

.summaryTopic .summary-input-text .p-inputtext::placeholder {
	font-size: 12px;
	font-weight: 400;
	color: rgba(74, 74, 74, 0.5);
}

.summaryTopic .summary-dropdown .p-dropdown {
	width: 100%;
	/* height: 30px; */
	padding-left: 15px;
	align-items: center;
	border: 1px solid rgba(74, 74, 74, 0.15);
	border-radius: 5px;
}

.summaryTopic .summary-dropdown .p-dropdown-label.p-inputtext {
	padding: 0px;
	font-size: 12px;
	color: rgba(74, 74, 74, 0.5);
}

.summaryTopic .summary-dropdown .p-dropdown-trigger-icon {
	height: 10px;
	width: 10px;
	color: rgba(74, 74, 74, 0.5);
}

.portfolio-buttons {
	margin-top: 10px;
	margin-left: 600px;
	display: flex;
	flex-direction: row;
	gap: 15px;
}

.portfolio-buttons .p-button {
	padding: 5px;
	height: 28px;
	width: 40px;
	background-color: rgba(255, 255, 255, 1);
	border-radius: 4px;
}

.portfolio-buttons .previous.p-button {
	border: 1px solid rgba(74, 74, 74, 0.5);
}

.portfolio-buttons .next.p-button {
	border: 1px solid rgba(42, 146, 53, 1);
}

.portfolio-buttons .save.p-button {
	background-color: rgba(42, 146, 53, 1);
}

.portfolio-buttons .p-button-label {
	font-size: 12px;
	font-weight: 400;
	background-color: rgba(255, 255, 255, 1);
	color: rgba(74, 74, 74, 0.75);
}

.portfolio-buttons .p-button-label {
	font-size: 12px;
	font-weight: 400;
	background-color: rgba(255, 255, 255, 1);
	color: rgba(74, 74, 74, 0.75);
}

.portfolio-buttons .save .p-button-label {
	background-color: rgba(42, 146, 53, 1);
	color: rgba(255, 255, 255, 1);
}

.form-control-inputnumber {
	width: 100px
}

.custom-increment-button {
	width: 12px !important;
	height: 12px !important;
	margin-left: -20 !important;
	background-color: rgba(42, 146, 53, 1);
}

.custom-decrement-button {
	width: 12px !important;
	height: 12px !important;
	margin-left: -20 !important;
	background-color: rgba(42, 146, 53, 1);
}

.select-button .p-dropdown-item.p-highlight {
	background-color: green !important;
}

/* Alignments */

.ml-0 {
	margin-left: 0px;
}

.mt-0 {
	margin-top: 0px;
}

.ml-2 {
	margin-left: 2px;
}

.mr-2 {
	margin-right: 2px;
}

.mt-30 {
	margin-top: 30px;
}

.pt-0 {
	padding-top: 0px;
}

.pt-5 {
	padding-top: 5px;
}

.pad-t-8 {
	padding-top: 8px !important;
}

.pad-b-8 {
	padding-bottom: 8px !important;
}

.pt-10 {
	padding-top: 10px;
}

.pt-17 {
	padding-top: 17px;
}

.pt-18 {
	padding-top: 18px !important;
}

.pl-10 {
	padding-left: 10px;
}

.pl-16 {
	padding-left: 16px;
}

.pl-0 {
	padding-left: 0px !important;
}

.p-15 {
	padding: 15px !important;
}

.padding-8 {
	padding: 8px 17px !important;
}

.mar-b-3 {
	margin-bottom: 3px;
}

.pr-12 {
	padding-right: 12px;
}

.width-025 {
	width: 0.25% !important;
}

.width-2 {
	width: 2% !important;
}

.width-3 {
	width: 3% !important;
}

.width-5 {
	width: 5% !important;
}

.width-6 {
	width: 6% !important;
}

.width-7 {
	width: 7% !important;
}

.width-9 {
	width: 9% !important;
}

.width-10 {
	width: 10% !important;
}

.width-11_5 {
	width: 11.5% !important;
}

.width-12 {
	width: 12% !important;
}

.width-15 {
	width: 15% !important;
}

.w-20 {
	width: 20% !important;
}

.w-25 {
	width: 25% !important;
}

.w-30 {
	width: 30% !important;
}

.width-3 {
	width: 3rem !important;
}

.width-46 {
	width: 46vw !important;
}

.width-32 {
	width: 32rem !important;
}

.width-40vw {
	width: 40vw !important;
}

.width-42vw {
	width: 42vw !important;
}

.width-42 {
	width: 42% !important;
}

.w-40 {
	width: 40% !important;
}

.w-50 {
	width: 50%;
}

.w-70 {
	width: 70%;
}

.w-100 {
	width: 100%;
}

.w-150 {
	width: 150px !important;
}

.w-350 {
	width: 350px;
}

.h-25 {
	height: 30px;
}

.h-27 {
	height: 27px;
}

.flex {
	display: flex;
}

.justify-center {
	justify-content: center;
}


.direction-col {
	flex-direction: column;
}

.white-space {
	white-space: nowrap;
}

.word-wrap {
	word-wrap: break-word;
}

.font-color-white {
	color: #fff;
}

.background-red .p-progressbar-value {
	background-color: #ff0005 !important;
}

.background-red .p-progressbar {
	border-color: #ff0005 !important;
}

.background-amber .p-progressbar-value {
	background-color: #ffbf00 !important;
}

.background-amber .p-progressbar {
	border-color: #ffbf00 !important;
}

.background-green .p-progressbar-value {
	background-color: green !important;
}

.background-green .p-progressbar {
	border-color: green !important;
}

.border-red {
	border-color: red !important;
}

.border-grey {
	border-color: #E5E7EB !important;
}

.fs-12 {
	font-size: 12px;
}

.fs-13 {
	font-size: 13px !important;
}

.fs-16 {
	font-size: 16px;
}

.fs-18 {
	font-size: 18px !important;
}

.fw-500 {
	font-weight: 500;
}

.fw-600 {
	font-weight: 600;
}

/* Select Button*/

.p-selectbutton .p-button,
.p-selectbutton .p-button:focus {
	font-size: 12px;
	font-family: '-apple-system', 'BlinkMacSystemFont', 'Segoe UI', 'Roboto', 'Oxygen',
		'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif
}

.p-selectbutton .p-button.p-highlight,
.p-selectbutton .p-button:focus.p-highlight {
	color: #ffff;
	font-size: 12px;
	background: #3F51B5 !important;
	border-color: #3F51B5 !important;
}

.text-xs {
	font-size: 12px;
}

/* STAKEHOLDER ASSESSMENT QUESTIONS */

.header-design {
	display: flex;
	justify-content: space-between;
	align-items: top;
}

.group-header {
	font-weight: 600;
	font-size: 12px;
	text-align: left;
	background-color: #f8f9fa;

}

.group-table-header tr th {
	text-align: left;
}

.group-table-header tr th:nth-child(1) {
	text-align: center;
}

.group-table-row {
	font-size: 14px;
}

.group-datatable {
	min-width: 100%;
	border-collapse: collapse;
}

.group-table-row td,
.group-table-header tr th {
	width: 100%;
	border: 1px solid #f8f9fa;
	padding: 8px;
	/* background-color: red; */
}

.group-table-row td:nth-child(1),
.group-table-header tr th:nth-child(1), .usagelog .group-table-header tr:nth-child(1) th:nth-child(1) {
	text-align: center;
}

.kpi-output .group-table-row td:nth-child(1),
.kpi-output .group-table-header tr th:nth-child(1), .activity .group-table-row td:nth-child(1), .activity .group-table-header tr th:nth-child(1), .usagelog .group-table-row td:nth-child(1) {
	text-align: left !important;
}

.group-table-row td:nth-child(1),
.group-table-row th:nth-child(1) {
	width: 50px;
}

.group-table-row th:nth-child(2),
.group-table-row td:nth-child(2) {
	width: 100%;
	min-width: 100%;
}

.checkbox-header {
	width: 5% !important;

}

.checkbox {
	margin: auto;
}

.group-table-row i {
	font-size: 14px;
}

.group-table-search {
	display: flex;
	justify-content: right;
	align-items: center;
	width: max-content;
}

.group-table-buttons {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: 20px auto 10px auto;
}


.upload-button {
	width: 35px;
	height: 35px;
	background-color: #2A9235;
}


.search-input {

	height: 35px;
	width: 300px;
	padding: 10px 40px;
	outline: none;

}

.p-inputtext:enabled:focus {
	box-shadow: inset 0 0 0 1px #2A9235, inset 0 0 0 1px #2A9235, inset 0 0 0 1px #2A9235, inset 0 0 0 1px #2A9235 !important;
	border-color: #2A9235 !important;
}

.p-input-icon-left i {
	margin-left: 13px;
	font-size: 12px;
	padding-top: 1px;
}

.group-table-search i {
	margin-right: 20px;
}

.group-table-text-section {
	font-size: 10px;
}

.group-table-component {
	margin-top: 20px;
}

.group-table-component h2 {
	margin: 0;
	padding: 0;
	color: #2A9235;
}

.group-table-data {

	overflow-x: auto;
	height: 60vh;
	position: relative;
}

.group-table-data::-webkit-scrollbar {
	width: 0;
}

.group-field-display {
	display: flex;
	flex-wrap: wrap;

}

.input-group {
	display: flex;
	flex-direction: column;
	margin-top: 1px;
	width: 30%;
	margin: 20px auto;

}

.group-button-handle div {

	text-align: left;

}

.input-group label {
	width: 100%;
	font-size: 14px;
	margin: 10px auto;
}

/* .group-field-handle {
	height: 28px;
	padding: 1px;
	width: 250px;
} */

/* .dropdown-field-handle {
	height: 35px;
	margin: 0px;
	width: 215px;
} */

.group-option-field {
	width: 100%;
	background: #2A9235 !important;
	font-weight: 600;
	margin-top: 30px !important;
	color: white;
}

.group-option-field p {
	margin: 8px;
}

.group-popup-button {
	justify-content: flex-end !important;
}

.group-popup-button div {
	margin: 2px;
}

.no-data-found {
	color: red;
}

.group-table-row tr:last-child td {
	border-bottom: none;
}

.group-table-row {
	width: calc(100% - 17px);
	/* Adjust for scrollbar width */
}

/* app.css */

.p-field-container {
	display: flex;
	align-items: center;
}

.p-label {
	width: 230px;
	padding-top: 7px;
	font-size: 12px;
}

.p-inputgroup-container {
	display: flex;
	align-items: center;
}

.p-field-switch-container {
	display: flex;
	align-items: center;
	margin-right: 10px;
}

.p-field-switch-text {
	font-size: 12px;
}

.p-field-switch-text-left {
	margin-left: 7px;
}

.p-field-switch-text-right {
	margin-right: 7px;
}

/* app.css */

.group-table-component h2 {
	margin: 0;
}

.flex-container {
	display: flex;
	flex-direction: row;
	align-items: center;
}

.summary-dropdown {
	margin-top: 10px;
	margin-right: 20px;
}

.summary-dropdown label {
	font-weight: 400;
}

.summary-dropdown .dropdown-container {
	margin-top: -6px;

}

.last-summary-dropdown {
	margin-right: 0;
}

.app-container {
	display: flex;
	flex-direction: row;
	align-items: center;
	width: 100%;
}

.flex-1 {
	flex: 1 1;
}

.width-100 {
	width: 100%;
	box-sizing: border-box;
}

.width-50 {
	width: 50%;
}

.width-50vw {
	width: 50vw;
}



/* app.css */

.p-field-container {
	display: flex;
	align-items: center;
}

.p-label-container {
	width: 280px;
	padding-top: 7px;
}

.p-label {
	font-size: 12px;
}

/* app.css */

.p-field-container {
	display: flex;
	align-items: center;
}

.p-label-container {
	width: 280px;
	padding-top: 7px;
}

.p-label {
	font-size: 12px;
}

/* app.css */

.p-field-container {
	display: flex;
	align-items: center;
}

.p-label-container {
	width: 230px;
	padding-top: 7px;
}

.p-label {
	font-size: 12px;
}

.p-inputgroup-container {
	display: flex;
	align-items: center;
}

.p-field-switch-container {
	display: flex;
	align-items: center;
	margin-right: 10px;
}

.p-field-switch-text {
	font-size: 12px;
}

.p-field-switch-text-left {
	margin-left: 7px;
}

.p-field-switch-text-right {
	margin-right: 7px;
}

.custom-dropdown {
	font-size: 12px !important;
	/* Use !important to override other styles */
}

.custom-multiselect {
	font-size: 12px;
	color: #4B5563;
	/* Set font color */
	border-color: #e7e6e6;
	width: 100%;
	border-radius: 5px;
	/* Set border color */
	padding-left: 0px !important;
}

.custom-multiselect .p-multiselect {
	border-color: rgba(74, 74, 74, 0.5);

	/* Ensure the border color of the multiselect is light gray */
}

.custom-multiselect .p-multiselect-label {
	color: #4B5563;

	/* Set the font color of the selected labels */
}

.custom-multiselect .p-multiselect-trigger {
	font-size: 12px;

	/* Decrease the dropdown icon size */
}

.custom-multiselect .p-multiselect-filter-container .p-inputtext {
	color: rgba(74, 74, 74, 0.5);
	/* Set font color of the filter input */
	border-color: #e7e6e6;

	/* Set border color of the filter input */
}

.custom-calendar {
	font-size: 12px !important;
	color: rgba(74, 74, 74, 0.5) !important;
}

.p-calendar .p-inputtext {
	color: #4B5563;
	font-size: 12px;
}

.risks-tab .p-inputtext.p-component {
	margin-top: 0px !important;
	width: 150px;
	font-size: 12px;
}

.risks-tab .p-calendar .p-inputtext {
	color: #4B5563;
	font-size: 12px;
}

.p-icon {
	width: 0.6rem;
	height: 0.6rem;
	color: rgba(74, 74, 74, 0.5);
}

.p-row-editor-init .p-icon, .p-row-editor-save .p-icon, .p-row-editor-cancel .p-icon {
	width: 13px;
    height: 13px;
    color: #495057;
}

.summary-input-text label,
.summary-dropdown label {
	width: 25%;
	margin-right: 10px;

}

.summary-input-text input,
.summary-dropdown input,
.summary-input-text .input-element,
.summary-dropdown .input-element,
.summary-input-text .multi-select-element,
.summary-dropdown .multi-select-element,
.summary-input-text .single-select-element,
.summary-dropdown .single-select-element {
	width: 75%;
}

.summary-input-text,
.summary-dropdown {
	display: flex;
	align-items: space-between;
	/* background-color: red; */
	width: 100%;
}

.selecting-dropdown {
	width: 100%;
	height: 30px;
}

.display-row {
	display: flex;
	flex-direction: row;
	align-items: center;
	margin-top: 10px;
}

.font-bold {
	font-weight: 600 !important;
}

.font-600 {
	font-weight: 600 !important;
}

.display-end {
	display: flex;
	justify-content: flex-end;
	margin-top: 20px;
}

.display-center {
	display: flex;
	justify-content: center;
	align-items: center;
}

.w-130 {
	width: 130px;
	padding-top: 7;
}

.w-230 {
	width: 230px;
	padding-top: 7;
}

.w-280 {
	width: 280px;
	padding-top: 7;
}

.fs-12 {
	font-size: 12px !important;
}

.portfolio-menu-scrollable {
	width: 30%;
	overflow-y: auto;
	overflow-x: hidden;
	max-height: 100vh;
	/* Adjust as needed */
	margin-left: -20px;
}

.portfolio-menu-content-scrollable {
	width: 70%;
	overflow-y: hidden;
	overflow-x: hidden;
	max-height: 100vh;
	/* Adjust as needed */
}

.portfolio-menu-scrollable::-webkit-scrollbar,
.portfolio-menu-content-scrollable::-webkit-scrollbar {
	width: 0;
	height: 0;
}

/* Hide scrollbar for other browsers */
.portfolio-menu-scrollable,
.portfolio-menu-content-scrollable {
	-ms-overflow-style: none;
	/* IE and Edge */
	scrollbar-width: none;
	/* Firefox */
}

.pb-100 {
	padding-bottom: 100px;
}

.max-height {
	max-height: 100%;
	margin-bottom: -100px;
}

.w-200 {
	width: 200px;
}

.w-190 {
	width: 190px;
	border-color: 'white' !important;
}

.logoSize {
	width: 150px;
	height: 50px;
}

.h-44 {
	height: 44px;
	margin-left: 10x;
}

.p-relative {
	position: relative;
}

.b-white {
	border: white;
}

.s-field {
	background-color: white;
	border: 1px solid #ccc;
	padding: 10px;
	display: flex;
	flex-direction: row;
	position: absolute;
	z-index: 1000;
	height: 'auto';
	margin-top: 5px;
	width: 500px;
	right: 1px;
	border-radius: 4px;
}

.fontWeigth-600 {
	font-weight: 600;
}

.mt-3 {
	margin-top: 3px;
}

.ml-10 {
	margin-left: 10px;
}

.dilog-box {
	font-size: 1.5rem;
	padding-top: 4px;
	margin-right: 5px;
}

.color-red {
	color: red;
}

.color-green {
	color: green;
}

.width-35 {
	width: 35%;
}

.p-field-container {
	display: flex;
	align-items: center;
}

.p-label-container {
	width: 280px;
	padding-top: 7px;
}

.p-label {
	width: 230px;
	padding-top: 7px;
	font-size: 12px;
}

.p-inputgroup-container {
	display: flex;
	align-items: center;
}

.p-field-switch-container {
	display: flex;
	align-items: center;
	margin-right: 10px;
}

.p-field-switch-text {
	font-size: 12px;
}

.p-field-switch-text-left {
	margin-left: 7px;
}

.p-field-switch-text-right {
	margin-right: 7px;
}

.flex-container {
	display: flex;
	flex-direction: row;
	align-items: center;
}

.summary-dropdown {
	margin-top: 10px;
	margin-right: 20px;
}

.summary-dropdown label {
	font-weight: 600;
}

.summary-dropdown .dropdown-container {
	margin-top: 5px;
}

.last-summary-dropdown {
	margin-right: 0;
}

.app-container {
	display: flex;
	flex-direction: row;
	align-items: center;
	width: 100%;
}

.flex-1 {
	flex: 1 1;
}

.height-50 {
	height: 50px !important;
}

.width-100 {
	width: 100%;
	box-sizing: border-box;
}

.width-50 {
	width: 50%;
}

.summary-input-text {
	display: flex;

	margin-top: 20px;
}

#score>span>input {
	height: 35px !important;
}

#score>span {
	/* height: 29px !important; */
	align-items: center;
}

#score>span>span {
	/* margin-top: -6px; */
	height: 35px;
}

.group-table-row tr:last-child td {
	border: 0.5px solid #f8f9fa;
}

.p-inputnumber-input {
	font-size: 12px
}

/*  This*/

.custom-dropdown {

	font-size: 12px !important;

	/* Use !important to override other styles */

}

.custom-multiselect {

	font-size: 12px;

	color: rgba(74, 74, 74, 0.5);

	/* Set font color */

	border-color: #e7e6e6;

	/* Set border color */

}



.custom-multiselect .p-multiselect {

	border-color: rgba(74, 74, 74, 0.5);

	/* Ensure the border color of the multiselect is light gray */

}

.custom-multiselect .p-multiselect-trigger {

	font-size: 12px;

	/* Decrease the dropdown icon size */

}



.custom-multiselect .p-multiselect-filter-container .p-inputtext {

	color: rgba(74, 74, 74, 0.5);

	/* Set font color of the filter input */

	border-color: #e7e6e6;

	/* Set border color of the filter input */

}



.custom-calendar {

	font-size: 12px !important;

	color: rgba(74, 74, 74, 0.5) !important;

}

.summary-input-text label,

.summary-dropdown label {

	width: 25%;

	margin-right: 10px;

}

.summary-input-text input,

.summary-dropdown input,

.summary-input-text .input-element,

.summary-dropdown .input-element,

.summary-input-text .multi-select-element,

.summary-dropdown .multi-select-element,

.summary-input-text .single-select-element,

.summary-dropdown .single-select-element {

	width: 75%;

}



.summary-input-text,

.summary-dropdown {

	display: flex;

	align-items: center;

}

.p-inputtext {
	margin-top: 0px !important;
	width: 100%;
	font-size: 12px;
}

.p-dialog-header-icons>button>svg {
	height: 1.4rem;
	width: 1.4rem;
	color: #6B7280;
}

.p-disabled,
.p-component:disabled {
	/* opacity: 0.5; */
}

.p-accordion .p-accordion-tab .p-accordion-header.p-disabled .p-accordion-header-link>* {
	opacity: 1;
}

/* LOGIN PAGE CSS  */
.login-Component {
	display: flex;
	width: 100%;
	justify-content: center;
	align-items: center;
	height: 95.5vh;
	background-repeat: no-repeat;
	background-size: 100vw 100vh;
}

.login-container {
	position: relative;
	width: 30%;
	height: 60%;
	display: flex;
	align-items: center;
	justify-content: center;
	/* box-shadow: -7px 0px 1px 1px rgba(0, 0, 0, 0.193); */
	border-top-left-radius: 10px;
	border-bottom-left-radius: 10px;
	border: 1px solid #2A9235;
	/* box-shadow: 0 0px 10px 1px rgba(251, 250, 250, 0.278) */
	/* background-color: blue; */

}

.login-Image {
	margin: 1rem;
	text-align: center;
}

.side-image {
	width: 30%;
	height: 60%;
	/* box-shadow: 0 0px 1px 0px rgba(0, 0, 0, 0.5); */
	/* box-shadow: 7px 0px 1px 1px rgba(0, 0, 0, 0.193); */
	background-color: rgb(192, 252, 192);
	background-color: #2A9235;
	border-top-right-radius: 10px;
	border-bottom-right-radius: 10px;
	display: flex;
	justify-content: center;
	align-items: center;
	/* box-shadow: 0 0px 10px 1px rgba(0, 0, 0, 0.193) */

	/* background-color: blue; */
}

.login-page {
	display: flex;
	width: 70%;
	flex-direction: column;
	justify-content: center;
	align-items: left;
	height: max-content;



}

.input-style {
	width: 100%;
	height: 100%;
	border: none;
	font-size: 16px;
	background: none;
	margin: 0 !important;
	padding: 8px;

}

.input-design i {
	margin: auto;
	font-size: 16px;
	opacity: 7px;
}

.input-style:hover {
	border: none !important;
	outline: none !important;
}

.input-design {
	display: flex;
	align-items: center;
	padding: 8px;
	justify-content: space-between;
	background-color: #f3f8f1;

}

.design-container {
	position: absolute;
}

.triangle {
	width: 0;
	height: 0;
	border-left: 50px solid transparent;
	border-right: 50px solid transparent;
	border-bottom: 100px solid #f3f8f1;
	position: relative;
	right: -352px;
	bottom: -198px;
	opacity: 0.2;
	transform: rotate(110deg);
}

.circle {
	width: 100px;
	height: 100px;
	background-color: #f3f8f1;
	border-radius: 50%;
	position: relative;
	right: -410px;
	bottom: 100px;
	opacity: 0.2;
}

.square {
	background-color: #f3f8f1;
	position: relative;
	right: -273px;
	bottom: 258px;
	opacity: 0.2;
	width: 50px;
	height: 50px;
	transform: rotate(580deg);
}

.rectangle {
	position: relative;
	width: 50px;
	height: 25px;
	background-color: #f3f8f1;
	opacity: 0.2;
}




.input-style:enabled:focus {
	box-shadow: none !important;
	border: none !important;

}

.login-content {
	margin: 0 0 3rem 0;
}

.login-content p {
	margin: 2px;
}

.login-content h2 {
	margin: 0;
	color: #2A9235;
}

.login-image {
	width: 70%;
	/* mix-blend-mode: multiply; */
	margin: auto;
	text-align: center;
	margin-bottom: 1rem;
	/* background-color: red; */


}

.submit-button {
	margin-top: 1rem;
	margin-bottom: 0.5rem;
	background-color: #2A9235;
	outline: none;
	border: none;
	cursor: pointer;
}

.forget-password {
	margin: 0;
	margin-bottom: 1.5rem;
	text-align: center;
	margin-top: 2rem;
}

.loader-div {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: rgba(255, 255, 255, 0.648);
	z-index: 1105;
}

.p-dialog-mask {
	z-index: 1001;
}

.progress-spinner {
	width: 50px;
	height: 50px;
}

.loader-img {
	width: 50px;
	mix-blend-mode: multiply;
}

.footer {
	height: max-content;
	margin: 0;
	padding: 0;
}

.footer-content {
	height: max-content;
	display: flex;
	justify-content: space-between;
	align-items: end;
	padding: 0 1rem;
	font-size: 14px;
}

.side-content {
	color: white;
	text-align: center;
}

.side-content h2 {
	color: white;
	margin: 1rem 0;
	font-size: 40px;
}

/* FORGET PASSWORD CSS  */

.forget-text {
	font-size: 12px;
}

/* MFA CSS  */

.mfa-container {
	width: 100%;
	height: 100vh;

}

.emailConatiner {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 40%;
	height: 50%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	border-radius: 10px;
	box-shadow: 0 0px 10px 1px rgba(0, 0, 0, 0.193);

}

.emailConatiner h2 {
	color: #2A9235;
	margin-bottom: 0;

}

.lock-icon {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 60px;
	height: 60px;
	text-align: center;
	font-size: 25px;
	color: white;
	background-color: #2A9235;
	border-radius: 50%;
	padding: 30px;
}

.emailConatiner p {
	margin-top: 0;
}

.verify-button {
	background-color: #2A9235;
	outline: none;
	border: none;
	margin-top: 1rem;
}

.sent-otp-button {
	background-color: #2A9235;
	outline: none;
	border: none;
}

.resend-otp-button {
	background-color: #2A9235;
	outline: none;
	border: none;
}

.verify-input {
	margin: 1rem auto;
	width: 40%;
	height: 25%;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: center;

}

.verify-input-field {
	outline: none;
	margin: 0;
	margin-top: 0px !important;
}

.p-inputtext:hover,
.p-inputnumber-input:hover {
	border: 1px solid #4B5563;
}

.p-dropdown-label.p-inputtext:hover {
	border: none !important;
}

/* RESET PASSWORD CSS */

.password-text {
	font-size: 12px;
}

.reset-pasword-button {
	margin-top: 1rem;
	background-color: #2A9235;
}

.p-button {
	border: none;
}

/* SECURITY POLICIES */

.mm {
	height: 500px;
	line-height: 500px;
	text-align: center;
}

span {
	display: inline-block;
	vertical-align: middle;
	line-height: normal;
}

.readType {
	font-size: 15px !important;
	border: 0px !important
}

.row {
	margin-right: 0px !important;
	margin-left: 0px !important;
	margin-top: 2%;
}

.section-heading {
	text-align: center;
	color: #1E12B9;
	font-weight: 400;
	font-size: 25px;
}

.section-header {
	color: #1E12B9;
}

.logo-image img {
	width: 150px;
}

.container-fluid {
	margin-top: 2%;
	margin: auto 10%;
}

.table {
	font-family: Arial, Helvetica, sans-serif;
	border-collapse: collapse;
	width: 100%;
}

.table td,
.table th {
	border: 1px solid #ddd;
	padding: 8px;
}


/* PROMPTS CSS  */
.popup-save-button {
	background-color: #2A9235;
}

.p-datatable-wrapper {
	max-height: none !important;
	/* height: 65vh !important; */
}

/* DATA TABLE CSS  */
.p-column-header-content {
	color: #2A9235;
	font-weight: 500 !important;
}

.test:hover {
	color: blue;
	text-decoration: underline;
	cursor: pointer;
}

/* Change the background color of the checkbox */
.p-checkbox-box .p-checkbox-icon {
	background-color: #19486B !important;
	color: white;
}

/* Change the border color of the checkbox */
.p-checkbox-box {
	border: 0.5px solid #D1D5DB !important;
	width: 15px !important;
	height: 15px !important;
	margin-top: 1px;
}

.p-checkbox-icon {
	width: 100%;
	height: 100%;
	padding: 2px;
}


/* RESPONSIVE UI  */

@media only screen and (max-width: 600px) {

	/* LOGIN PAGE CSS  */

	.login-container {
		width: 100%;
		border: none;
		border-top-right-radius: 10px;
		border-bottom-right-radius: 10px;
	}

	.side-image {
		display: none;
	}

	.emailConatiner {
		width: 100%;
		box-shadow: none;
	}


}

@media only screen and (min-device-width: 601px) and (max-device-width: 1200px) and (-webkit-min-device-pixel-ratio: 1) {

	.login-container {
		width: 60%;
		border-top-right-radius: 10px;
		border-bottom-right-radius: 10px;
	}

	.side-image {
		display: none;
	}

	.emailConatiner {
		width: 100%;
		box-shadow: none;
	}
}


/* Tab view */
.p-menuitem-link {
	/* border-color:#19486B; */
	color: #19486B;
	text-decoration: none !important;
	white-space: nowrap;
}

.p-tabmenu-ink-bar {
	background-color: #19486B;
}

.p-tabmenu .p-tabmenu-nav .p-tabmenuitem.p-highlight .p-menuitem-link {
	border-color: #19486B;
	color: #19486B
}




.search-wrapper {
	position: relative;
	width: 100%;
	max-width: 400px;
}

.search-input {
	padding-left: 2.5rem;
	/* Adjust this value based on icon size */
	padding-right: 2.5rem;
	/* Adjust this value based on button size */
	width: 100%;
}

.p-input-icon-left {
	display: flex;
	align-items: center;
	position: relative;
}

.p-input-icon-left>.pi-search {
	position: absolute;
	left: 0.75rem;
	/* Adjust this value for desired left padding */
	top: 50%;
	transform: translateY(-50%);
	pointer-events: none;
}

.p-input-icon-right {
	display: flex;
	align-items: center;
	position: relative;
}

.cancel-button {
	position: absolute;
	right: 0.75rem;
	top: 50%;
	transform: translateY(-50%);
	border: none;
	background: transparent;
	color: var(--text-color-secondary);
}

.cancel-button:focus {
	outline: none;
	/* Remove outline on focus */
	box-shadow: none;
	/* Remove any box-shadow */
}

/* Sidebar & Header */

.sidebar {
	background: #FAFAFA;
	/* border-radius: 4px !important; */
	/* border: none !important; */
	border-right: 0.5px solid rgba(0, 0, 0, 0.1);
	height: 100vh;
	overflow: hidden;
}

.sidebarMenu {
	height: 84vh;
	overflow-y: auto;
	/* border-right: 0.5px solid rgba(0, 0, 0, 0.1); */
}

.border-sidebar {
	/* border-right: 0.5px solid rgba(0, 0, 0, 0.1); */
	position: fixed;
    bottom: 0;
    left: 0;
    padding: 15px 0px 15px 28px;
    width: 12.5%;
	z-index: 1;
    background: #FAFAFA;
	border-top: 0.5px solid rgba(0, 0, 0, 0.1);
}

.sidebar a {
	text-decoration: none;
}

.sidebarMenu ol,
ul {
	padding-left: 0px !important;
}

.sidebarMenuClosed {
	height: 84vh;
	/* border-right: 0.5px solid rgba(0, 0, 0, 0.1); */
}

.d-flex {
	display: flex !important;
}

.justify-between {
	justify-content: space-between;
}

.font-normal {
	font-weight: normal;
}

.font-white {
	color: #4B5563;
}

.fs-14 {
	font-size: 14px;
}

.mar-b-4 {
	margin-bottom: 4px !important;
}

.ml-10 {
	margin-left: 10px !important;
}

.ml-14 {
	margin-left: 14px !important;
}

.m-0 {
	margin: 0px !important;
}

.pointer {
	cursor: pointer;
}

@media only screen and (min-width: 769px) {

	.menu-icon,
	.close-sidebar {
		display: none;
	}

	.content {
		/* padding: 15px; */
		margin-left: 240px;
		height: 100vh;
		overflow: hidden auto;
	}

	.contentClosed {
		margin-left: 62px;
		height: 100vh;
		overflow: hidden auto;
	}

	.header-content {
		background-color: #FAFAFA;
		border-bottom: 0.5px solid rgba(0, 0, 0, 0.1);
		position: sticky;
        top: 0;
		z-index: 2;
	}

	.outlet-content {
		padding: 0px 15px 15px 15px;
		overflow-y: auto;
        height: 100%;
	}

	.sidebar {
		width: 240px;
		float: left;
	}

	.sidebar.sidebarClosed {
		width: 62px;
        border-right: 0.5px solid rgba(0, 0, 0, 0.1);
	}

	.sidebar .sidenavClosed {
		width: 62px;
        border-right: 0.5px solid rgba(0, 0, 0, 0.1);
	}

	.p-dialog {
		width: 40% !important;
	}

	.resource-planner .p-dialog {
		width: 60% !important;
		height: 60% !important;
	}

	#surveyDialogView {
		width: 80% !important;
	}

	#travelApproval {
		width: 50% !important;
	}

	#visaApproval {
		width: 53% !important;
	}
}

@media only screen and (max-width: 768px) {
	.sidebar {
		display: none;
		position: absolute;
		z-index: 2;
		width: 186px;
		border-right: 0.5px solid rgba(0, 0, 0, 0.1);
	}

	.menu-icon {
		display: block;
	}

	.show {
		display: block !important;
	}

	.hide {
		display: none !important;
	}

	.hideMenuIcon {
		visibility: hidden !important;
	}

	.close-sidebar {
		position: fixed;
		top: 20px;
		left: 150px;
	}

	.close-sidebar .navIcon {
		color: #4B5563;
	}

	.navIcon {
		font-size: 24px;
		color: #000000;
	}

	.p-breadcrumb {
		padding: 0px !important;
	}

	.content {
		width: 100%;
		padding: 22px;
	}

	.outlet-content {
		padding: 0px 15px 15px 15px;
	}

	.p-input-icon-left>.p-inputtext {
		width: 50% !important;
	}

	.orderlist-demo .p-input-icon-left>.p-inputtext {
		width: 100% !important
	}

	.p-dialog {
		width: 70% !important;
	}
}

.p-icon.p-submenu-icon {
	position: absolute !important;
	color: #4B5563;
	right: -3px !important;
	font-size: 7px;
}

.p-panelmenu-content {
	border: none;
	margin-left: 15px;
	background-color: #FAFAFA;
}

.header-label {
	color: #2A9235;
	font-weight: 600;
	font-size: 20px;
}

.header-class .p-input-icon-left i {
	margin-left: 0px !important;
}

.header-class {
	background-color: #FAFAFA;
}

.top-add-button {
	height: 34px;
	/* margin-top: -1px; */
	background-color: #243137;
	border-radius: 4px;
}

.top-add-button .p-button-icon {
	font-size: 13px;
}

.search-bar {
	color: #4B5563;
	font-size: 13px;
	width: 100%;
}

.sidebarMenu a:hover,
.sidebarMenuClosed a:hover {
	color: transparent;
}

.p-menuitem.p-focus .p-menuitem-link,
.sidebarMenu .p-panelmenu-header:active, .active-menu-item .p-menuitem-link {
	/* background-color: #5EBD6826 !important; */
	color: #4A4A4A !important;
	text-decoration: none;
}

.active-menu-item .p-panelmenu-header-content, .p-submenu-list .active-menu-item .submenu-link, .p-menu .p-menuitem:not(.p-highlight):not(.p-disabled) > .p-menuitem-content:hover {
	background-color: #5EBD6826 !important;
	border-left: 3px solid #5EBD68;
	height: max-content;
}

.p-menubar .p-menubar-root-list > .p-menuitem:not(.p-highlight):not(.p-disabled) > .p-menuitem-content:hover, .p-menubar .p-menuitem:not(.p-highlight):not(.p-disabled).p-focus > .p-menuitem-content, .p-panelmenu .p-panelmenu-content .p-menuitem:not(.p-highlight):not(.p-disabled).p-focus > .p-menuitem-content, .p-panelmenu .p-panelmenu-content .p-menuitem:not(.p-highlight):not(.p-disabled) > .p-menuitem-content:hover {
	background: none !important;
}

.p-menu {
	padding: 0px;
	background: transparent;
    color: transparent;
    border: none;
    border-radius: 0px;
	cursor: pointer;
}

.active-menu-item .p-menuitem-text, .active-menu-item .p-menuitem-icon, .active-menu-item .p-menuitem.p-focus .p-menuitem-icon,
.active-menu-item .p-menuitem.p-focus .p-menuitem-text {
	color: #4A4A4A !important;
	text-decoration: none;
}

.p-menuitem.p-focus .p-menuitem-icon,
.p-menuitem.p-focus .p-menuitem-text {
	/* color: #FFFFFF !important; */
}



::-webkit-scrollbar {
	width: 5px;
	height: 5px;
}

::-webkit-scrollbar-track {
	-webkit-box-shadow: inset 0 0 6px rgba(156, 26, 26, 0.1);
	border-radius: 10px;
}

::-webkit-scrollbar-thumb {
	border-radius: 10px;
	-webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
}

.sidebar-footer {
	margin-left: 0px !important;
	margin-right: 18px !important;
}

.sidebar-footer:before {
	content: "";
	top: 100%;
	width: 100%;
	height: .5px;
	background: linear-gradient(43deg, rgba(255, 255, 255, 0) 2%, rgba(255, 255, 255, 0.7) 50%, rgba(255, 255, 255, 0) 99%);
	margin-top: -10px;
	display: block;
}

.sidenav {
	transition: width 0.3s ease-in-out;
	height: 100vh;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	/* border-right: 0.5px solid rgba(0, 0, 0, 0.1); */
}

.sidenavClosed {
	transition: width 0.3s ease-in-out;
	width: 60px
}

.form-label {
	font-size: 14px;
	color: #4B5563 !important;
}

.form-label-text {
	font-size: 13px;
	color: #0467ae !important;
}

.p-inputwrapper:hover {
	border: 1px solid green;
}

.p-inputwrapper:focus {
	border: 1px solid green;
}

.p-inputwrapper:active {
	border: 1px solid green;
}

.p-dropdown:not(.p-disabled).p-focus {
	box-shadow: unset !important;
	border: 1px solid green;
}

.radio-buttons-row {
	display: flex;
	align-items: center;
}

.field-radiobutton {
	display: flex;
	align-items: center;
	margin-right: 1rem;
}

.field-checkbox,
.field-radiobutton {
	margin-bottom: 0px !important;
}

.field-radiobutton label {
	margin-left: 0.5rem;
	padding-top: 5px;
}

.pi-plus::before {
	font-size: 12px;
}

.p-inputnumber-button-down {
	width: 15px;
}

.p-inputnumber-button-up {
	align-items: center;
	margin-top: 7px;
	width: 15px;
}

.p-dialog-header-icons>button>svg {
	height: 16px;
	width: 16px;
}

.p-dialog .p-dialog-header .p-dialog-title {
	font-size: 18px !important;
	color: #0467AE;
}

.timesheet-buttons .p-inputtext {
	padding: 6px 9px;
}

.timesheet-buttons .p-button {
	border-radius: 3px;
	padding: 8px 8px;
}

.p-button:focus {
	box-shadow: unset;
}

.p-button:focus {
	outline: #19486B;
}

.button:focus {
	outline: 5px auto #19486B;
}

.p-dialog .p-dialog-header-icons {
	border: unset !important;
	box-sizing: unset !important
}

/* Dialog */

.p-dialog-header {
	padding: 14px 14px 10px 14px;
}

.p-dialog-content {
	padding: 10px 14px 14px 14px;
}

.new-field .p-inputtext {
	border-color: #E5E7EB;
	height: 30px;
	border-radius: 2px;
}

.new-field .p-dropdown {
	border-color: #E5E7EB;
	border-radius: 2px;
}

.new-field .p-dropdown-label.p-inputtext {
	height: max-content !important;
}

.new-field .p-inputtext.error-tab, .p-dropdown.error-tab, .p-inputtext.error-tab {
	border-color: red !important;
}

.new-field .p-inputtextarea {
	border-color: #E5E7EB;
	height: 56px;
	border-radius: 2px;
}

.button-portfolio {
	border: 1px solid #B2B2B2 !important;
	margin-left: 20px;
}

.new-field .p-inputnumber-button-group {
	display: none;
}

.radio-buttons-row {
	font-size: 12px;
}

.label-text {
	font-weight: 500;
	font-size: 18px;
	color: #374151;
}

.sub-label-text {
	font-weight: 500;
	font-size: 18px;
	color: #218a31;
}

.new-option-button {
	height: 35px;
	width: 127px;
	padding: 11px;
	font-size: 12px;
	background-color: unset;
	color: rgb(25, 72, 107);
	border: 1px solid #19486B;
	border-radius: 4px;
}

.new-option-button .p-button-icon {
	color: #19486B;
	font-weight: 500;
	margin-right: 7px;
	margin-bottom: 2.5px;
}

.new-option-button .p-button-label {
	color: #19486B;
	font-size: 14px;
	font-weight: 500;
}

.edit-option-button {
	height: 35px;
	width: 38px;
	padding: 11px;
	font-size: 12px;
	background-color: unset;
	color: rgb(25, 72, 107);
	border: 1px solid #19486B;
	border-radius: 4px;
}

.edit-option-button .p-button-icon {
	color: #19486B !important;
	font-weight: 500;
	margin-bottom: 1.5px;
	font-size: 14px;
}

.edit-option-button .p-button-label {
	color: #19486B;
	font-size: 14px;
	font-weight: 500;
}

.group-table-component .p-button-label {
	color: #FFFFFF;
	font-weight: 500;
	font-size: 14px;
}

.group-table-component .new-button .p-button-label {
	color: #FFFFFF;
	font-weight: 500;
	font-size: 14px;
	margin-left: 5px;
}

.group-table-component .p-button-icon {
	font-size: 13px;
	color: #FFFFFF;
}

.new-field .header-datatable,
.new-field .p-editable-column,
.group-table-component .header-datatable,
.group-table-component .p-editable-column {
	text-align: left !important;
	/* width: 14em; */
	padding: 8px 10px !important;
	font-size: 14px;
}

.group-table-component .row-datatable,
.new-field .row-datatable {
	text-align: left;
	/* width: 14em; */
	padding: 8px 10px !important;
	font-size: 12px;
	cursor: pointer;
}

.group-table-component .p-input-icon-left i {
	margin-left: 16px !important;
}

.new-field .p-column-header-content {
	font-size: 14px;
	font-weight: 400;
}

.new-field .p-datatable-tbody .p-inputtext {
	font-size: 12px;
	padding-left: 10px;
	color: #4B5563;
	height: 33px;
}

.cancel-new-button {
	background-color: #fff;
	border: 1px solid #19486B;
	border-radius: 4px;
	height: 40px;
	color: #19486B;
	font-size: 13px;
}

.save-button {
	background-color: #19486B;
    border: 1px solid #19486B;
    border-radius: 4px;
    height: 40px;
    margin-left: 20px;
}

.add-button-portfolio {
	background-color: #19486B;
	border: 1px solid #19486B;
	border-radius: 4px;
	height: 31px;
	margin-left: 18px;
}

.add-button-summary {
	background-color: #19486B;
	border: 1px solid #19486B;
	border-radius: 4px;
	height: 31px;
	margin-left: 8px;
	padding: 8px !important;
}

.save-button-add {
	background-color: #19486B;
    border: 1px solid #19486B;
    border-radius: 4px;
    height: 33px;
    margin-left: 20px;
}

.p-button-label {
	font-size: 14px;
}

.cancel-footer .cancel-new-button .p-button-label {
	color: #19486B;
	font-size: 14px;
	font-weight: 500;
}

.delete-icon .cancel-new-button .p-button-icon,
.approve-button.p-button .p-button-label {
	color: #19486B;
	font-size: 14px;
	font-weight: 500;
}

.approve-button {
	background-color: #FFFFFF;
	border: 1px solid #19486B;
	border-radius: 4px;
	height: 30px;
}

.cancel-footer .save-button .p-button-label {
	color: #FFFFFF;
	font-size: 14px;
	font-weight: 500;
}

.cancel-footer .save-button.p-disabled .p-button-label {
	color: #19486B;
	font-size: 14px;
	font-weight: 500;
}

.p-radiobutton.p-highlight .p-radiobutton-box {
	border-color: #19486B;
	background: #19486B;
}

.p-radiobutton .p-radiobutton-input:hover {
	border-color: #19486B;
}

.new-field .md\\:w-14rem {
	width: 10.3rem !important;
}

.pi-check-circle {
	color: #2A9235 !important;
	font-size: 13px !important;
}

/* Toaster CSS */

.p-toast .p-toast-message {
	background: #fff !important;
	height: 46px;
	border: none;
}

.p-toast-summary {
	color: #304563;
	line-height: 24px;
}

.p-toast-detail {
	font-style: normal;
	font-weight: normal;
	font-size: 14px;
	line-height: 21px;
	color: #304563;
	margin: 0 !important;
}

.p-toast-message-content {
	align-items: center !important;
	height: 20px;
	padding: 6px;
}

.p-toast-message-text {
	margin-left: 22px !important;
}

.p-toast-message-content:before {
	position: absolute;
	width: 4px;
	height: 38px;
	content: "\\2223";
	left: 6px;
	border-radius: 6px;
	top: 4px;
	color: #7CCAAE;
	background: #7CCAAE;
}

.p-toast-message-success .p-toast-message-content:before {
	color: #7CCAAE;
	background: #7CCAAE;
}

.p-toast-message-error .p-toast-message-content:before {
	color: red;
	background: red;
}

.p-toast-message-icon {
	padding-left: 8px;
	color: #fff !important;
}

.p-toast-message-icon::before {
	width: 24px;
	height: 24px;
	display: block;
	border-radius: 50%;
	text-align: center;
	font-size: 14px;
	line-height: 1.5;
}

.p-toast-message-success .p-toast-message-icon::before {
	content: "\\2714";
	background: #7CCAAE;
}

.p-toast-message-error .p-toast-message-icon::before {
	content: "\\2715";
	background: red;
}

.p-toast-icon-close-icon {
	color: #304563;
	font-size: 16px !important;
}

.p-toast-icon-close {
	margin-top: 26px;
}

/* Tab View */

.vertical-tabview .p-tabview {
	display: flex;
	flex-direction: row;
}

.vertical-tabview .p-tabview-nav {
	flex-direction: column;
	min-width: 150px;
	/* border-right: 1px solid #ccc; */
}

.vertical-tabview .p-tabview-panels {
	flex-grow: 1;
}

.p-tabview-title {
	color: #4B5563;
	font-size: 14px;
}

.portfolio-tabs .p-tabview-title {
	color: #4A4A4A;
	font-size: 13px;
	margin-left: 11px;
	font-weight: normal;
}

.p-tabview-nav-link,
.p-tabview-nav-link:hover {
	text-decoration: none;
}

.p-tabview-selected.p-highlight a {
	color: transparent;
}

.portfolio-tabs .p-tabview-selected.p-highlight a,
.portfolio-tabs a {
	color: #19486B !important;
}

.p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link {
	border-color: #19486B !important;
}

.custom-tabview.p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link {
	border: none !important;
	background-color: #5EBD6826;
}

.custom-tabview .p-tabview-selected.p-highlight {
	border-left: 3px solid #5EBD68;
}

.custom-tabview.p-tabview .p-tabview-nav li .p-tabview-nav-link {
	border: none !important;
}

.custom-tabview.p-tabview .p-tabview-nav {
	border-bottom: none !important;
}

.custom-tabview .p-tabview-selected.p-highlight.error-tab {
	border-left: 3px solid red;
}

.custom-tabview .p-tabview-nav-link {
	padding: 12px !important;
}

.p-tabview .p-tabview-nav li.p-highlight.error-tab .p-tabview-nav-link {
	border-color: red !important;
}

.error-tab .p-menu {
	border-left: 3px solid red !important;
}

.active-menu-item .p-menu {
    border-left: 3px solid #5EBD68 !important;
}

.custom-tabview .p-tabview-nav {
	flex-direction: column;
	border-left: 1px solid #5EBD6840;
	margin-top: 20px;
}

.portfolio-tabs .p-tabview-selected.p-highlight.error-tab a, .portfolio-tabs .p-tabview-selected.p-highlight.error-tab .p-tabview-title, .portfolio-tabs .error-tab a, .portfolio-tabs .error-tab .p-tabview-title {
	color: red !important;
}

.p-tabview .p-tabview-nav .p-tabview-ink-bar {
	background-color: transparent;
}

.vertical-tabview .p-tabview-nav-container {
	border-right: 1px solid #ccc;
}

.bread-crumb {
	font-size: 14px;
	color: green;
	font-weight: 500;
	margin-bottom: 0px;
}

.b-bottom {
	border-bottom: 1px solid #4B5563;
}

.p-accordion-header.p-highlight a,
.p-accordion-header.p-highlight .p-icon,
.p-accordion-header a,
.p-accordion-header .p-icon {
	color: #243137 !important;
	text-decoration: none;
	border-bottom: 1px solid #5EBD6859 !important;
}

.custom-tabview.p-tabview .p-toggleable-content {
	margin-top: 10px;
}

.p-accordion .p-accordion-header .p-accordion-header-link,
.p-accordion-content {
	padding: 10px;
    width: 100%;
	border: none;
}

.custom-tabview .p-tabview-panels {
	padding: 10px;
    border: 1px solid #2A923540;
    border-radius: 3px;
    margin-left: 20px; 
    margin-top: 15px;
    flex-grow: 1; 
    overflow: auto; 
    min-width: 0; 
}

.p-accordion-content .p-md-4 {
	padding: 0px !important;
}

.p-tabview-nav {
	margin-bottom: 5px;
}

.p-inputswitch {
	width: 40px;
	height: 23px;
}

.p-inputswitch .p-inputswitch-slider:before {
	width: 20px;
	height: 20px;
	left: 0px;
	margin-top: -10px;
}

.p-inputswitch.p-highlight .p-inputswitch-slider {
	background: #19486B !important;
}

.table-dialog .p-dialog-title {
	color: #182233;
	font-weight: 500;
}

.table-dialog .table-description {
	color: #182233;
	font-weight: 400;
	font-size: 14px;
}

.p-dialog-header-icons>button>svg {
	color: #182233;
}

.p-datatable-header,
.p-datatable .p-datatable-thead>tr>th {
	/* text-align: center; */
	padding: 8px 10px !important;
	font-size: 14px;
	color: #2A9235;
	font-weight: 500 !important;
}

.data-submit .p-datatable-header, .p-datatable .p-datatable-thead > tr > th {
	text-align: center;
}

.p-datatable .p-datatable-tbody>tr>td {
	padding: 8px 10px !important;
	font-size: 12px;
}

.p-datatable-emptymessage {
	color: #495057;
	font-size: 13px;
}

.p-selectbutton .p-button.p-highlight,
.p-selectbutton .p-button:focus.p-highlight {
	background: #19486B !important;
	border-color: #19486B !important;
}

.p-selectbutton .p-button,
.p-selectbutton .p-button:focus {
	border: 1px solid #4B5563;
}

.p-selectbutton .p-button .p-button-label {
	color: #4B5563;
	font-size: 12px;
}

.p-selectbutton .p-button.p-highlight .p-button-label {
	color: #FFFFFF;
	font-size: 12px;
}

.p-input-icon {
	color: #19486B;
    font-size: 16px;
    margin-left: 10px;
}

.p-input-icon.angle-sidebar {
	position: absolute;
    top: 26px;
    left: 219px;
    background-color: #2A9235 !important;
    border-radius: 50%;
    width: 21px;
    height: 21px;
	z-index: 3;
}

.angle-sidebar:before {
	padding: 4px !important;
    font-size: 12px !important;
    color: white !important;
}

.p-input-icon.angle-right-sidebar {
	position: absolute;
    top: 26px;
    left: 41px;
    background-color: #2A9235 !important;
    border-radius: 50%;
    width: 21px;
    height: 21px;
	z-index: 3;
}

.angle-right-sidebar:before {
	padding: 5px !important;
    font-size: 12px !important;
    color: white !important;
}

.tab-element-wrapper {
	position: relative;
}

.icon-container {
	position: absolute;
    top: 1%;
    left: 176px;
    transform: translateY(-50%);
    z-index: 10;
}

.icon-left-container {
	position: absolute;
    top: 1%;
    left: 41px;
    transform: translateY(-50%);
    z-index: 10;
}

.p-input-icon.angle-portfolio {
    background-color: rgba(94, 189, 104, 1) !important;
    border-radius: 50%;
    width: 21px;
    height: 21px;
}

.angle-portfolio:before {
	padding: 4px !important;
    font-size: 12px !important;
    color: white !important;
}

/* Date Picker */

.p-datepicker {
	width: 339px !important;
}

.p-datepicker table th {
	font-weight: 600;
}

.p-datepicker-header,
.p-datepicker table th,
.p-datepicker table td {
	padding: 2px;
	text-align: center;
}

.p-datepicker table th>span,
.p-datepicker table td>span {
	color: #4B5563;
	font-size: 14px;
}

.p-inputwrapper:hover {
	border: 1px solid #19486B;
}

.p-inputtext:enabled:focus {
	box-shadow: none !important;
	border-color: #19486B !important;
}

.checkbox-label {
	margin-bottom: 0px !important;
	font-size: 14px;
}

/* login Vikas */
.mc-input {
	border-bottom: 1px solid #FFC42A;
	border-right: unset;
	border-top: unset;
	border-left: unset;
	border-radius: 0px;
	font-size: 14px;
	padding-left: 0px;
	padding-bottom: 12px;
}

.mc-input:hover {
	box-shadow: none;
	outline: none;
	border: none;
	border-bottom: 1px solid #FFC42A;
}

.mc-input:focus {
	box-shadow: unset !important;
	outline: none !important;
	border: none !important;
	border-bottom: 1px solid #FFC42A !important;
}

.mc-input:enabled:focus {
	box-shadow: unset !important;
	outline: none !important;
	border: none !important;
	border-bottom: 1px solid #FFC42A !important;
	font-size: 14px;

}

.mc-input::placeholder {
	font-size: 14px;
	color: #2A9235;

}

.welcome-heading {
	color: #2A9235;
}

.forgot-password {
	color: #001F54;
	text-decoration: none;
	font-size: 12px;
	background: none !important;
}

.forgot-password:hover {
	text-decoration: underline;
}

.forgot-password:focus {
	border: unset;
	box-shadow: unset;
}

.login-btn {
	background-color: #2A9235;
	border: 1px solid #2A9235;
	color: #fff;
}

.login-btn:hover {
	background-color: #218a31;
	border-color: #218a31;
}

.p-button.p-button-help:not(:disabled):focus {
	box-shadow: unset;
}

.gradient-bg {
	background: linear-gradient(#2A9235 0%, #007882 100%);
	height: 100vh !important;
}

.box-border {
	box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
	margin-bottom: 0;
	border-radius: 4px;
	position: relative;
	transition: margin-bottom 225ms;
	padding: 10px;
	height: 400px;
	overflow-y: scroll;
}

.border-service {
	border-bottom: 1px solid #dee2e6;
}

.box-border-plan {
	box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
	margin-bottom: 0;
	border-radius: 4px;
	position: relative;
	transition: margin-bottom 225ms;
	padding: 10px;
	height: 300px;
	overflow-y: scroll;
}

.stakeholder .p-tabmenu-nav .p-menuitem-text {
	white-space: nowrap;
}

.group-table-component .clear-filter .p-button-icon {
	color: #4B5563 !important;
}

.p-multiselect-panel {
	width: 400px;
	left: 620px;
}

.p-multiselect-panel .p-multiselect-items .p-multiselect-item-group,
.p-multiselect-panel .p-multiselect-items .p-multiselect-item {
	padding: 6px 10px;
	font-size: 12px;
}

.p-multiselect-token-label,
.p-multiselect .p-multiselect-label.p-placeholder {
	font-size: 13px;
}

.stakeplan .p-field-checkbox {
	text-align: center;
}

.tooltip-font {
	font-size: 15px;
	cursor: pointer;
}

.p-accordion-toggle-icon {
	display: none;
}

.font-text .p-button-label {
	color: #19486B !important;
}

.list-height {
	height: 35px;
	overflow: auto;
	overflow: hidden auto;
	margin-bottom: 0px !important;
}

.active-button {
	height: 27px;
	font-size: 14px;
	color: #fff;
	border-color: #E5E7EB !important;
	background-color: #0dcaf0 !important;
	border-radius: 5px !important;
}

.in-active-button {
	height: 27px;
	font-size: 14px;
	color: #fff;
	border-color: #E5E7EB !important;
	background-color: grey !important;
	border-radius: 5px !important;
}

.won-button {
	height: 27px;
	font-size: 14px;
	color: #fff;
	border-color: #E5E7EB !important;
	background-color: #5cb85c !important;
	border-radius: 5px !important;
}

.lost-button {
	height: 27px;
	font-size: 14px;
	color: #fff;
	border-color: #E5E7EB !important;
	background-color: #d43f3a !important;
	border-radius: 5px !important;
}

.stop-button, .stop-button.p-disabled {
	height: 27px;
    font-size: 14px;
    color: #fff;
    border-color: #E5E7EB !important;
    background-color: #f0ad4e !important;
	border-radius: 5px !important;
	opacity: 1 !important;
}

.default-button {
	height: 27px;
	font-size: 14px;
	color: #4B5563;
	border-color: #E5E7EB !important;
	background-color: #fff !important;
	border-radius: 5px !important;
}

.btn-info {
	color: #fff;
	background-color: #5bc0de;
	border-color: #46b8da;
}

.btn-default {
	color: #333;
	background-color: #fff;
	border: 1px solid #000;
	/* Corrected syntax */
}

.btn-success {
	color: #fff;
	background-color: #5cb85c;
	border-color: #4cae4c;
}

.btn-danger {
	color: #fff;
	background-color: #d9534f;
	border-color: #d43f3a;
}

.btn-default-stat {
	color: #fff !important;
	background-color: grey !important;
	border-color: #adadad !important;
}

.btn-info {
	color: #fff;
	background-color: #5bc0de;
	border-color: #46b8da;
}

.btn-default {
	color: #333;
	background-color: #fff;
	border: 1px solid #000;
}

.btn-success {
	color: #fff;
	background-color: #5cb85c;
	border-color: #4cae4c;
}

.btn-danger {
	color: #fff;
	background-color: #d9534f;
	border-color: #d43f3a;
}

.btn-danger:hover,
.btn-danger:focus,
.btn-danger:active,
.btn-danger.active {
	color: #fff;
	background-color: #c9302c;
	border-color: #ac2925;
}

/* .btn-warning {
	color: #fff;
	background-color: #f0ad4e;
	border-color: #eea236;
  } */

.btn-default-stat {
	color: #333;
	background-color: #CCC;
	border-color: #adadad;
}

.grid-container {
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	/* 2 columns */
	gap: 10px;
	/* Adjust the gap between items if needed */
}

.grid-display {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 10px;
}

.grid-display :nth-child(1),
.grid-display :nth-child(2) {
	grid-column: span 2;
}

.grid-display-metrics {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 10px;
}

.grid-display-metrics :nth-child(1),
.grid-display-metrics :nth-child(2),
.grid-display-metrics :nth-child(3),
.grid-display-metrics :nth-child(4),
.grid-display-metrics :nth-child(5) {
	grid-column: span 2;
}

.grid-display-target {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 10px;
}

.grid-display-target :nth-child(1) {
	grid-column: span 2;
}

.p-autocomplete {
	width: 100% !important;
}

.p-autocomplete-item {
	font-size: 12px !important;
	color: #4B5563 !important;
}

.project-address {
	border-color: #E5E7EB;
	height: 30px;
	border-radius: 2px !important;
	color: #495057;
	background: #ffffff;
	padding-left: 0.5rem;
	border: 1px solid #E5E7EB;
	transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;
	appearance: none;
	outline-color: transparent;
	font-size: 12px !important;
}

.project-address:focus-visible {
	border-color: #E5E7EB;
	height: 30px;
	border-radius: 2px !important;
	color: #495057;
	background: #ffffff;
	padding-left: 0.5rem;
	border: 2px solid #E5E7EB;
	transition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;
	appearance: none;
	outline-color: transparent;
	font-size: 12px !important;
}

.color_red_new {
	color: red
}

.color_red {
	color: red;
	font-size: 12px !important;
	font-weight: 500 !important;
	margin: 0px !important;
}

.color_amber {
	color: #ffbf00;
	font-size: 12px !important;
	font-weight: 500 !important;
	margin: 0px !important;
}

.color_green {
	color: green;
	font-size: 12px !important;
	font-weight: 500 !important;
	margin: 0px !important;
}


/* chat box  */
.chatbox {
	box-shadow: 0 2px 1px -1px rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 1px 3px 0 rgba(0, 0, 0, 0.12);
	border-radius: 3px;
	border: 1px solid black;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	height: 100% !important;
}

.h-max-content {
	height: max-content;
}

.icon-font {
	font-size: 24px;
}

.emoji-style {
	position: absolute;
	bottom: 40px;
	right: 0px
}

/* Hide the number inside a step item when the lock icon is present */
.p-steps-item .pi-lock~.p-steps-number {
	display: none;
}

/* Optionally, adjust the alignment of the lock icon */
.p-steps-item .pi-lock {
	display: flex;
	align-items: center;
	justify-content: center;
	border: 2px solid rgba(94, 189, 104, 1) !important;
	background-color: rgba(94, 189, 104, 1) !important;
	color: rgba(255, 255, 255, 1) !important;
	font-size: 0.7rem;
	padding: 7px 10px;
	margin-top: 24px;
	border-radius: 50%;
	min-width: 2rem;
	height: 2rem;
	z-index: 1;
}

.p-tooltip .p-tooltip-text {
	font-size: 11px !important;
	background-color: rgba(94, 189, 104, 1) !important;
}

.cp-container {
    height: 100vh;
}

.cp-container .form-wrapper {
    padding: 30px;
    max-width: 350px; 
    width: 100%;
    background: white;
    border-radius: 10px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
}

.cp-container .form-group-cp {
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
}

.cp-container .label-text {
    margin-bottom: 5px;
    font-weight: 500;
    font-size: 14px;
}

.cp-container .form-control {
    padding: 10px;
    border-radius: 5px;
    border: 1px solid #ced4da;
    font-size: 14px;
    color: #4a4a4a;
    width: 100%; 
}

.cp-container .update-button {
    width: 100%;
    padding: 10px;
    font-size: 16px;
    font-weight: 600;
    background-color: #007bff;
    border: none;
    color: white;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color 0.3s;
}

.cp-container .update-button:hover {
    background-color: #0056b3;
}
.usage-filter{
	height:35px !important;
	width: 200px !important;
}
.branch-container {
	display: flex;
	align-items: center; /* Align items vertically center */
  }
  
  .branch-label {
	margin-right: 10px; /* Adjust spacing between label and select element */
  }
  
/* Chat */

.chat-box-adjustment {
	z-index: 2;
    position: absolute;
    bottom: 0px;
    right: 6px;
    width: 550px;
    height: 600px;
}

.overflow-auto {
	overflow: auto;
}

.chat .cancel-new-button {
	height: 33px;
    width: 30px;
	border: none;
}

.text-center {
	text-align: center !important;
}
.tooltip-span{
	margin-left: 20px;
}

.text-right {
	text-align: right;
}

.message-input-box::placeholder {
	font-size: 13px;
}

.file-upload {
	padding: 10px !important;
}
.uploaded-files{
	display: flex;
	justify-content: left;
	align-items: center;
	background-color: rgba(94, 189, 103, 0.185) !important;
	padding: 0.5rem;
}
.uploaded-file{
	display: flex;
	align-items: flex-start;
	margin-left: 10px ;
}
.sender{
	box-shadow: 0 2px 1px -1px rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 1px 3px 0 rgba(0, 0, 0, 0.12);
	padding: 0.5rem 1rem;
	background-color: rgba(94, 189, 103, 0.185);
	margin: 0.2rem;
	border-radius: 3px;
}
.receiver{
	box-shadow: 0 2px 1px -1px rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 1px 3px 0 rgba(0, 0, 0, 0.12);
	padding: 0.5rem 1rem;
	margin: 0.2rem;
	border-radius: 3px;
}
.emoji-button {
	padding: 0px;
    display: block;
    min-width: 30px;
}
.uploaded-image{
	width: 200px;
}

.send-button {
	border: none;
    padding-bottom: 11px;
    padding-left: 9px !important;
    padding-right: 10px !important;
    display: block;
    width: 35px;
}

.editing-icon {
	position: absolute;
    z-index: 2;
    bottom: 70px;
    right: 15px;
    width: 45px;
    height: 45px;
    border: none;
    box-shadow: inset 0 0 0 1px #2A9235, inset 0 0 0 1px #2A9235, inset 0 0 0 1px #2A9235, inset 0 0 0 1px #2A9235 !important;
	background-color: #2A9235;
	border-radius: 50%;
	color: #ffffff;
}

.pi-comment {
	font-size: 18px;
}
.w-cp {
	width: 100%;
	padding-right: 2.5rem; 
}

.notification-icon .p-button-icon {
	color: #19486B;
    font-size: 18px !important;
}

.p-badge-danger {
	font-size: 11px;
    position: absolute;
    min-width: 15px;
    height: 15px;
    top: 2px;
    right: 0px;
}
.p-badge-success {
	font-size: 11px;
    position: absolute;
    min-width: 15px;
    height: 15px;
    top: -6px;
    right: -6px;
	background-color: #19486B;
}


.container {
	display: flex;
	justify-content: center;  
	align-items: center;      
	height: 100vh; 
}

/* .custom-tabview .p-tabview-nav {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
}

.custom-tabview .p-tabview-nav li {
    flex: 1 1 16.6%; 
}

.custom-tabview .p-tabview-nav li:nth-child(n+7) {
    margin-top: 0px; 
} */

.avatar-img {
	width: 30px !important;
    height: 30px !important;
    background: rgba(94, 189, 104, 1) !important;
}
.login-icon{
	position: relative;
}
.cp-icon {
  position: relative;
  display: inline-block;
  width: 30%;
}
.eye-icon {
	position: absolute;
	top: 50%;
	right: 10px;
	transform: translateY(-50%);
	cursor: pointer;
	color: #888; 
  }
  
  .eye-icon:hover {
	color: #333;
  }

iframe {
	width: 100%;
    height: 92vh;
}

.sidebar-link {
	color: #4B5563 !important; /* Default color */
	text-decoration: none; /* Remove underline */
  }
  
  .sidebar-link:hover {
	color: #4B5563 !important; /* Maintain color on hover */
	cursor: default; /* Change cursor to default */
  }

  .submenu-link {
    color: #4B5563 !important; /* Default color */
    text-decoration: none; /* Remove underline */
    display: flex; /* Make the entire area clickable */
	align-items: center; /* Vertically center the items */
	padding: 12px 16px; 
	font-size: 13px; /* Ajust the font size */
}

.submenu-link i {
    margin-right: 8px; /* Adjust the value for the desired space */
	font-size: 14px;
}

.submenu-link:hover {
    color: #4B5563 !important; /* Maintain color on hover */
    cursor: pointer; /* Change cursor to pointer */
}

.password-input {
	width: 100%;
	padding-right: 30px;
}

.logo-icon-dashboard {
	width: 34px !important;
    cursor: pointer;
    height: 34px;
    position: absolute;
    right: 15px;
    z-index: 1001;
    top: 84px;
    background-color: #2A9235;
    padding: 6px;
    border-radius: 35%;
}

.scroll-top{
	position: absolute;
	z-index: 2;
	bottom: 15px;
	right: 15px;
	width: 45px;
	height: 45px;
	padding: 10px 20px;
	border-radius: 50%;
	cursor: pointer;
	font-size: 16px;
}

.target-div{
	margin-top: -60px;
	margin-bottom: 80px;
}

.target-cal .p-inputtext {
	width: 84px !important;
}


@media only screen and (min-width: 769px) {
	/* Target the specific modal (video modal) */
	#videoModal {
	  width: 80% !important;   /* Set the width of this specific modal */
	  height: 90% !important;  /* Adjust height for this specific modal */
	}
  

	/* .p-dialog {
	  width: 80% !important;   
	} */
  
	/* Example for a resource planner modal, which can be left unchanged */
	.resource-planner .p-dialog {
	  width: 60% !important;
	  height: 60% !important;
	}
  
	/* Specific adjustments for other modals, if needed */
	#surveyDialogView {
	  width: 80% !important;
	}
  
	#travelApproval {
	  width: 50% !important;
	}
  
	#visaApproval {
	  width: 53% !important;
	}
  }
  
  /* Adjust for smaller screens */
  @media only screen and (max-width: 768px) {
	/* Apply these styles only to the video modal */
	#videoModal {
	  width: 95% !important;    /* Full width on small screens */
	  height: auto !important;  /* Auto height for responsiveness */
	}
  
	/* General modal settings for smaller screens */
	.p-dialog {
	  width: 95% !important;
	  height: auto !important;
	}
  
	/* Other modals */
	#surveyDialogView,
	#travelApproval,
	#visaApproval {
	  width: 90% !important;
	}
  }
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,6DAA6D;AAC7D;;EAEE,aAAa;AACf;;AAEA;CACC,wBAAwB;CACxB,8BAA8B;CAC9B,gBAAgB;CAChB,mFAAmF;AACpF;;AAEA;CACC,wBAAwB;CACxB,8BAA8B;CAC9B,oCAAoC;CACpC,2BAA2B;AAC5B;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,YAAY;CACZ,mBAAmB;AACpB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,0BAA0B;CAC1B,2BAA2B;CAC3B,yBAAyB;AAC1B;;AAEA;CACC,sBAAsB;CACtB,uBAAuB;AACxB;;AAEA;CACC,kBAAkB;CAClB,eAAe;CACf,cAAc;AACf;;AAEA;CACC,eAAe;CACf;AACD;;;AAGA;CACC,cAAc;CACd,wBAAwB;CACxB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,YAAY;AACb;;AAEA,YAAY;AACZ;CACC,qBAAqB;CACrB,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;IACb,qBAAqB;IACrB,eAAe;IACf,YAAY;AAChB;;AAEA;CACC,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,oCAAoC;CACpC,uBAAuB;AACxB;;AAEA;CACC,UAAU;CACV,YAAY;CACZ,cAAc;CACd,kBAAkB;CAClB,SAAS;CACT,aAAa;CACb,8BAA8B;CAC9B,mBAAmB;CACnB,4BAA4B;CAC5B,uBAAuB;CACvB,8BAA8B;CAC9B,kBAAkB;CAClB,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,UAAU;AACX;;AAEA;CACC,4BAA4B;CAC5B,0BAA0B;CAC1B,2BAA2B;AAC5B;;AAEA;CACC,6BAA6B;CAC7B,0BAA0B;CAC1B,2BAA2B;CAC3B,2BAA2B;AAC5B;;AAEA;CACC,qBAAqB;CACrB,oCAAoC;CACpC,YAAY;AACb;;AAEA;CACC,eAAe;CACf,8BAA8B;AAC/B;;AAEA;CACC,2BAA2B;IACxB,YAAY;IACZ,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,WAAW;CACX,4BAA4B;CAC5B,0BAA0B;CAC1B,2BAA2B;CAC3B,yBAAyB;AAC1B;;AAEA;CACC,6BAA6B;CAC7B,0BAA0B;CAC1B,2BAA2B;CAC3B,yBAAyB;AAC1B;;AAEA,WAAW;;AAEX;CACC,uBAAuB;CACvB,aAAa;CACb,mBAAmB;CACnB,SAAS;CACT,mBAAmB;CACnB,sCAAsC;AACvC;;AAEA;CACC;EACC,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,gCAAgC;CACjC;AACD;;AAEA;CACC,mCAAmC;CACnC,0BAA0B;CAC1B,2BAA2B;CAC3B,yBAAyB;AAC1B;;AAEA;CACC;EACC,mCAAmC;EACnC,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;CAC1B;AACD;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,mBAAmB;CACnB,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;CACpB,sBAAsB;CACtB,uBAAuB;CACvB,gBAAgB;CAChB,uCAAuC;CACvC,kBAAkB;CAClB,0BAA0B;AAC3B;;AAEA;CACC;EACC,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,uCAAuC;EACvC,kBAAkB;EAClB,0BAA0B;CAC3B;AACD;;AAEA;CACC;EACC,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,uCAAuC;EACvC,kBAAkB;EAClB,0BAA0B;CAC3B;AACD;;AAEA,UAAU;;AAEV;CACC,UAAU;AACX;;AAEA;CACC,WAAW;CACX,6BAA6B;CAC7B,sCAAsC;CACtC,UAAU;CACV,SAAS;CACT,YAAY;CACZ,yCAAyC;CACzC,cAAc;AACf;;AAEA,8BAA8B;;AAE9B;CACC,wBAAwB;CACxB,8BAA8B;CAC9B,yCAAyC;CACzC,2BAA2B;AAC5B;;AAEA;CACC,UAAU;CACV,aAAa;AACd;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,sBAAsB;CACtB,wBAAwB;CACxB,8BAA8B;CAC9B,yCAAyC;AAC1C;;AAEA;CACC,0BAA0B;CAC1B,2BAA2B;CAC3B,sBAAsB;CACtB,yBAAyB;AAC1B;;AAEA;CACC,0BAA0B;CAC1B,sBAAsB;CACtB,yBAAyB;AAC1B;;AAEA;CACC,uBAAuB;CACvB,kCAAkC;CAClC,2BAA2B;CAC3B,wBAAwB;CACxB,8BAA8B;CAC9B,yCAAyC;AAC1C;;AAEA;CACC,uBAAuB;CACvB,sBAAsB;CACtB,0BAA0B;CAC1B,yDAAyD;CACzD,6BAA6B;CAC7B,kCAAkC;AACnC;;AAEA;CACC,uBAAuB;AACxB;;AAEA;;GAEG;;AAEH;CACC,6BAA6B;AAC9B;;AAEA;;CAEC,kCAAkC;CAClC,0BAA0B;CAC1B,2BAA2B;CAC3B,yBAAyB;AAC1B;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,aAAa;AACd;;AAEA,2BAA2B;;AAE3B;CACC,sBAAsB;CACtB,0DAA0D;CAC1D,yBAAyB;CACzB,wBAAwB;CACxB,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;CAC3B,wBAAwB;CACxB,oDAAoD;CACpD,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,uBAAuB;AACxB;;AAEA,iCAAiC;AACjC;CACC,WAAW;CACX,iBAAiB;CACjB,aAAa;CACb,sBAAsB;CACtB,SAAS;CACT,uBAAuB;CACvB,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;CACC,UAAU;CACV,WAAW;CACX,mBAAmB;CACnB,eAAe;CACf,gBAAgB;CAChB,yBAAyB;CACzB,iDAAiD;CACjD,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,YAAY;AACb;;;AAGA;CACC,aAAa;CACb,mBAAmB;CACnB,SAAS;CACT,mBAAmB;AACpB;;;AAGA,uBAAuB;AACvB;CACC,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,SAAO;CACP,iBAAiB;AAClB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,cAAc;CACd,qBAAqB;AACtB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,8BAA8B;CAC9B,YAAY;CACZ,2BAA2B;AAC5B;;;AAGA,YAAY;AACZ;CACC,eAAe;CACf,YAAY;CACZ,4BAA4B;CAC5B,iBAAiB;;CAEjB,iCAAiC;AAClC;;AAEA;CACC,eAAe;CACf,YAAY;CACZ,4BAA4B;CAC5B,iBAAiB;CACjB,iCAAiC;CACjC,aAAa;CACb,mBAAmB;AACpB;;;;AAIA;CACC,eAAe;CACf,8CAA8C;AAC/C;;AAEA;CACC,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,iBAAiB;;CAEjB,iCAAiC;AAClC;;AAEA;CACC,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,cAAc;AACf;;AAEA;CACC,eAAe;AAChB;;AAEA,4BAA4B;AAC5B;CACC,eAAe;CACf,YAAY;CACZ,4BAA4B;CAC5B,iBAAiB;CACjB,iCAAiC;CACjC,WAAW;CACX,4BAA4B;CAC5B,gBAAgB;CAChB,6BAA6B;CAC7B,kBAAkB;CAClB,mCAAmC;AACpC;;AAEA;CACC,eAAe;CACf,YAAY;CACZ,4BAA4B;CAC5B,iBAAiB;;CAEjB,iCAAiC;AAClC;;AAEA;CACC,eAAe;CACf,YAAY;CACZ,4BAA4B;CAC5B,iBAAiB;CACjB,iCAAiC;AAClC;;AAEA;CACC,YAAY;CACZ,eAAe;CACf,4BAA4B;AAC7B;;AAEA;;CAEC,eAAe;CACf,cAAc;AACf;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,4BAA4B;AAC7B;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;CAClB,aAAa;CACb,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,YAAY;CACZ,YAAY;CACZ,WAAW;CACX,wCAAwC;CACxC,kBAAkB;AACnB;;AAEA;CACC,uCAAuC;AACxC;;AAEA;CACC,sCAAsC;AACvC;;AAEA;CACC,sCAAsC;AACvC;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,wCAAwC;CACxC,6BAA6B;AAC9B;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,wCAAwC;CACxC,6BAA6B;AAC9B;;AAEA;CACC,sCAAsC;CACtC,6BAA6B;AAC9B;;AAEA;CACC;AACD;;AAEA;CACC,sBAAsB;CACtB,uBAAuB;CACvB,2BAA2B;CAC3B,sCAAsC;AACvC;;AAEA;CACC,sBAAsB;CACtB,uBAAuB;CACvB,2BAA2B;CAC3B,sCAAsC;AACvC;;AAEA;CACC,kCAAkC;AACnC;;AAEA,eAAe;;AAEf;CACC,2BAA2B;AAC5B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,kBAAkB;AACnB;AACA;CACC,mBAAmB;AACpB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;;GAEG;;AAEH;CACC,mBAAmB;AACpB;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,sBAAsB;AACvB;;AAEA,iBAAiB;;AAEjB;;CAEC,eAAe;CACf;;AAED;;AAEA;;CAEC,YAAY;CACZ,eAAe;CACf,8BAA8B;CAC9B,gCAAgC;AACjC;;AAEA;CACC,eAAe;AAChB;;AAEA,qCAAqC;;AAErC;CACC,aAAa;CACb,8BAA8B;CAC9B,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;CAChB,eAAe;CACf,gBAAgB;CAChB,2BAA2B;;AAE5B;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,yBAAyB;AAC1B;;AAEA;CACC,6BAA6B;CAC7B,eAAe;AAChB;;AAEA;;CAEC,WAAW;CACX,yBAAyB;CACzB,2BAA2B;CAC3B,gBAAgB;CAChB,4BAA4B;CAC5B,eAAe;CACf,yBAAyB;AAC1B;;AAEA;;CAEC,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;;CAEC,kBAAkB;AACnB;;AAEA;;CAEC,WAAW;AACZ;;AAEA;;CAEC,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,oBAAoB;;AAErB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,mBAAmB;CACnB,2BAA2B;AAC5B;;AAEA;CACC,iBAAiB;CACjB,WAAW;CACX,YAAY;CACZ,yBAAyB;CACzB,kBAAkB;CAClB,aAAa;CACb,qBAAqB;AACtB;;AAEA;CACC,iBAAiB;IACd,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;CAChB,qBAAqB;AACtB;;;AAGA;CACC,iBAAiB;CACjB,YAAY;CACZ,YAAY;CACZ,yBAAyB;CACzB,kBAAkB;CAClB,YAAY;CACZ,qBAAqB;AACtB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,aAAa;CACb,oCAAoC;CACpC,gCAAgC;CAChC,kBAAkB;AACnB;;AAEA;CACC,oCAAoC;CACpC,gCAAgC;CAChC,kBAAkB;AACnB;;;AAGA;CACC,WAAW;CACX,YAAY;CACZ,yBAAyB;CACzB,6BAA6B;AAC9B;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;;CAEC,YAAY;CACZ,YAAY;CACZ,kBAAkB;CAClB,aAAa;CACb,eAAe;;AAEhB;;AAEA;CACC,yHAAyH;CACzH,qBAAqB;AACtB;;AAEA;CACC,iBAAiB;CACjB,eAAe;CACf,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,eAAe;CACf,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,cAAc;AACf;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,SAAS;CACT,UAAU;CACV,cAAc;AACf;;AAEA;;CAEC,gBAAgB;CAChB,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;CAChB,YAAY;CACZ,yBAAyB;CACzB,cAAc;CACd,UAAU;AACX;;AAEA;IACI,MAAM;AACV;;AAEA;IACI,SAAS;IACT,gBAAgB;AACpB;;AAEA;CACC,QAAQ;AACT;;AAEA;CACC,aAAa;CACb,eAAe;;AAEhB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,eAAe;CACf,UAAU;CACV,iBAAiB;;AAElB;;AAEA;;CAEC,gBAAgB;;AAEjB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,YAAY;CACZ,YAAY;CACZ,YAAY;AACb;;AAEA;;;;;GAKG;;AAEH;CACC,WAAW;CACX,8BAA8B;CAC9B,gBAAgB;CAChB,2BAA2B;CAC3B,YAAY;AACb;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,wBAAwB;CACxB,+BAA+B;AAChC;;AAEA,UAAU;;AAEV;CACC,YAAY;AACb;;AAEA;CACC,iCAAiC;CACjC,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,kDAAkD;CAClD,kDAAkD;CAClD,wCAAwC;CACxC,iBAAiB;CACjB,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,kDAAkD;CAClD,wCAAwC;CACxC,uCAAuC;CACvC,iBAAiB;CACjB,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;CAChB,iBAAiB;CACjB,YAAY;CACZ,yBAAyB;AAC1B;;AAEA;CACC,YAAY;CACZ,6BAA6B;CAC7B,WAAW;CACX,QAAQ;CACR,OAAO;CACP,cAAc;CACd,kBAAkB;CAClB,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;;CAEC,4BAA4B;AAC7B;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,6BAA6B;CAC7B,sCAAsC;CACtC,UAAU;CACV,SAAS;CACT,YAAY;CACZ,yCAAyC;CACzC,cAAc;AACf;;AAEA,8BAA8B;;AAE9B;CACC,wBAAwB;CACxB,8BAA8B;CAC9B,yCAAyC;CACzC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;CACtB,wBAAwB;CACxB,8BAA8B;CAC9B,yCAAyC;AAC1C;;AAEA;CACC,0BAA0B;CAC1B,2BAA2B;CAC3B,sBAAsB;CACtB,kCAAkC;AACnC;;AAEA;CACC,0BAA0B;CAC1B,sBAAsB;CACtB,yBAAyB;AAC1B;;AAEA;CACC,uBAAuB;CACvB,kCAAkC;CAClC,2BAA2B;CAC3B,wBAAwB;CACxB,8BAA8B;CAC9B,yCAAyC;AAC1C;;AAEA;CACC,uBAAuB;CACvB,sBAAsB;CACtB,0BAA0B;CAC1B,mDAAmD;CACnD,6BAA6B;CAC7B,kCAAkC;AACnC;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,oCAAoC;AACrC;;AAEA;;GAEG;;AAEH,mBAAmB;;AAEnB;CACC,wBAAwB;CACxB,8BAA8B;CAC9B,aAAa;AACd;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,aAAa;IACb,cAAc;CACjB,UAAU;CACV,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;IACb,MAAM;IACN,aAAa;IACb,cAAc;IACd,YAAY;IACZ,cAAc;AAClB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,uBAAuB;CACvB,uBAAuB;CACvB,YAAY;CACZ,iCAAiC;CACjC,0DAA0D;CAC1D,kBAAkB;CAClB,eAAe;CACf,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,0BAA0B;CAC1B,2BAA2B;CAC3B,qCAAqC;AACtC;;;AAGA,2BAA2B;;AAE3B;CACC,sBAAsB;CACtB,0DAA0D;CAC1D,yBAAyB;CACzB,gBAAgB;CAChB,gBAAgB;IACb,aAAa;AACjB;;AAEA;CACC,2BAA2B;CAC3B,wBAAwB;CACxB,oDAAoD;CACpD,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,uBAAuB;AACxB;;AAEA,iCAAiC;AACjC;CACC,WAAW;CACX,gBAAgB;CAChB,aAAa;CACb,sBAAsB;CACtB,SAAS;CACT,uBAAuB;CACvB,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;CACC,UAAU;CACV,WAAW;CACX,mBAAmB;CACnB,eAAe;CACf,gBAAgB;CAChB,yBAAyB;CACzB,iDAAiD;CACjD,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,YAAY;AACb;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,SAAS;CACT,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,SAAS;CACT,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,yBAAyB;CACzB,wCAAwC;CACxC,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,yBAAyB;CACzB,qBAAqB;CACrB,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,4BAA4B;AAC7B;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,kBAAkB;CAClB,mBAAmB;CACnB,wCAAwC;CACxC,kBAAkB;AACnB;;AAEA;CACC,YAAY;CACZ,eAAe;CACf,4BAA4B;AAC7B;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,4BAA4B;AAC7B;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;CAClB,aAAa;CACb,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,YAAY;CACZ,YAAY;CACZ,WAAW;CACX,wCAAwC;CACxC,kBAAkB;AACnB;;AAEA;CACC,uCAAuC;AACxC;;AAEA;CACC,sCAAsC;AACvC;;AAEA;CACC,sCAAsC;AACvC;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,wCAAwC;CACxC,6BAA6B;AAC9B;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,wCAAwC;CACxC,6BAA6B;AAC9B;;AAEA;CACC,sCAAsC;CACtC,6BAA6B;AAC9B;;AAEA;CACC;AACD;;AAEA;CACC,sBAAsB;CACtB,uBAAuB;CACvB,2BAA2B;CAC3B,sCAAsC;AACvC;;AAEA;CACC,sBAAsB;CACtB,uBAAuB;CACvB,2BAA2B;CAC3B,sCAAsC;AACvC;;AAEA;CACC,kCAAkC;AACnC;;AAEA,eAAe;;AAEf;CACC,gBAAgB;AACjB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,uBAAuB;AACxB;;;AAGA;CACC,sBAAsB;AACvB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,iBAAiB;;AAEjB;;CAEC,eAAe;CACf;;AAED;;AAEA;;CAEC,YAAY;CACZ,eAAe;CACf,8BAA8B;CAC9B,gCAAgC;AACjC;;AAEA;CACC,eAAe;AAChB;;AAEA,qCAAqC;;AAErC;CACC,aAAa;CACb,8BAA8B;CAC9B,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;CAChB,eAAe;CACf,gBAAgB;CAChB,yBAAyB;;AAE1B;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,yBAAyB;AAC1B;;AAEA;;CAEC,WAAW;CACX,yBAAyB;CACzB,YAAY;CACZ,2BAA2B;AAC5B;;AAEA;;CAEC,kBAAkB;AACnB;;AAEA;;CAEC,2BAA2B;AAC5B;;AAEA;;CAEC,WAAW;AACZ;;AAEA;;CAEC,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,oBAAoB;;AAErB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,mBAAmB;CACnB,2BAA2B;AAC5B;;;AAGA;CACC,WAAW;CACX,YAAY;CACZ,yBAAyB;AAC1B;;;AAGA;;CAEC,YAAY;CACZ,YAAY;CACZ,kBAAkB;CAClB,aAAa;;AAEd;;AAEA;CACC,yHAAyH;CACzH,gCAAgC;AACjC;;AAEA;CACC,iBAAiB;CACjB,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,SAAS;CACT,UAAU;CACV,cAAc;AACf;;AAEA;;CAEC,gBAAgB;CAChB,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,QAAQ;AACT;;AAEA;CACC,aAAa;CACb,eAAe;;AAEhB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,eAAe;CACf,UAAU;CACV,iBAAiB;;AAElB;;AAEA;;CAEC,gBAAgB;;AAEjB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,iBAAiB;AAClB;;AAEA;;;;GAIG;;AAEH;;;;GAIG;;AAEH;CACC,WAAW;CACX,8BAA8B;CAC9B,gBAAgB;CAChB,2BAA2B;CAC3B,YAAY;AACb;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,wBAAwB;CACxB,+BAA+B;AAChC;;AAEA,YAAY;;AAEZ;CACC,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,YAAY;CACZ,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;AAClB;;AAEA,YAAY;;AAEZ;CACC,SAAS;AACV;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;;AAEjB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,SAAO;AACR;;AAEA;CACC,WAAW;CACX,sBAAsB;AACvB;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,WAAW;AACZ;;;;AAIA,YAAY;;AAEZ;CACC,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,YAAY;CACZ,gBAAgB;AACjB;;AAEA;CACC,eAAe;AAChB;;AAEA,YAAY;;AAEZ;CACC,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,YAAY;CACZ,gBAAgB;AACjB;;AAEA;CACC,eAAe;AAChB;;AAEA,YAAY;;AAEZ;CACC,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,YAAY;CACZ,gBAAgB;AACjB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,0BAA0B;CAC1B,4CAA4C;AAC7C;;AAEA;CACC,eAAe;CACf,cAAc;CACd,mBAAmB;CACnB,qBAAqB;CACrB,WAAW;CACX,kBAAkB;CAClB,qBAAqB;CACrB,4BAA4B;AAC7B;;AAEA;CACC,mCAAmC;;CAEnC,6DAA6D;AAC9D;;AAEA;CACC,cAAc;;CAEd,8CAA8C;AAC/C;;AAEA;CACC,eAAe;;CAEf,oCAAoC;AACrC;;AAEA;CACC,4BAA4B;CAC5B,uCAAuC;CACvC,qBAAqB;;CAErB,yCAAyC;AAC1C;;AAEA;CACC,0BAA0B;CAC1B,uCAAuC;AACxC;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,0BAA0B;CAC1B,YAAY;CACZ,eAAe;AAChB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,cAAc;CACd,4BAA4B;AAC7B;;AAEA;CACC,WAAW;IACR,YAAY;IACZ,cAAc;AAClB;;AAEA;;CAEC,UAAU;CACV,kBAAkB;;AAEnB;;AAEA;;;;;;;;CAQC,UAAU;AACX;;AAEA;;CAEC,aAAa;CACb,0BAA0B;CAC1B,2BAA2B;CAC3B,WAAW;AACZ;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,aAAa;CACb,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,YAAY;CACZ,cAAc;AACf;;AAEA;CACC,YAAY;CACZ,cAAc;AACf;;AAEA;CACC,YAAY;CACZ,cAAc;AACf;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,UAAU;CACV,gBAAgB;CAChB,kBAAkB;CAClB,iBAAiB;CACjB,qBAAqB;CACrB,kBAAkB;AACnB;;AAEA;CACC,UAAU;CACV,kBAAkB;CAClB,kBAAkB;CAClB,iBAAiB;CACjB,qBAAqB;AACtB;;AAEA;;CAEC,QAAQ;CACR,SAAS;AACV;;AAEA,sCAAsC;AACtC;;CAEC,wBAAwB;CACxB,gBAAgB;CAChB,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,YAAY;CACZ,gCAAgC;AACjC;;AAEA;CACC,YAAY;CACZ,YAAY;AACb;;AAEA;CACC,YAAY;CACZ,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,uBAAuB;CACvB,sBAAsB;CACtB,aAAa;CACb,aAAa;CACb,mBAAmB;CACnB,kBAAkB;CAClB,aAAa;CACb,cAAc;CACd,eAAe;CACf,YAAY;CACZ,UAAU;CACV,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;CACjB,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,YAAY;CACZ,gBAAgB;AACjB;;AAEA;CACC,YAAY;CACZ,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,SAAO;AACR;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,WAAW;CACX,sBAAsB;AACvB;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,aAAa;;CAEb,gBAAgB;AACjB;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,6BAA6B;CAC7B,mBAAmB;AACpB;;AAEA;CACC,sBAAsB;CACtB,YAAY;AACb;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC;AACD;;AAEA,SAAS;;AAET;;CAEC,0BAA0B;;CAE1B,4CAA4C;;AAE7C;;AAEA;;CAEC,eAAe;;CAEf,4BAA4B;;CAE5B,mBAAmB;;CAEnB,qBAAqB;;CAErB,qBAAqB;;AAEtB;;;;AAIA;;CAEC,mCAAmC;;CAEnC,6DAA6D;;AAE9D;;AAEA;;CAEC,eAAe;;CAEf,oCAAoC;;AAErC;;;;AAIA;;CAEC,4BAA4B;;CAE5B,uCAAuC;;CAEvC,qBAAqB;;CAErB,yCAAyC;;AAE1C;;;;AAIA;;CAEC,0BAA0B;;CAE1B,uCAAuC;;AAExC;;AAEA;;;;CAIC,UAAU;;CAEV,kBAAkB;;AAEnB;;AAEA;;;;;;;;;;;;;;;;CAgBC,UAAU;;AAEX;;;;AAIA;;;;CAIC,aAAa;;CAEb,mBAAmB;;AAEpB;;AAEA;CACC,0BAA0B;CAC1B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,cAAc;CACd,aAAa;CACb,cAAc;AACf;;AAEA;;CAEC,kBAAkB;AACnB;;AAEA;CACC,UAAU;AACX;;AAEA,oBAAoB;AACpB;CACC,aAAa;CACb,WAAW;CACX,uBAAuB;CACvB,mBAAmB;CACnB,cAAc;CACd,4BAA4B;CAC5B,4BAA4B;AAC7B;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,WAAW;CACX,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,uDAAuD;CACvD,4BAA4B;CAC5B,+BAA+B;CAC/B,yBAAyB;CACzB,0DAA0D;CAC1D,4BAA4B;;AAE7B;;AAEA;CACC,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,UAAU;CACV,WAAW;CACX,kDAAkD;CAClD,sDAAsD;CACtD,oCAAoC;CACpC,yBAAyB;CACzB,6BAA6B;CAC7B,gCAAgC;CAChC,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,oDAAoD;;CAEpD,4BAA4B;AAC7B;;AAEA;CACC,aAAa;CACb,UAAU;CACV,sBAAsB;CACtB,uBAAuB;CACvB,iBAAiB;CACjB,mBAAmB;;;;AAIpB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,YAAY;CACZ,eAAe;CACf,gBAAgB;CAChB,oBAAoB;CACpB,YAAY;;AAEb;;AAEA;CACC,YAAY;CACZ,eAAe;CACf,YAAY;AACb;;AAEA;CACC,uBAAuB;CACvB,wBAAwB;AACzB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,YAAY;CACZ,8BAA8B;CAC9B,yBAAyB;;AAE1B;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,QAAQ;CACR,SAAS;CACT,mCAAmC;CACnC,oCAAoC;CACpC,kCAAkC;CAClC,kBAAkB;CAClB,aAAa;CACb,cAAc;CACd,YAAY;CACZ,yBAAyB;AAC1B;;AAEA;CACC,YAAY;CACZ,aAAa;CACb,yBAAyB;CACzB,kBAAkB;CAClB,kBAAkB;CAClB,aAAa;CACb,aAAa;CACb,YAAY;AACb;;AAEA;CACC,yBAAyB;CACzB,kBAAkB;CAClB,aAAa;CACb,aAAa;CACb,YAAY;CACZ,WAAW;CACX,YAAY;CACZ,yBAAyB;AAC1B;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,yBAAyB;CACzB,YAAY;AACb;;;;;AAKA;CACC,2BAA2B;CAC3B,uBAAuB;;AAExB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,SAAS;CACT,cAAc;AACf;;AAEA;CACC,UAAU;CACV,8BAA8B;CAC9B,YAAY;CACZ,kBAAkB;CAClB,mBAAmB;CACnB,2BAA2B;;;AAG5B;;AAEA;CACC,gBAAgB;CAChB,qBAAqB;CACrB,yBAAyB;CACzB,aAAa;CACb,YAAY;CACZ,eAAe;AAChB;;AAEA;CACC,SAAS;CACT,qBAAqB;CACrB,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,WAAW;CACX,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,4CAA4C;CAC5C,aAAa;AACd;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,WAAW;CACX,wBAAwB;AACzB;;AAEA;CACC,mBAAmB;CACnB,SAAS;CACT,UAAU;AACX;;AAEA;CACC,mBAAmB;CACnB,aAAa;CACb,8BAA8B;CAC9B,gBAAgB;CAChB,eAAe;CACf,eAAe;AAChB;;AAEA;CACC,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,YAAY;CACZ,cAAc;CACd,eAAe;AAChB;;AAEA,yBAAyB;;AAEzB;CACC,eAAe;AAChB;;AAEA,aAAa;;AAEb;CACC,WAAW;CACX,aAAa;;AAEd;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,gCAAgC;CAChC,UAAU;CACV,WAAW;CACX,aAAa;CACb,sBAAsB;CACtB,uBAAuB;CACvB,mBAAmB;CACnB,mBAAmB;CACnB,+CAA+C;;AAEhD;;AAEA;CACC,cAAc;CACd,gBAAgB;;AAEjB;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,eAAe;CACf,YAAY;CACZ,yBAAyB;CACzB,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,yBAAyB;CACzB,aAAa;CACb,YAAY;CACZ,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,aAAa;CACb,YAAY;AACb;;AAEA;CACC,yBAAyB;CACzB,aAAa;CACb,YAAY;AACb;;AAEA;CACC,iBAAiB;CACjB,UAAU;CACV,WAAW;CACX,aAAa;CACb,sBAAsB;CACtB,8BAA8B;CAC9B,mBAAmB;;AAEpB;;AAEA;CACC,aAAa;CACb,SAAS;CACT,0BAA0B;AAC3B;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;CACC,uBAAuB;AACxB;;AAEA,uBAAuB;;AAEvB;CACC,eAAe;AAChB;;AAEA;CACC,gBAAgB;CAChB,yBAAyB;AAC1B;;AAEA;CACC,YAAY;AACb;;AAEA,sBAAsB;;AAEtB;CACC,aAAa;CACb,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,qBAAqB;CACrB,sBAAsB;CACtB,mBAAmB;AACpB;;AAEA;CACC,0BAA0B;CAC1B;AACD;;AAEA;CACC,4BAA4B;CAC5B,2BAA2B;CAC3B,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,yCAAyC;CACzC,yBAAyB;CACzB,WAAW;AACZ;;AAEA;;CAEC,sBAAsB;CACtB,YAAY;AACb;;;AAGA,iBAAiB;AACjB;CACC,yBAAyB;AAC1B;;AAEA;CACC,2BAA2B;CAC3B,6BAA6B;AAC9B;;AAEA,oBAAoB;AACpB;CACC,cAAc;CACd,2BAA2B;AAC5B;;AAEA;CACC,WAAW;CACX,0BAA0B;CAC1B,eAAe;AAChB;;AAEA,gDAAgD;AAChD;CACC,oCAAoC;CACpC,YAAY;AACb;;AAEA,4CAA4C;AAC5C;CACC,sCAAsC;CACtC,sBAAsB;CACtB,uBAAuB;CACvB,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,YAAY;AACb;;;AAGA,mBAAmB;;AAEnB;;CAEC,oBAAoB;;CAEpB;EACC,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,gCAAgC;CACjC;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;;AAGD;;AAEA;;CAEC;EACC,UAAU;EACV,6BAA6B;EAC7B,gCAAgC;CACjC;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;AACD;;;AAGA,aAAa;AACb;CACC,0BAA0B;CAC1B,cAAc;CACd,gCAAgC;CAChC,mBAAmB;AACpB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,qBAAqB;CACrB;AACD;;;;;AAKA;CACC,kBAAkB;CAClB,WAAW;CACX,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;CACpB,yCAAyC;CACzC,qBAAqB;CACrB,2CAA2C;CAC3C,WAAW;AACZ;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,aAAa;CACb,+CAA+C;CAC/C,QAAQ;CACR,2BAA2B;CAC3B,oBAAoB;AACrB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,QAAQ;CACR,2BAA2B;CAC3B,YAAY;CACZ,uBAAuB;CACvB,kCAAkC;AACnC;;AAEA;CACC,aAAa;CACb,4BAA4B;CAC5B,gBAAgB;CAChB,0BAA0B;AAC3B;;AAEA,qBAAqB;;AAErB;CACC,mBAAmB;CACnB,mCAAmC;CACnC,6BAA6B;CAC7B,4CAA4C;CAC5C,aAAa;CACb,gBAAgB;AACjB;;AAEA;CACC,YAAY;CACZ,gBAAgB;CAChB,kDAAkD;AACnD;;AAEA;CACC,kDAAkD;CAClD,eAAe;IACZ,SAAS;IACT,OAAO;IACP,2BAA2B;IAC3B,YAAY;CACf,UAAU;IACP,mBAAmB;CACtB,0CAA0C;AAC3C;;AAEA;CACC,qBAAqB;AACtB;;AAEA;;CAEC,4BAA4B;AAC7B;;AAEA;CACC,YAAY;CACZ,kDAAkD;AACnD;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,eAAe;AAChB;;AAEA;;CAEC;;EAEC,aAAa;CACd;;CAEA;EACC,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,qBAAqB;CACtB;;CAEA;EACC,iBAAiB;EACjB,aAAa;EACb,qBAAqB;CACtB;;CAEA;EACC,yBAAyB;EACzB,6CAA6C;EAC7C,gBAAgB;QACV,MAAM;EACZ,UAAU;CACX;;CAEA;EACC,2BAA2B;EAC3B,gBAAgB;QACV,YAAY;CACnB;;CAEA;EACC,YAAY;EACZ,WAAW;CACZ;;CAEA;EACC,WAAW;QACL,4CAA4C;CACnD;;CAEA;EACC,WAAW;QACL,4CAA4C;CACnD;;CAEA;EACC,qBAAqB;CACtB;;CAEA;EACC,qBAAqB;EACrB,sBAAsB;CACvB;;CAEA;EACC,qBAAqB;CACtB;;CAEA;EACC,qBAAqB;CACtB;;CAEA;EACC,qBAAqB;CACtB;AACD;;AAEA;CACC;EACC,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,4CAA4C;CAC7C;;CAEA;EACC,cAAc;CACf;;CAEA;EACC,yBAAyB;CAC1B;;CAEA;EACC,wBAAwB;CACzB;;CAEA;EACC,6BAA6B;CAC9B;;CAEA;EACC,eAAe;EACf,SAAS;EACT,WAAW;CACZ;;CAEA;EACC,cAAc;CACf;;CAEA;EACC,eAAe;EACf,cAAc;CACf;;CAEA;EACC,uBAAuB;CACxB;;CAEA;EACC,WAAW;EACX,aAAa;CACd;;CAEA;EACC,2BAA2B;CAC5B;;CAEA;EACC,qBAAqB;CACtB;;CAEA;EACC;CACD;;CAEA;EACC,qBAAqB;CACtB;AACD;;AAEA;CACC,6BAA6B;CAC7B,cAAc;CACd,sBAAsB;CACtB,cAAc;AACf;;AAEA;CACC,YAAY;CACZ,iBAAiB;CACjB,yBAAyB;AAC1B;;AAEA;CACC,cAAc;CACd,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,YAAY;CACZ,sBAAsB;CACtB,yBAAyB;CACzB,kBAAkB;AACnB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,WAAW;AACZ;;AAEA;;CAEC,kBAAkB;AACnB;;AAEA;;CAEC,4CAA4C;CAC5C,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;CACC,sCAAsC;CACtC,8BAA8B;CAC9B,mBAAmB;AACpB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,YAAY;CACZ,uBAAuB;IACpB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;CACrB,eAAe;AAChB;;AAEA;;CAEC,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;;CAEC,+BAA+B;AAChC;;;;AAIA;CACC,UAAU;CACV,WAAW;AACZ;;AAEA;CACC,wDAAwD;CACxD,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;CACnB,oDAAoD;AACrD;;AAEA;CACC,2BAA2B;CAC3B,6BAA6B;AAC9B;;AAEA;CACC,WAAW;CACX,SAAS;CACT,WAAW;CACX,YAAY;CACZ,uHAAuH;CACvH,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,kCAAkC;CAClC,aAAa;CACb,aAAa;CACb,sBAAsB;CACtB,8BAA8B;CAC9B,kDAAkD;AACnD;;AAEA;CACC,kCAAkC;CAClC;AACD;;AAEA;CACC,eAAe;CACf,yBAAyB;AAC1B;;AAEA;CACC,eAAe;CACf,yBAAyB;AAC1B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,4BAA4B;CAC5B,uBAAuB;AACxB;;AAEA;CACC,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;;CAEC,6BAA6B;AAC9B;;AAEA;CACC,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,mBAAmB;CACnB,eAAe;CACf,WAAW;AACZ;;AAEA;CACC,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,0BAA0B;CAC1B,cAAc;AACf;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,wBAAwB;CACxB;AACD;;AAEA,WAAW;;AAEX;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,qBAAqB;CACrB,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,qBAAqB;CACrB,kBAAkB;AACnB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,qBAAqB;CACrB,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,oCAAoC;CACpC,iBAAiB;AAClB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,gBAAgB;CAChB,eAAe;CACf,cAAc;AACf;;AAEA;CACC,gBAAgB;CAChB,eAAe;CACf,cAAc;AACf;;AAEA;CACC,YAAY;CACZ,YAAY;CACZ,aAAa;CACb,eAAe;CACf,uBAAuB;CACvB,uBAAuB;CACvB,yBAAyB;CACzB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,gBAAgB;CAChB,iBAAiB;CACjB,oBAAoB;AACrB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,YAAY;CACZ,WAAW;CACX,aAAa;CACb,eAAe;CACf,uBAAuB;CACvB,uBAAuB;CACvB,yBAAyB;CACzB,kBAAkB;AACnB;;AAEA;CACC,yBAAyB;CACzB,gBAAgB;CAChB,oBAAoB;CACpB,eAAe;AAChB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,cAAc;CACd,gBAAgB;CAChB,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,cAAc;AACf;;AAEA;;;;CAIC,2BAA2B;CAC3B,iBAAiB;CACjB,4BAA4B;CAC5B,eAAe;AAChB;;AAEA;;CAEC,gBAAgB;CAChB,iBAAiB;CACjB,4BAA4B;CAC5B,eAAe;CACf,eAAe;AAChB;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,kBAAkB;CAClB,cAAc;CACd,YAAY;AACb;;AAEA;CACC,sBAAsB;CACtB,yBAAyB;CACzB,kBAAkB;CAClB,YAAY;CACZ,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,yBAAyB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;CACzB,kBAAkB;CAClB,YAAY;CACZ,iBAAiB;AAClB;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;CACzB,kBAAkB;CAClB,YAAY;CACZ,gBAAgB;CAChB,uBAAuB;AACxB;;AAEA;CACC,yBAAyB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,gBAAgB;AACjB;;AAEA;;CAEC,cAAc;CACd,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;CACzB,kBAAkB;CAClB,YAAY;AACb;;AAEA;CACC,cAAc;CACd,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,qBAAqB;CACrB,mBAAmB;AACpB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;CACzB,0BAA0B;AAC3B;;AAEA,gBAAgB;;AAEhB;CACC,2BAA2B;CAC3B,YAAY;CACZ,YAAY;AACb;;AAEA;CACC,cAAc;CACd,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;CACnB,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,oBAAoB;AACrB;;AAEA;CACC,8BAA8B;CAC9B,YAAY;CACZ,YAAY;AACb;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,YAAY;CACZ,gBAAgB;CAChB,SAAS;CACT,kBAAkB;CAClB,QAAQ;CACR,cAAc;CACd,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,mBAAmB;AACpB;;AAEA;CACC,UAAU;CACV,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,cAAc;CACd,kBAAkB;CAClB,kBAAkB;CAClB,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,cAAc;CACd,0BAA0B;AAC3B;;AAEA;CACC,gBAAgB;AACjB;;AAEA,aAAa;;AAEb;CACC,aAAa;CACb,mBAAmB;AACpB;;AAEA;CACC,sBAAsB;CACtB,gBAAgB;CAChB,kCAAkC;AACnC;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,cAAc;CACd,eAAe;CACf,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;;CAEC,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,uBAAuB;CACvB,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,qCAAqC;AACtC;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;CACC,sBAAsB;CACtB,gCAAgC;CAChC,gBAAgB;AACjB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,eAAe;CACf,YAAY;CACZ,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,gCAAgC;AACjC;;AAEA;;;;CAIC,yBAAyB;CACzB,qBAAqB;CACrB,6CAA6C;AAC9C;;AAEA;CACC,gBAAgB;AACjB;;AAEA;;CAEC,aAAa;IACV,WAAW;CACd,YAAY;AACb;;AAEA;CACC,aAAa;IACV,2BAA2B;IAC3B,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,YAAY;AAChB;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,SAAS;CACT,iBAAiB;AAClB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,gBAAgB;CAChB,eAAe;AAChB;;AAEA;CACC,cAAc;AACf;;AAEA;;CAEC,wBAAwB;CACxB,4BAA4B;CAC5B,eAAe;CACf,cAAc;CACd,2BAA2B;AAC5B;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,4BAA4B;CAC5B,eAAe;AAChB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;;CAEC,8BAA8B;CAC9B,gCAAgC;AACjC;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,cAAc;IACX,eAAe;IACf,iBAAiB;AACrB;;AAEA;CACC,kBAAkB;IACf,SAAS;IACT,WAAW;IACX,oCAAoC;IACpC,kBAAkB;IAClB,WAAW;IACX,YAAY;CACf,UAAU;AACX;;AAEA;CACC,uBAAuB;IACpB,0BAA0B;IAC1B,uBAAuB;AAC3B;;AAEA;CACC,kBAAkB;IACf,SAAS;IACT,UAAU;IACV,oCAAoC;IACpC,kBAAkB;IAClB,WAAW;IACX,YAAY;CACf,UAAU;AACX;;AAEA;CACC,uBAAuB;IACpB,0BAA0B;IAC1B,uBAAuB;AAC3B;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;IACf,OAAO;IACP,WAAW;IACX,2BAA2B;IAC3B,WAAW;AACf;;AAEA;CACC,kBAAkB;IACf,OAAO;IACP,UAAU;IACV,2BAA2B;IAC3B,WAAW;AACf;;AAEA;IACI,kDAAkD;IAClD,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;CACC,uBAAuB;IACpB,0BAA0B;IAC1B,uBAAuB;AAC3B;;AAEA,gBAAgB;;AAEhB;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;;;CAGC,YAAY;CACZ,kBAAkB;AACnB;;AAEA;;CAEC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,2BAA2B;CAC3B,gCAAgC;AACjC;;AAEA;CACC,6BAA6B;CAC7B,eAAe;AAChB;;AAEA,gBAAgB;AAChB;CACC,gCAAgC;CAChC,mBAAmB;CACnB,iBAAiB;CACjB,kBAAkB;CAClB,kBAAkB;CAClB,eAAe;CACf,iBAAiB;CACjB,oBAAoB;AACrB;;AAEA;CACC,gBAAgB;CAChB,aAAa;CACb,YAAY;CACZ,gCAAgC;AACjC;;AAEA;CACC,4BAA4B;CAC5B,wBAAwB;CACxB,uBAAuB;CACvB,2CAA2C;AAC5C;;AAEA;CACC,4BAA4B;CAC5B,wBAAwB;CACxB,uBAAuB;CACvB,2CAA2C;CAC3C,eAAe;;AAEhB;;AAEA;CACC,eAAe;CACf,cAAc;;AAEf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;CACd,qBAAqB;CACrB,eAAe;CACf,2BAA2B;AAC5B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,aAAa;CACb,iBAAiB;AAClB;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;CACzB,WAAW;AACZ;;AAEA;CACC,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,qDAAqD;CACrD,wBAAwB;AACzB;;AAEA;CACC,+GAA+G;CAC/G,gBAAgB;CAChB,kBAAkB;CAClB,kBAAkB;CAClB,+BAA+B;CAC/B,aAAa;CACb,aAAa;CACb,kBAAkB;AACnB;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,+GAA+G;CAC/G,gBAAgB;CAChB,kBAAkB;CAClB,kBAAkB;CAClB,+BAA+B;CAC/B,aAAa;CACb,aAAa;CACb,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,YAAY;CACZ,WAAW;AACZ;;AAEA;;CAEC,iBAAiB;CACjB,eAAe;AAChB;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,eAAe;AAChB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,YAAY;CACZ,cAAc;CACd,qBAAqB;CACrB,6BAA6B;AAC9B;;AAEA;CACC,YAAY;CACZ,eAAe;CACf,WAAW;CACX,gCAAgC;CAChC,oCAAoC;CACpC,6BAA6B;AAC9B;;AAEA;CACC,YAAY;CACZ,eAAe;CACf,WAAW;CACX,gCAAgC;CAChC,iCAAiC;CACjC,6BAA6B;AAC9B;;AAEA;CACC,YAAY;CACZ,eAAe;CACf,WAAW;CACX,gCAAgC;CAChC,oCAAoC;CACpC,6BAA6B;AAC9B;;AAEA;CACC,YAAY;CACZ,eAAe;CACf,WAAW;CACX,gCAAgC;CAChC,oCAAoC;CACpC,6BAA6B;AAC9B;;AAEA;CACC,YAAY;IACT,eAAe;IACf,WAAW;IACX,gCAAgC;IAChC,oCAAoC;CACvC,6BAA6B;CAC7B,qBAAqB;AACtB;;AAEA;CACC,YAAY;CACZ,eAAe;CACf,cAAc;CACd,gCAAgC;CAChC,iCAAiC;CACjC,6BAA6B;AAC9B;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;CACC,WAAW;CACX,sBAAsB;CACtB,sBAAsB;CACtB,qBAAqB;AACtB;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;CACtB,iCAAiC;CACjC,gCAAgC;AACjC;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;CACC,WAAW;CACX,sBAAsB;CACtB,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;CACC,WAAW;CACX,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;;;;CAIC,WAAW;CACX,yBAAyB;CACzB,qBAAqB;AACtB;;AAEA;;;;KAIK;;AAEL;CACC,WAAW;CACX,sBAAsB;CACtB,qBAAqB;AACtB;;AAEA;CACC,aAAa;CACb,qCAAqC;CACrC,cAAc;CACd,SAAS;CACT,2CAA2C;AAC5C;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,SAAS;AACV;;AAEA;;CAEC,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,SAAS;AACV;;AAEA;;;;;CAKC,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,0BAA0B;CAC1B,yBAAyB;AAC1B;;AAEA;CACC,qBAAqB;CACrB,YAAY;CACZ,6BAA6B;CAC7B,cAAc;CACd,mBAAmB;CACnB,oBAAoB;CACpB,yBAAyB;CACzB,iFAAiF;CACjF,gBAAgB;CAChB,0BAA0B;CAC1B,0BAA0B;AAC3B;;AAEA;CACC,qBAAqB;CACrB,YAAY;CACZ,6BAA6B;CAC7B,cAAc;CACd,mBAAmB;CACnB,oBAAoB;CACpB,yBAAyB;CACzB,iFAAiF;CACjF,gBAAgB;CAChB,0BAA0B;CAC1B,0BAA0B;AAC3B;;AAEA;CACC;AACD;;AAEA;CACC,UAAU;CACV,0BAA0B;CAC1B,2BAA2B;CAC3B,sBAAsB;AACvB;;AAEA;CACC,cAAc;CACd,0BAA0B;CAC1B,2BAA2B;CAC3B,sBAAsB;AACvB;;AAEA;CACC,YAAY;CACZ,0BAA0B;CAC1B,2BAA2B;CAC3B,sBAAsB;AACvB;;;AAGA,cAAc;AACd;CACC,+GAA+G;CAC/G,kBAAkB;CAClB,uBAAuB;CACvB,aAAa;CACb,sBAAsB;CACtB,8BAA8B;CAC9B,uBAAuB;AACxB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ;AACD;;AAEA,qEAAqE;AACrE;CACC,aAAa;AACd;;AAEA,sDAAsD;AACtD;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,kDAAkD;CAClD,kDAAkD;CAClD,wCAAwC;CACxC,iBAAiB;CACjB,iBAAiB;CACjB,gBAAgB;CAChB,kBAAkB;CAClB,eAAe;CACf,YAAY;CACZ,UAAU;AACX;;AAEA;CACC,0BAA0B;CAC1B,kDAAkD;AACnD;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,2CAA2C;IAC3C,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,cAAc;IACd,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;AACA;CACC,sBAAsB;CACtB,uBAAuB;AACxB;AACA;CACC,aAAa;CACb,mBAAmB,EAAE,kCAAkC;EACtD;;EAEA;CACD,kBAAkB,EAAE,oDAAoD;EACvE;;AAEF,SAAS;;AAET;CACC,UAAU;IACP,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,YAAY;IACZ,aAAa;AACjB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,YAAY;IACT,WAAW;CACd,YAAY;AACb;;AAEA;CACC,6BAA6B;AAC9B;AACA;CACC,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,wBAAwB;AACzB;AACA;CACC,aAAa;CACb,qBAAqB;CACrB,mBAAmB;CACnB,sDAAsD;CACtD,eAAe;AAChB;AACA;CACC,aAAa;CACb,uBAAuB;CACvB,kBAAkB;AACnB;AACA;CACC,+GAA+G;CAC/G,oBAAoB;CACpB,2CAA2C;CAC3C,cAAc;CACd,kBAAkB;AACnB;AACA;CACC,+GAA+G;CAC/G,oBAAoB;CACpB,cAAc;CACd,kBAAkB;AACnB;AACA;CACC,YAAY;IACT,cAAc;IACd,eAAe;AACnB;AACA;CACC,YAAY;AACb;;AAEA;CACC,YAAY;IACT,oBAAoB;IACpB,4BAA4B;IAC5B,8BAA8B;IAC9B,cAAc;IACd,WAAW;AACf;;AAEA;CACC,kBAAkB;IACf,UAAU;IACV,YAAY;IACZ,WAAW;IACX,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,yHAAyH;CAC5H,yBAAyB;CACzB,kBAAkB;CAClB,cAAc;AACf;;AAEA;CACC,eAAe;AAChB;AACA;CACC,WAAW;CACX,qBAAqB;AACtB;;AAEA;CACC,cAAc;IACX,0BAA0B;AAC9B;;AAEA;CACC,eAAe;IACZ,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,QAAQ;IACR,UAAU;AACd;AACA;CACC,eAAe;IACZ,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,SAAS;IACT,WAAW;CACd,yBAAyB;AAC1B;;;AAGA;CACC,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,aAAa;AACd;;AAEA;;;;;;;;;;;;GAYG;;AAEH;CACC,sBAAsB;IACnB,uBAAuB;IACvB,4CAA4C;AAChD;AACA;CACC,kBAAkB;AACnB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,UAAU;AACZ;AACA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;CACX,2BAA2B;CAC3B,eAAe;CACf,WAAW;EACV;;EAEA;CACD,WAAW;EACV;;AAEF;CACC,WAAW;IACR,YAAY;AAChB;;AAEA;CACC,yBAAyB,EAAE,kBAAkB;CAC7C,qBAAqB,EAAE,qBAAqB;EAC3C;;EAEA;CACD,yBAAyB,EAAE,4BAA4B;CACvD,eAAe,EAAE,6BAA6B;EAC7C;;EAEA;IACE,yBAAyB,EAAE,kBAAkB;IAC7C,qBAAqB,EAAE,qBAAqB;IAC5C,aAAa,EAAE,mCAAmC;CACrD,mBAAmB,EAAE,gCAAgC;CACrD,kBAAkB;CAClB,eAAe,EAAE,wBAAwB;AAC1C;;AAEA;IACI,iBAAiB,EAAE,2CAA2C;CACjE,eAAe;AAChB;;AAEA;IACI,yBAAyB,EAAE,4BAA4B;IACvD,eAAe,EAAE,6BAA6B;AAClD;;AAEA;CACC,WAAW;CACX,mBAAmB;AACpB;;AAEA;CACC,sBAAsB;IACnB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,SAAS;IACT,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,YAAY;CACZ,WAAW;CACX,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,kBAAkB;CAClB,eAAe;CACf,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,sBAAsB;AACvB;;;AAGA;CACC,4CAA4C;CAC5C;GACE,qBAAqB,IAAI,yCAAyC;GAClE,sBAAsB,GAAG,0CAA0C;CACrE;;;CAGA;;IAEG;;CAEH,sEAAsE;CACtE;GACE,qBAAqB;GACrB,sBAAsB;CACxB;;CAEA,qDAAqD;CACrD;GACE,qBAAqB;CACvB;;CAEA;GACE,qBAAqB;CACvB;;CAEA;GACE,qBAAqB;CACvB;EACC;;EAEA,+BAA+B;EAC/B;CACD,+CAA+C;CAC/C;GACE,qBAAqB,KAAK,gCAAgC;GAC1D,uBAAuB,GAAG,mCAAmC;CAC/D;;CAEA,+CAA+C;CAC/C;GACE,qBAAqB;GACrB,uBAAuB;CACzB;;CAEA,iBAAiB;CACjB;;;GAGE,qBAAqB;CACvB;EACC","sourcesContent":["/* Hide the default password reveal and clear icons in Edge */\ninput[type=\"password\"]::-ms-reveal,\ninput[type=\"password\"]::-ms-clear {\n  display: none;\n}\n\n.myconsole {\n\tdisplay: flex !important;\n\tflex-direction: row !important;\n\toverflow: hidden;\n\tfont-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif !important;\n}\n\n.searchBox {\n\tdisplay: flex !important;\n\tflex-direction: row !important;\n\tjustify-content: flex-end !important;\n\tmargin: 20px 0px !important;\n}\n\n.p-radiobutton-label {\n\tfont-size: 12px;\n\tmargin-left: 5px;\n\tcolor: #757373;\n\tmargin: auto 3px;\n}\n\n.radiobutton {\n\tdisplay: flex;\n\twidth: 71.5%;\n\talign-items: center;\n}\n\n.marginLeft {\n\tmargin: 0px 10px !important;\n}\n\n.headerText {\n\tfont-size: 20px !important;\n\tfont-weight: 500 !important;\n\tcolor: #2A9235 !important;\n}\n\n.searchBoxSize {\n\twidth: 50px !important;\n\theight: 20px !important;\n}\n\n.font13 {\n\tfont-style: italic;\n\tfont-size: 13px;\n\tcolor: #757373;\n}\n\n.p-inputtext-lg {\n\tfont-size: 12px;\n\tcolor: '#9e9e9e'\n}\n\n\n.text-red-500 {\n\tfont-size: 9px;\n\t/* margin-left: 150px; */\n\tmargin-top: -4px;\n\tcolor: rgb(239 68 68);\n}\n\n.color-red {\n\tcolor: 'red';\n}\n\n/* Sidebar */\n.sidebar .logo {\n\twidth: 50% !important;\n\tcursor: pointer;\n\tmargin-left: 27px;\n}\n\n.logo-icon {\n\tmargin-left: 7px;\n    width: 58% !important;\n    cursor: pointer;\n    height: 41px;\n}\n\n.logo-w-h {\n\theight: 45px;\n\twidth: 68px;\n}\n\n.add-button {\n\tbackground-color: #2A9235 !important;\n\tcolor: white !important;\n}\n\n.sidebar .sm-add-button {\n\twidth: 70%;\n\tpadding: 5px;\n\tcolor: #4B5563;\n\tborder-radius: 4px;\n\tborder: 0;\n\tdisplay: flex;\n\t/* Use Flexbox for centering */\n\talign-items: center;\n\t/* Center items vertically */\n\tjustify-content: center;\n\t/* Center items horizontally */\n\tpadding-left: 15px;\n\tcursor: pointer;\n}\n\n.sidebar .icons-end {\n\tposition: absolute;\n\tbottom: 10px;\n\tright: 0px;\n}\n\n.sidebar .p-button-icon {\n\tpadding-left: 5px !important;\n\tfont-size: 14px !important;\n\tfont-weight: 400 !important;\n}\n\n.sidebar .p-button-label {\n\tpadding-left: 15px !important;\n\tfont-size: 14px !important;\n\tfont-weight: 400 !important;\n\ttext-align: left !important;\n}\n\n.sidebar .p-panelmenu {\n\twidth: 85% !important;\n\tmargin: 0px 12px 0px 12px !important;\n\theight: 40px;\n}\n\n.sidebar .p-panelmenu-panel {\n\tmargin: 5px 0px;\n\tbox-shadow: 0 0 0 0 !important;\n}\n\n.sidebar .p-panelmenu-header-content {\n\tpadding: 8px 5px !important;\n    border: none;\n    background-color: transparent;\n    height: 40px;\n}\n\n.sidebar .selected-item .p-panelmenu-header-content {\n\tbackground-color: #DFF2E1 !important;\n}\n\n.sidebar .p-panelmenu-header-link {\n\tpadding: 3px;\n}\n\n.sidebar .p-menuitem-icon {\n\tmargin: 0px;\n\tpadding-left: 5px !important;\n\tfont-size: 14px !important;\n\tfont-weight: 400 !important;\n\tcolor: #4B5563 !important;\n}\n\n.sidebar .p-menuitem-text {\n\tpadding-left: 15px !important;\n\tfont-size: 13px !important;\n\tfont-weight: 400 !important;\n\tcolor: #4B5563 !important;\n}\n\n/* Header */\n\n.content .header {\n\theight: 50px !important;\n\tdisplay: flex;\n\tflex-direction: row;\n\tgap: 3rem;\n\talign-items: center;\n\t/* background: #2A92351A !important; */\n}\n\n@media (max-width: 600px) {\n\t.content .header {\n\t\theight: 50px !important;\n\t\tdisplay: flex;\n\t\tflex-direction: row;\n\t\tgap: 1rem;\n\t\talign-items: center;\n\t\tbackground: #2A92351A !important;\n\t}\n}\n\n.header .headerLabel {\n\tmargin: 0px 0px 0px 20px !important;\n\tfont-size: 20px !important;\n\tfont-weight: 500 !important;\n\tcolor: #2A9235 !important;\n}\n\n@media (max-width: 600px) {\n\t.header .headerLabel {\n\t\tmargin: 0px 0px 0px 20px !important;\n\t\tfont-size: 14px !important;\n\t\tfont-weight: 500 !important;\n\t\tcolor: #2A9235 !important;\n\t}\n}\n\n.header .headerLabel>p {\n\tmargin: 0px !important;\n}\n\n.header .headerSearch .pi {\n\tpadding-top: 0.2rem;\n\tfont-size: 0.75rem;\n\tfont-weight: 400;\n}\n\n.header .headerSearch .p-inputtext {\n\tpadding-top: 0.25rem;\n\tpadding-right: 0.25rem;\n\tpadding-bottom: 0.25rem;\n\tfont-weight: 400;\n\tborder: 1px solid rgba(74, 74, 74, 0.2);\n\tborder-radius: 3px;\n\tcolor: rgba(0, 0, 0, 0.55);\n}\n\n@media (max-width: 720px) {\n\t.header .headerSearch .p-inputtext {\n\t\tpadding-top: 0.25rem;\n\t\tpadding-right: 0.25rem;\n\t\tpadding-bottom: 0.25rem;\n\t\tfont-weight: 400;\n\t\twidth: 230px;\n\t\tborder: 1px solid rgba(74, 74, 74, 0.2);\n\t\tborder-radius: 3px;\n\t\tcolor: rgba(0, 0, 0, 0.55);\n\t}\n}\n\n@media (max-width: 600px) {\n\t.header .headerSearch .p-inputtext {\n\t\tpadding-top: 0.25rem;\n\t\tpadding-right: 0.25rem;\n\t\tpadding-bottom: 0.25rem;\n\t\tfont-weight: 400;\n\t\twidth: 150px;\n\t\tborder: 1px solid rgba(74, 74, 74, 0.2);\n\t\tborder-radius: 3px;\n\t\tcolor: rgba(0, 0, 0, 0.55);\n\t}\n}\n\n/* Steps */\n\n.p-steps .p-steps-item {\n\twidth: 20%;\n}\n\n.portfolio-steps #pr_id_3_6.p-steps-item:before {\n\twidth: 100%;\n\tposition: absolute !important;\n\tmargin: 0px 0px 1.25rem 0px !important;\n\tleft: auto;\n\ttop: auto;\n\tcontent: \" \";\n\tborder-top: 1px solid rgba(0, 0, 0, 0.12);\n\tdisplay: block;\n}\n\n/* portfolio-cards Portfolio */\n\n.portfolio-cards {\n\tdisplay: flex !important;\n\tflex-direction: row !important;\n\tjustify-content: space-between !important;\n\tmargin-top: 20px !important;\n}\n\n.portfolio-cards .p-card {\n\twidth: 19%;\n\tpadding: 10px;\n}\n\n.portfolio-cards .p-card-body {\n\tpadding: 0px;\n}\n\n.portfolio-cards .p-card-content {\n\tpadding: 0px;\n}\n\n.portfolio-cards .cardHeader {\n\tmargin: 5px !important;\n\tdisplay: flex !important;\n\tflex-direction: row !important;\n\tjustify-content: space-between !important;\n}\n\n.portfolio-cards .cardTitle {\n\tfont-size: 12px !important;\n\tfont-weight: 500 !important;\n\tmargin: 0px !important;\n\tcolor: #4B5563 !important;\n}\n\n.portfolio-cards .progressStatus {\n\tfont-size: 12px !important;\n\tmargin: 0px !important;\n\tcolor: #2A9235 !important;\n}\n\n.portfolio-cards .cardContent {\n\theight: 30px !important;\n\tmargin: 5px 5px 5px 5px !important;\n\tpadding-top: 5px !important;\n\tdisplay: flex !important;\n\tflex-direction: row !important;\n\tjustify-content: space-between !important;\n}\n\n.portfolio-cards .p-progressbar {\n\twidth: 128px !important;\n\theight: 8px !important;\n\tmargin-top: 8px !important;\n\t/* border: solid 1px rgba(42, 146, 53, 0.5) !important; */\n\tborder-radius: 4px !important;\n\tjustify-content: center !important;\n}\n\n.portfolio-cards .p-progressbar {\n\tbackground-color: white;\n}\n\n/* .portfolio-cards .p-progressbar-value {\n\tbackground-color: #2A9235 !important;\n} */\n\n.portfolio-cards .p-progressbar-label {\n\tcolor: transparent !important;\n}\n\n.portfolio-cards .progressPercentage,\n.portfolio-cards .costValue {\n\tmargin: 2px 0px 0px 0px !important;\n\tfont-size: 12px !important;\n\tfont-weight: 500 !important;\n\tcolor: #4B5563 !important;\n}\n\n.portfolio-menu .p-menuitem {\n\tpadding: 0px 0px 0px 10px !important;\n}\n\n.portfolio-menu .p-menuitem-link {\n\tpadding: 10px;\n}\n\n/* Portfolio Menu Content */\n\n.portfolio-content .portfolio-menu-content {\n\twidth: 100% !important;\n\tborder-left: 1px solid rgba(94, 189, 104, 0.25) !important;\n\tpadding: 0px 0px 0px 18px;\n\theight: 100vh !important;\n\tmargin-top: 20px;\n}\n\n.portfolio-menu-content .p-scrollpanel {\n\tmargin-top: 20px !important;\n\theight: 280px !important;\n\tborder: 1px solid rgba(42, 146, 53, 0.25) !important;\n\tborder-radius: 3px;\n}\n\n.portfolio-menu-content .p-scrollpanel-content {\n\twidth: 100%;\n\theight: 100%;\n\tpadding: 0px !important;\n}\n\n/* Summary Dropdowns and Inputs */\n.summaryTopic {\n\twidth: 100%;\n\tmargin-left: 10px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 10px;\n\tjustify-content: center;\n\talign-self: center;\n\talign-items: flex;\n}\n\n.summaryTopic>p {\n\twidth: 94%;\n\tmargin: 0px;\n\tpadding-bottom: 2px;\n\tfont-size: 12px;\n\tfont-weight: 400;\n\tcolor: rgba(0, 31, 84, 1);\n\tborder-bottom: 1px solid rgba(94, 189, 104, 0.35);\n\tborder-radius: 2px;\n}\n\n.summaryTopic label {\n\tfont-size: 12px;\n\twidth: 130px;\n}\n\n\n.summaryTopic .summary-dropdown {\n\tdisplay: flex;\n\tflex-direction: row;\n\tgap: 1rem;\n\talign-items: center;\n}\n\n\n/* PasswordChange.css */\n.p-inputgroup {\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.p-inputgroup .p-inputtext {\n\tflex: 1;\n\tmargin-left: 1rem;\n}\n\n.p-field {\n\tmargin-bottom: 1.5rem;\n}\n\nlabel {\n\tdisplay: block;\n\tmargin-bottom: 0.5rem;\n}\n\n.p-field-switch {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\twidth: 100px;\n\t/* Adjust width as needed */\n}\n\n\n/* app.css */\n.custom-multiselect .p-multiselect {\n\tfont-size: 12px;\n\theight: 30px;\n\t/* Adjust height as needed */\n\tline-height: 30px;\n\n\t/* Adjust line-height as needed */\n}\n\n.custom-multiselect .p-multiselect-label-container {\n\tfont-size: 12px;\n\theight: 30px;\n\t/* Adjust height as needed */\n\tline-height: 30px;\n\t/* Adjust line-height as needed */\n\tdisplay: flex;\n\talign-items: center;\n}\n\n\n\n.custom-multiselect .p-multiselect-trigger .p-multiselect-trigger-icon {\n\tfont-size: 12px;\n\t/* Adjust font-size to make the icon smaller */\n}\n\n.custom-multiselect .p-multiselect-panel {\n\tfont-size: 12px;\n\tmax-height: 100px;\n}\n\n.custom-multiselect .p-multiselect-item {\n\tfont-size: 12px;\n\tline-height: 30px;\n\n\t/* Adjust line-height as needed */\n}\n\n.custom-multiselect .p-multiselect-items {\n\tmax-height: 100px;\n\toverflow-y: auto;\n}\n\n.p-multiselect-item span {\n\tfont-size: 12px;\n\tcolor: #4B5563;\n}\n\n.p-multiselect-checkbox .p-checkbox-box {\n\tmargin-top: 2px;\n}\n\n/* Custom styles for chips */\n.custom-multiselect .p-multiselect-token {\n\tfont-size: 12px;\n\theight: 20px;\n\t/* Adjust height as needed */\n\tline-height: 20px;\n\t/* Adjust line-height as needed */\n\tmargin: 2px;\n\t/* Adjust margin as needed */\n\tpadding: 2px 5px;\n\t/* Adjust padding as needed */\n\tborder-radius: 5px;\n\t/* Adjust border-radius as needed */\n}\n\n.custom-multiselect .p-multiselect-token-label {\n\tfont-size: 12px;\n\theight: 16px;\n\t/* Adjust height as needed */\n\tline-height: 16px;\n\n\t/* Adjust line-height as needed */\n}\n\n.custom-multiselect .p-multiselect-token-icon {\n\tfont-size: 12px;\n\theight: 15px;\n\t/* Adjust height as needed */\n\tline-height: 15px;\n\t/* Adjust line-height as needed */\n}\n\n.summaryTopic .summary-dropdown .p-dropdown-label.p-inputtext {\n\tpadding: 0px;\n\tfont-size: 12px;\n\tcolor: rgba(74, 74, 74, 0.5);\n}\n\n.p-dropdown-label.p-inputtext,\n.p-dropdown-item-label {\n\tfont-size: 12px;\n\tcolor: #4B5563;\n}\n\n.summaryTopic .summary-dropdown .p-dropdown-trigger-icon {\n\theight: 10px;\n\twidth: 10px;\n\tcolor: rgba(74, 74, 74, 0.5);\n}\n\n.portfolio-buttons {\n\tmargin-top: 10px;\n\tmargin-left: 600px;\n\tdisplay: flex;\n\tflex-direction: row;\n\tgap: 15px;\n}\n\n.portfolio-buttons .p-button {\n\tpadding: 5px;\n\theight: 28px;\n\twidth: 40px;\n\tbackground-color: rgba(255, 255, 255, 1);\n\tborder-radius: 4px;\n}\n\n.portfolio-buttons .previous.p-button {\n\tborder: 1px solid rgba(74, 74, 74, 0.5);\n}\n\n.portfolio-buttons .next.p-button {\n\tborder: 1px solid rgba(42, 146, 53, 1);\n}\n\n.portfolio-buttons .save.p-button {\n\tbackground-color: rgba(42, 146, 53, 1);\n}\n\n.portfolio-buttons .p-button-label {\n\tfont-size: 12px;\n\tfont-weight: 400;\n\tbackground-color: rgba(255, 255, 255, 1);\n\tcolor: rgba(74, 74, 74, 0.75);\n}\n\n.portfolio-buttons .p-button-label {\n\tfont-size: 12px;\n\tfont-weight: 400;\n\tbackground-color: rgba(255, 255, 255, 1);\n\tcolor: rgba(74, 74, 74, 0.75);\n}\n\n.portfolio-buttons .save .p-button-label {\n\tbackground-color: rgba(42, 146, 53, 1);\n\tcolor: rgba(255, 255, 255, 1);\n}\n\n.form-control-inputnumber {\n\twidth: 100px\n}\n\n.custom-increment-button {\n\twidth: 12px !important;\n\theight: 12px !important;\n\tmargin-left: -20 !important;\n\tbackground-color: rgba(42, 146, 53, 1);\n}\n\n.custom-decrement-button {\n\twidth: 12px !important;\n\theight: 12px !important;\n\tmargin-left: -20 !important;\n\tbackground-color: rgba(42, 146, 53, 1);\n}\n\n.select-button .p-dropdown-item.p-highlight {\n\tbackground-color: green !important;\n}\n\n/* Alignments */\n\n.ml-0 {\n\tmargin-left: 0px !important;\n}\n\n.mt-0 {\n\tmargin-top: 0px !important;\n}\n\n.mar-t-5 {\n\tmargin-top: 5px !important;\n}\n\n.mar-t-8 {\n\tmargin-top: 8px !important;\n}\n\n.mar-16 {\n\tmargin: 16px;\n}\n\n.ml-2 {\n\tmargin-left: 2px;\n}\n\n.mar-l-5 {\n\tmargin-left: 5px !important;\n}\n\n.ml-10 {\n\tmargin-left: 10px;\n}\n\n.ml-15 {\n\tmargin-left: 15px;\n}\n\n.ml-20 {\n\tmargin-left: 20px;\n}\n\n.ml-25 {\n\tmargin-left: 25px;\n}\n\n.mr-2 {\n\tmargin-right: 2px;\n}\n\n.mr-5 {\n\tmargin-right: 5px !important;\n}\n\n.mr-20 {\n\tmargin-right: 20px;\n}\n.mr-560 {\n\tmargin-right: 560px;\n}\n\n.mt-10 {\n\tmargin-top: 10px !important;\n}\n\n.mt-13 {\n\tmargin-top: 13px !important;\n}\n\n.mt-20 {\n\tmargin-top: 20px !important;\n}\n\n.mt-30 {\n\tmargin-top: 30px;\n}\n\n.mb-20 {\n\tmargin-bottom: 20px !important;\n}\n\n/* .mb-16 {\n    margin-bottom: 16px;\n} */\n\n.pr-12 {\n\tpadding-right: 12px;\n}\n\n.p-0 {\n\tpadding: 0px !important;\n}\n\n.pr-0 {\n\tpadding-right: 0px;\n}\n\n.w-350 {\n\twidth: 350px;\n}\n\n.h-25 {\n\theight: 25px;\n}\n\n.h-27 {\n\theight: 27px;\n}\n\n.h-350 {\n\theight: 350px !important;\n}\n\n.flex {\n\tdisplay: flex;\n}\n\n.flex-wrap {\n\tflex-wrap: wrap;\n}\n\n.justify-center {\n\tjustify-content: center;\n}\n\n.justify-space-between {\n\tjustify-content: space-between;\n}\n\n.justify-end {\n\tjustify-content: end !important;\n}\n\n.align-center {\n\talign-items: center;\n}\n\n.direction-col {\n\tflex-direction: column;\n}\n\n/* Select Button*/\n\n.p-selectbutton .p-button,\n.p-selectbutton .p-button:focus {\n\tfont-size: 12px;\n\tfont-family: '-apple-system', 'BlinkMacSystemFont', 'Segoe UI', 'Roboto', 'Oxygen',\n\t\t'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif\n}\n\n.p-selectbutton .p-button.p-highlight,\n.p-selectbutton .p-button:focus.p-highlight {\n\tcolor: #ffff;\n\tfont-size: 12px;\n\tbackground: #3F51B5 !important;\n\tborder-color: #3F51B5 !important;\n}\n\n.text-xs {\n\tfont-size: 12px;\n}\n\n/* STAKEHOLDER ASSESSMENT QUESTIONS */\n\n.header-design {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n}\n\n.group-header {\n\tfont-weight: 600;\n\tfont-size: 12px;\n\ttext-align: left;\n\tbackground-color: #2A92351A;\n\n}\n\n.group-table-header tr th {\n\ttext-align: left;\n}\n\n.group-table-header tr th:nth-child(1) {\n\ttext-align: center;\n}\n\n.group-table-row {\n\tfont-size: 14px;\n}\n\n.group-datatable {\n\tmin-width: 100%;\n\tborder-collapse: collapse;\n}\n\n.group-table-row tr:hover {\n\tbackground-color: transparent;\n\tcursor: pointer;\n}\n\n.group-table-row td,\n.group-table-header tr th {\n\twidth: 100%;\n\tborder: 1px solid #f8f9fa;\n\t/* background-color: red; */\n\ttext-align: left;\n\tpadding: 8px 10px !important;\n\tfont-size: 14px;\n\t/* white-space: nowrap; */\n}\n\n.budget-plan .group-table-row td,\n.budget-plan .group-table-header tr th  {\n\twhite-space: nowrap;\n}\n\n.group-table-header tr th {\n\tfont-weight: 500;\n}\n\n.group-table-row td:nth-child(1),\n.group-table-header tr th:nth-child(1) {\n\ttext-align: center;\n}\n\n.group-table-row td:nth-child(1),\n.group-table-row th:nth-child(1) {\n\twidth: 50px;\n}\n\n.group-table-row th:nth-child(2),\n.group-table-row td:nth-child(2) {\n\twidth: 100%;\n\tmin-width: 100%;\n}\n\n.checkbox-header {\n\twidth: 5% !important;\n\n}\n\n.checkbox {\n\tmargin: auto;\n}\n\n.group-table-row i {\n\tfont-size: 14px;\n}\n\n.group-table-search {\n\tdisplay: flex;\n\tjustify-content: right;\n\talign-items: center;\n\twidth: max-content;\n}\n\n.group-table-buttons {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tmargin: 20px auto 10px auto;\n}\n\n.clear-filter-button {\n\tmargin-left: 15px;\n\twidth: 38px;\n\theight: 34px;\n\tbackground-color: #2A9235;\n\tborder-radius: 4px;\n\tpadding: 10px;\n\tborder-color: #2A9235;\n}\n\n.export-button {\n\tmargin-left: 15px;\n    width: 150px;\n    height: 34px;\n    background-color: #2A9235;\n    border-radius: 4px;\n    padding: 10px;\n\tborder-color: #2A9235;\n}\n\n\n.new-button {\n\tmargin-left: 15px;\n\twidth: 100px;\n\theight: 34px;\n\tbackground-color: #2A9235;\n\tborder-radius: 4px;\n\tpadding: 7px;\n\tborder-color: #2A9235;\n}\n\n.delete-button-icon {\n\twidth: 38px;\n\theight: 34px;\n\tpadding: 10px;\n\tbackground-color: #2A9235 !important;\n\tborder-color: #2A9235 !important;\n\tborder-radius: 4px;\n}\n\n.delete-button {\n\tbackground-color: #2A9235 !important;\n\tborder-color: #2A9235 !important;\n\tborder-radius: 4px;\n}\n\n\n.upload-button {\n\twidth: 35px;\n\theight: 35px;\n\tbackground-color: #2A9235;\n\tborder-radius: 4px !important;\n}\n\n.upload-button .p-button-icon {\n\tcolor: #FFFFFF;\n}\n\n.add-button {\n\ttext-align: right;\n\twidth: max-content;\n}\n\n.search-input {\n\n\theight: 35px;\n\twidth: 300px;\n\tpadding: 10px 40px;\n\toutline: none;\n\tfont-size: 13px;\n\n}\n\n.p-inputtext:enabled:focus {\n\tbox-shadow: inset 0 0 0 1px #2A9235, inset 0 0 0 1px #2A9235, inset 0 0 0 1px #2A9235, inset 0 0 0 1px #2A9235 !important;\n\tborder-color: #2A9235;\n}\n\n.p-input-icon-left i {\n\tmargin-left: 13px;\n\tfont-size: 14px;\n\tpadding-top: 1px;\n\tcolor: #4B5563;\n}\n\n.p-dropdown-empty-message {\n\tfont-size: 14px;\n\tcolor: #4B5563;\n}\n\n.group-table-search i {\n\tmargin-right: 20px;\n}\n\n.group-table-text-section {\n\tfont-size: 10px;\n\tcolor: #666666;\n}\n\n.group-table-component {\n\tmargin-top: 20px;\n}\n\n.group-table-component h2 {\n\tmargin: 0;\n\tpadding: 0;\n\tcolor: #2A9235;\n}\n\n.group-table-data {\n\n\toverflow-x: auto;\n\theight: 60vh;\n\tposition: relative;\n}\n\n.group-table-header {\n\tposition: sticky;\n\t/* top: 0; */\n\tbackground-color: #f8f9fa;\n\tcolor: #2A9235;\n\tz-index: 1;\n}\n\n.group-table-header:first-of-type {\n    top: 0;\n}\n\n.group-table-header:last-of-type {\n    bottom: 0;\n    position: sticky;\n}\n\n.group-table-data::-webkit-scrollbar {\n\twidth: 0;\n}\n\n.group-field-display {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\n}\n\n.input-group {\n\tdisplay: flex;\n\tflex-direction: column;\n\tmargin-top: 1px;\n\twidth: 30%;\n\tmargin: 20px auto;\n\n}\n\n.group-button-handle div {\n\n\ttext-align: left;\n\n}\n\n.input-group label {\n\twidth: 100%;\n\tfont-size: 14px;\n\tmargin: 10px auto;\n}\n\n.group-field-handle {\n\theight: 35px;\n\tpadding: 1px;\n\twidth: 220px;\n}\n\n/* \n.dropdown-field-handle {\n\theight: 35px;\n\tmargin: 0px;\n\twidth: 215px;\n} */\n\n.group-option-field {\n\twidth: 100%;\n\tbackground: #2A9235 !important;\n\tfont-weight: 600;\n\tmargin-top: 30px !important;\n\tcolor: white;\n}\n\n.group-option-field p {\n\tmargin: 8px;\n}\n\n.group-popup-button {\n\tjustify-content: flex-end !important;\n}\n\n.group-popup-button div {\n\tmargin: 2px;\n}\n\n.no-data-found {\n\tcolor: red;\n}\n\n.group-table-row tr:last-child td {\n\tborder-bottom: none;\n}\n\n.group-table-row {\n\twidth: calc(100% - 17px);\n\t/* Adjust for scrollbar width */\n}\n\n/* Steps */\n\n.portfolio-steps .p-steps {\n\tpadding: 0px;\n}\n\n.portfolio-steps .p-menuitem-link {\n\tflex-direction: column !important;\n\tpadding: 0px;\n\tgap: 0.5rem;\n}\n\n.portfolio-steps .p-steps-current .p-steps-number {\n\tborder: 2px solid rgba(94, 189, 104, 1) !important;\n\tbackground-color: rgba(94, 189, 104, 1) !important;\n\tcolor: rgba(255, 255, 255, 1) !important;\n\tfont-size: 0.7rem;\n\tpadding: 7px 10px;\n\tmargin-top: 25px;\n}\n\n.portfolio-steps .p-steps-number {\n\tborder: 2px solid rgba(74, 74, 74, 0.2) !important;\n\tbackground-color: rgba(255, 255, 255, 1);\n\tcolor: rgba(74, 74, 74, 0.5) !important;\n\tfont-size: 0.7rem;\n\tpadding: 7px 10px;\n\tmargin-top: 27px;\n}\n\n.portfolio-steps .p-steps-title {\n\tfont-weight: 400;\n\tfont-size: 0.7rem;\n\tpadding: 0px;\n\twhite-space: break-spaces;\n}\n\n.portfolio-steps .p-steps-item:last-child::before {\n\tcontent: \" \";\n\tborder-top: 1px solid #dee2e6;\n\twidth: 100%;\n\ttop: 50%;\n\tleft: 0;\n\tdisplay: block;\n\tposition: absolute;\n\tmargin-top: -1px;\n\t/* width: 300px; */\n}\n\n.portfolio-steps .p-steps .p-steps-item.p-highlight .p-steps-title {\n\tfont-weight: bold;\n}\n\n.portfolio-steps ol,\nul {\n\tpadding-left: 0px !important;\n}\n\n.portfolio-steps .p-steps-item:before {\n\tmargin-top: -1px;\n}\n\n.portfolio-steps #pr_id_3_6.p-steps-item:before {\n\twidth: 100%;\n\tposition: absolute !important;\n\tmargin: 0px 0px 1.25rem 0px !important;\n\tleft: auto;\n\ttop: auto;\n\tcontent: \" \";\n\tborder-top: 1px solid rgba(0, 0, 0, 0.12);\n\tdisplay: block;\n}\n\n/* portfolio-cards Portfolio */\n\n.portfolio-cards {\n\tdisplay: flex !important;\n\tflex-direction: row !important;\n\tjustify-content: space-between !important;\n\tmargin-top: 20px !important;\n}\n\n.portfolio-cards .cardHeader {\n\tmargin: 5px !important;\n\tdisplay: flex !important;\n\tflex-direction: row !important;\n\tjustify-content: space-between !important;\n}\n\n.portfolio-cards .cardTitle {\n\tfont-size: 12px !important;\n\tfont-weight: 500 !important;\n\tmargin: 0px !important;\n\tcolor: rgba(0, 0, 0, 1) !important;\n}\n\n.portfolio-cards .progressStatus {\n\tfont-size: 12px !important;\n\tmargin: 0px !important;\n\tcolor: #2A9235 !important;\n}\n\n.portfolio-cards .cardContent {\n\theight: 30px !important;\n\tmargin: 5px 5px 5px 5px !important;\n\tpadding-top: 5px !important;\n\tdisplay: flex !important;\n\tflex-direction: row !important;\n\tjustify-content: space-between !important;\n}\n\n.portfolio-cards .p-progressbar {\n\twidth: 128px !important;\n\theight: 8px !important;\n\tmargin-top: 8px !important;\n\tborder: solid 1px rgba(42, 146, 53, 0.5) !important;\n\tborder-radius: 4px !important;\n\tjustify-content: center !important;\n}\n\n.portfolio-cards .p-progressbar {\n\tbackground-color: white;\n}\n\n.portfolio-cards .p-progressbar-value {\n\tbackground-color: #2A9235 !important;\n}\n\n/* .portfolio-cards .p-progressbar-label {\n\tcolor: #2A9235 !important;\n} */\n\n/* Portfolio Menu */\n\n.portfolio-content {\n\tdisplay: flex !important;\n\tflex-direction: row !important;\n\theight: 100vh;\n}\n\n.portfolio-menu {\n    position: sticky;\n    top: 0;\n    height: 100vh;\n    overflow: auto;\n\twidth: 19%;\n\tmargin-top: 20px;\n}\n\n.custom-tabview {\n\toverflow: hidden;\n}\n\n.custom-tabview .p-tabview-nav-container {\n\tposition: sticky;\n    top: 0;\n    height: 100vh;\n    overflow: auto;\n    width: 200px;\n    flex-shrink: 0;\n}\n\n.collapse-tabs .custom-tabview .p-tabview-nav-container {\n\twidth: 62px !important;\n}\n\n.custom-tabview .p-accordion .p-accordion-tab {\n\tbox-shadow: none !important;\n}\n\n.portfolio-menu .p-menu {\n\twidth: 195px !important;\n\theight: auto !important;\n\tpadding: 0px;\n\t/* margin-top: 20px !important; */\n\tborder-left: 1px solid rgba(94, 189, 104, 0.25) !important;\n\tborder-radius: 0px;\n\tborder-top: 0px;\n\tborder-right: 0px;\n\tborder-bottom: 0px;\n}\n\n.portfolio-menu .p-menu ol, ul, dl {\n\tmargin-bottom: 0px !important;\n}\n\n.portfolio-menu .p-menuitem {\n\tpadding: 0px 0px 0px 10px !important;\n}\n\n.portfolio-menu .p-menuitem-link {\n\tpadding: 10px;\n}\n\n.portfolio-menu .p-menuitem-text {\n\tfont-size: 12px !important;\n\tfont-weight: 400 !important;\n\tcolor: rgba(74, 74, 74, 1) !important;\n}\n\n\n/* Portfolio Menu Content */\n\n.portfolio-content .portfolio-menu-content {\n\twidth: 100% !important;\n\tborder-left: 1px solid rgba(94, 189, 104, 0.25) !important;\n\tpadding: 0px 0px 0px 18px;\n\tmargin-top: 20px;\n\toverflow-y: auto;\n    height: 100vh;\n}\n\n.portfolio-menu-content .p-scrollpanel {\n\tmargin-top: 20px !important;\n\theight: 280px !important;\n\tborder: 1px solid rgba(42, 146, 53, 0.25) !important;\n\tborder-radius: 3px;\n}\n\n.portfolio-menu-content .p-scrollpanel-content {\n\twidth: 100%;\n\theight: 100%;\n\tpadding: 0px !important;\n}\n\n/* Summary Dropdowns and Inputs */\n.summaryTopic {\n\twidth: 100%;\n\tmargin-left: 0px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 10px;\n\tjustify-content: center;\n\talign-self: center;\n\talign-items: flex;\n}\n\n.summaryTopic>p {\n\twidth: 94%;\n\tmargin: 0px;\n\tpadding-bottom: 2px;\n\tfont-size: 12px;\n\tfont-weight: 400;\n\tcolor: rgba(0, 31, 84, 1);\n\tborder-bottom: 1px solid rgba(94, 189, 104, 0.35);\n\tborder-radius: 2px;\n}\n\n.summaryTopic label {\n\tfont-size: 12px;\n\twidth: 130px;\n}\n\n.summaryTopic .summary-input-text {\n\tdisplay: flex;\n\tflex-direction: row;\n\tgap: 1rem;\n\talign-items: center;\n}\n\n.summaryTopic .summary-dropdown {\n\tdisplay: flex;\n\tflex-direction: row;\n\tgap: 1rem;\n\talign-items: center;\n}\n\n.summaryTopic .summary-input-text .p-inputtext {\n\twidth: 100%;\n\theight: 30px;\n\tpadding: 0px 0px 0px 15px;\n\tborder: 1px solid rgba(74, 74, 74, 0.15);\n\tborder-radius: 5px;\n}\n\n.summaryTopic .summary-input-text-red .p-inputtext {\n\twidth: 100%;\n\theight: 30px;\n\tpadding: 0px 0px 0px 15px;\n\tborder: 1px solid red;\n\tborder-radius: 5px;\n}\n\n.summaryTopic .summary-input-text .p-inputtext::placeholder {\n\tfont-size: 12px;\n\tfont-weight: 400;\n\tcolor: rgba(74, 74, 74, 0.5);\n}\n\n.summaryTopic .summary-dropdown .p-dropdown {\n\twidth: 100%;\n\t/* height: 30px; */\n\tpadding-left: 15px;\n\talign-items: center;\n\tborder: 1px solid rgba(74, 74, 74, 0.15);\n\tborder-radius: 5px;\n}\n\n.summaryTopic .summary-dropdown .p-dropdown-label.p-inputtext {\n\tpadding: 0px;\n\tfont-size: 12px;\n\tcolor: rgba(74, 74, 74, 0.5);\n}\n\n.summaryTopic .summary-dropdown .p-dropdown-trigger-icon {\n\theight: 10px;\n\twidth: 10px;\n\tcolor: rgba(74, 74, 74, 0.5);\n}\n\n.portfolio-buttons {\n\tmargin-top: 10px;\n\tmargin-left: 600px;\n\tdisplay: flex;\n\tflex-direction: row;\n\tgap: 15px;\n}\n\n.portfolio-buttons .p-button {\n\tpadding: 5px;\n\theight: 28px;\n\twidth: 40px;\n\tbackground-color: rgba(255, 255, 255, 1);\n\tborder-radius: 4px;\n}\n\n.portfolio-buttons .previous.p-button {\n\tborder: 1px solid rgba(74, 74, 74, 0.5);\n}\n\n.portfolio-buttons .next.p-button {\n\tborder: 1px solid rgba(42, 146, 53, 1);\n}\n\n.portfolio-buttons .save.p-button {\n\tbackground-color: rgba(42, 146, 53, 1);\n}\n\n.portfolio-buttons .p-button-label {\n\tfont-size: 12px;\n\tfont-weight: 400;\n\tbackground-color: rgba(255, 255, 255, 1);\n\tcolor: rgba(74, 74, 74, 0.75);\n}\n\n.portfolio-buttons .p-button-label {\n\tfont-size: 12px;\n\tfont-weight: 400;\n\tbackground-color: rgba(255, 255, 255, 1);\n\tcolor: rgba(74, 74, 74, 0.75);\n}\n\n.portfolio-buttons .save .p-button-label {\n\tbackground-color: rgba(42, 146, 53, 1);\n\tcolor: rgba(255, 255, 255, 1);\n}\n\n.form-control-inputnumber {\n\twidth: 100px\n}\n\n.custom-increment-button {\n\twidth: 12px !important;\n\theight: 12px !important;\n\tmargin-left: -20 !important;\n\tbackground-color: rgba(42, 146, 53, 1);\n}\n\n.custom-decrement-button {\n\twidth: 12px !important;\n\theight: 12px !important;\n\tmargin-left: -20 !important;\n\tbackground-color: rgba(42, 146, 53, 1);\n}\n\n.select-button .p-dropdown-item.p-highlight {\n\tbackground-color: green !important;\n}\n\n/* Alignments */\n\n.ml-0 {\n\tmargin-left: 0px;\n}\n\n.mt-0 {\n\tmargin-top: 0px;\n}\n\n.ml-2 {\n\tmargin-left: 2px;\n}\n\n.mr-2 {\n\tmargin-right: 2px;\n}\n\n.mt-30 {\n\tmargin-top: 30px;\n}\n\n.pt-0 {\n\tpadding-top: 0px;\n}\n\n.pt-5 {\n\tpadding-top: 5px;\n}\n\n.pad-t-8 {\n\tpadding-top: 8px !important;\n}\n\n.pad-b-8 {\n\tpadding-bottom: 8px !important;\n}\n\n.pt-10 {\n\tpadding-top: 10px;\n}\n\n.pt-17 {\n\tpadding-top: 17px;\n}\n\n.pt-18 {\n\tpadding-top: 18px !important;\n}\n\n.pl-10 {\n\tpadding-left: 10px;\n}\n\n.pl-16 {\n\tpadding-left: 16px;\n}\n\n.pl-0 {\n\tpadding-left: 0px !important;\n}\n\n.p-15 {\n\tpadding: 15px !important;\n}\n\n.padding-8 {\n\tpadding: 8px 17px !important;\n}\n\n.mar-b-3 {\n\tmargin-bottom: 3px;\n}\n\n.pr-12 {\n\tpadding-right: 12px;\n}\n\n.width-025 {\n\twidth: 0.25% !important;\n}\n\n.width-2 {\n\twidth: 2% !important;\n}\n\n.width-3 {\n\twidth: 3% !important;\n}\n\n.width-5 {\n\twidth: 5% !important;\n}\n\n.width-6 {\n\twidth: 6% !important;\n}\n\n.width-7 {\n\twidth: 7% !important;\n}\n\n.width-9 {\n\twidth: 9% !important;\n}\n\n.width-10 {\n\twidth: 10% !important;\n}\n\n.width-11_5 {\n\twidth: 11.5% !important;\n}\n\n.width-12 {\n\twidth: 12% !important;\n}\n\n.width-15 {\n\twidth: 15% !important;\n}\n\n.w-20 {\n\twidth: 20% !important;\n}\n\n.w-25 {\n\twidth: 25% !important;\n}\n\n.w-30 {\n\twidth: 30% !important;\n}\n\n.width-3 {\n\twidth: 3rem !important;\n}\n\n.width-46 {\n\twidth: 46vw !important;\n}\n\n.width-32 {\n\twidth: 32rem !important;\n}\n\n.width-40vw {\n\twidth: 40vw !important;\n}\n\n.width-42vw {\n\twidth: 42vw !important;\n}\n\n.width-42 {\n\twidth: 42% !important;\n}\n\n.w-40 {\n\twidth: 40% !important;\n}\n\n.w-50 {\n\twidth: 50%;\n}\n\n.w-70 {\n\twidth: 70%;\n}\n\n.w-100 {\n\twidth: 100%;\n}\n\n.w-150 {\n\twidth: 150px !important;\n}\n\n.w-350 {\n\twidth: 350px;\n}\n\n.h-25 {\n\theight: 30px;\n}\n\n.h-27 {\n\theight: 27px;\n}\n\n.flex {\n\tdisplay: flex;\n}\n\n.justify-center {\n\tjustify-content: center;\n}\n\n\n.direction-col {\n\tflex-direction: column;\n}\n\n.white-space {\n\twhite-space: nowrap;\n}\n\n.word-wrap {\n\tword-wrap: break-word;\n}\n\n.font-color-white {\n\tcolor: #fff;\n}\n\n.background-red .p-progressbar-value {\n\tbackground-color: #ff0005 !important;\n}\n\n.background-red .p-progressbar {\n\tborder-color: #ff0005 !important;\n}\n\n.background-amber .p-progressbar-value {\n\tbackground-color: #ffbf00 !important;\n}\n\n.background-amber .p-progressbar {\n\tborder-color: #ffbf00 !important;\n}\n\n.background-green .p-progressbar-value {\n\tbackground-color: green !important;\n}\n\n.background-green .p-progressbar {\n\tborder-color: green !important;\n}\n\n.border-red {\n\tborder-color: red !important;\n}\n\n.border-grey {\n\tborder-color: #E5E7EB !important;\n}\n\n.fs-12 {\n\tfont-size: 12px;\n}\n\n.fs-13 {\n\tfont-size: 13px !important;\n}\n\n.fs-16 {\n\tfont-size: 16px;\n}\n\n.fs-18 {\n\tfont-size: 18px !important;\n}\n\n.fw-500 {\n\tfont-weight: 500;\n}\n\n.fw-600 {\n\tfont-weight: 600;\n}\n\n/* Select Button*/\n\n.p-selectbutton .p-button,\n.p-selectbutton .p-button:focus {\n\tfont-size: 12px;\n\tfont-family: '-apple-system', 'BlinkMacSystemFont', 'Segoe UI', 'Roboto', 'Oxygen',\n\t\t'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif\n}\n\n.p-selectbutton .p-button.p-highlight,\n.p-selectbutton .p-button:focus.p-highlight {\n\tcolor: #ffff;\n\tfont-size: 12px;\n\tbackground: #3F51B5 !important;\n\tborder-color: #3F51B5 !important;\n}\n\n.text-xs {\n\tfont-size: 12px;\n}\n\n/* STAKEHOLDER ASSESSMENT QUESTIONS */\n\n.header-design {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: top;\n}\n\n.group-header {\n\tfont-weight: 600;\n\tfont-size: 12px;\n\ttext-align: left;\n\tbackground-color: #f8f9fa;\n\n}\n\n.group-table-header tr th {\n\ttext-align: left;\n}\n\n.group-table-header tr th:nth-child(1) {\n\ttext-align: center;\n}\n\n.group-table-row {\n\tfont-size: 14px;\n}\n\n.group-datatable {\n\tmin-width: 100%;\n\tborder-collapse: collapse;\n}\n\n.group-table-row td,\n.group-table-header tr th {\n\twidth: 100%;\n\tborder: 1px solid #f8f9fa;\n\tpadding: 8px;\n\t/* background-color: red; */\n}\n\n.group-table-row td:nth-child(1),\n.group-table-header tr th:nth-child(1), .usagelog .group-table-header tr:nth-child(1) th:nth-child(1) {\n\ttext-align: center;\n}\n\n.kpi-output .group-table-row td:nth-child(1),\n.kpi-output .group-table-header tr th:nth-child(1), .activity .group-table-row td:nth-child(1), .activity .group-table-header tr th:nth-child(1), .usagelog .group-table-row td:nth-child(1) {\n\ttext-align: left !important;\n}\n\n.group-table-row td:nth-child(1),\n.group-table-row th:nth-child(1) {\n\twidth: 50px;\n}\n\n.group-table-row th:nth-child(2),\n.group-table-row td:nth-child(2) {\n\twidth: 100%;\n\tmin-width: 100%;\n}\n\n.checkbox-header {\n\twidth: 5% !important;\n\n}\n\n.checkbox {\n\tmargin: auto;\n}\n\n.group-table-row i {\n\tfont-size: 14px;\n}\n\n.group-table-search {\n\tdisplay: flex;\n\tjustify-content: right;\n\talign-items: center;\n\twidth: max-content;\n}\n\n.group-table-buttons {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tmargin: 20px auto 10px auto;\n}\n\n\n.upload-button {\n\twidth: 35px;\n\theight: 35px;\n\tbackground-color: #2A9235;\n}\n\n\n.search-input {\n\n\theight: 35px;\n\twidth: 300px;\n\tpadding: 10px 40px;\n\toutline: none;\n\n}\n\n.p-inputtext:enabled:focus {\n\tbox-shadow: inset 0 0 0 1px #2A9235, inset 0 0 0 1px #2A9235, inset 0 0 0 1px #2A9235, inset 0 0 0 1px #2A9235 !important;\n\tborder-color: #2A9235 !important;\n}\n\n.p-input-icon-left i {\n\tmargin-left: 13px;\n\tfont-size: 12px;\n\tpadding-top: 1px;\n}\n\n.group-table-search i {\n\tmargin-right: 20px;\n}\n\n.group-table-text-section {\n\tfont-size: 10px;\n}\n\n.group-table-component {\n\tmargin-top: 20px;\n}\n\n.group-table-component h2 {\n\tmargin: 0;\n\tpadding: 0;\n\tcolor: #2A9235;\n}\n\n.group-table-data {\n\n\toverflow-x: auto;\n\theight: 60vh;\n\tposition: relative;\n}\n\n.group-table-data::-webkit-scrollbar {\n\twidth: 0;\n}\n\n.group-field-display {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\n}\n\n.input-group {\n\tdisplay: flex;\n\tflex-direction: column;\n\tmargin-top: 1px;\n\twidth: 30%;\n\tmargin: 20px auto;\n\n}\n\n.group-button-handle div {\n\n\ttext-align: left;\n\n}\n\n.input-group label {\n\twidth: 100%;\n\tfont-size: 14px;\n\tmargin: 10px auto;\n}\n\n/* .group-field-handle {\n\theight: 28px;\n\tpadding: 1px;\n\twidth: 250px;\n} */\n\n/* .dropdown-field-handle {\n\theight: 35px;\n\tmargin: 0px;\n\twidth: 215px;\n} */\n\n.group-option-field {\n\twidth: 100%;\n\tbackground: #2A9235 !important;\n\tfont-weight: 600;\n\tmargin-top: 30px !important;\n\tcolor: white;\n}\n\n.group-option-field p {\n\tmargin: 8px;\n}\n\n.group-popup-button {\n\tjustify-content: flex-end !important;\n}\n\n.group-popup-button div {\n\tmargin: 2px;\n}\n\n.no-data-found {\n\tcolor: red;\n}\n\n.group-table-row tr:last-child td {\n\tborder-bottom: none;\n}\n\n.group-table-row {\n\twidth: calc(100% - 17px);\n\t/* Adjust for scrollbar width */\n}\n\n/* app.css */\n\n.p-field-container {\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.p-label {\n\twidth: 230px;\n\tpadding-top: 7px;\n\tfont-size: 12px;\n}\n\n.p-inputgroup-container {\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.p-field-switch-container {\n\tdisplay: flex;\n\talign-items: center;\n\tmargin-right: 10px;\n}\n\n.p-field-switch-text {\n\tfont-size: 12px;\n}\n\n.p-field-switch-text-left {\n\tmargin-left: 7px;\n}\n\n.p-field-switch-text-right {\n\tmargin-right: 7px;\n}\n\n/* app.css */\n\n.group-table-component h2 {\n\tmargin: 0;\n}\n\n.flex-container {\n\tdisplay: flex;\n\tflex-direction: row;\n\talign-items: center;\n}\n\n.summary-dropdown {\n\tmargin-top: 10px;\n\tmargin-right: 20px;\n}\n\n.summary-dropdown label {\n\tfont-weight: 400;\n}\n\n.summary-dropdown .dropdown-container {\n\tmargin-top: -6px;\n\n}\n\n.last-summary-dropdown {\n\tmargin-right: 0;\n}\n\n.app-container {\n\tdisplay: flex;\n\tflex-direction: row;\n\talign-items: center;\n\twidth: 100%;\n}\n\n.flex-1 {\n\tflex: 1;\n}\n\n.width-100 {\n\twidth: 100%;\n\tbox-sizing: border-box;\n}\n\n.width-50 {\n\twidth: 50%;\n}\n\n.width-50vw {\n\twidth: 50vw;\n}\n\n\n\n/* app.css */\n\n.p-field-container {\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.p-label-container {\n\twidth: 280px;\n\tpadding-top: 7px;\n}\n\n.p-label {\n\tfont-size: 12px;\n}\n\n/* app.css */\n\n.p-field-container {\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.p-label-container {\n\twidth: 280px;\n\tpadding-top: 7px;\n}\n\n.p-label {\n\tfont-size: 12px;\n}\n\n/* app.css */\n\n.p-field-container {\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.p-label-container {\n\twidth: 230px;\n\tpadding-top: 7px;\n}\n\n.p-label {\n\tfont-size: 12px;\n}\n\n.p-inputgroup-container {\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.p-field-switch-container {\n\tdisplay: flex;\n\talign-items: center;\n\tmargin-right: 10px;\n}\n\n.p-field-switch-text {\n\tfont-size: 12px;\n}\n\n.p-field-switch-text-left {\n\tmargin-left: 7px;\n}\n\n.p-field-switch-text-right {\n\tmargin-right: 7px;\n}\n\n.custom-dropdown {\n\tfont-size: 12px !important;\n\t/* Use !important to override other styles */\n}\n\n.custom-multiselect {\n\tfont-size: 12px;\n\tcolor: #4B5563;\n\t/* Set font color */\n\tborder-color: #e7e6e6;\n\twidth: 100%;\n\tborder-radius: 5px;\n\t/* Set border color */\n\tpadding-left: 0px !important;\n}\n\n.custom-multiselect .p-multiselect {\n\tborder-color: rgba(74, 74, 74, 0.5);\n\n\t/* Ensure the border color of the multiselect is light gray */\n}\n\n.custom-multiselect .p-multiselect-label {\n\tcolor: #4B5563;\n\n\t/* Set the font color of the selected labels */\n}\n\n.custom-multiselect .p-multiselect-trigger {\n\tfont-size: 12px;\n\n\t/* Decrease the dropdown icon size */\n}\n\n.custom-multiselect .p-multiselect-filter-container .p-inputtext {\n\tcolor: rgba(74, 74, 74, 0.5);\n\t/* Set font color of the filter input */\n\tborder-color: #e7e6e6;\n\n\t/* Set border color of the filter input */\n}\n\n.custom-calendar {\n\tfont-size: 12px !important;\n\tcolor: rgba(74, 74, 74, 0.5) !important;\n}\n\n.p-calendar .p-inputtext {\n\tcolor: #4B5563;\n\tfont-size: 12px;\n}\n\n.risks-tab .p-inputtext.p-component {\n\tmargin-top: 0px !important;\n\twidth: 150px;\n\tfont-size: 12px;\n}\n\n.risks-tab .p-calendar .p-inputtext {\n\tcolor: #4B5563;\n\tfont-size: 12px;\n}\n\n.p-icon {\n\twidth: 0.6rem;\n\theight: 0.6rem;\n\tcolor: rgba(74, 74, 74, 0.5);\n}\n\n.p-row-editor-init .p-icon, .p-row-editor-save .p-icon, .p-row-editor-cancel .p-icon {\n\twidth: 13px;\n    height: 13px;\n    color: #495057;\n}\n\n.summary-input-text label,\n.summary-dropdown label {\n\twidth: 25%;\n\tmargin-right: 10px;\n\n}\n\n.summary-input-text input,\n.summary-dropdown input,\n.summary-input-text .input-element,\n.summary-dropdown .input-element,\n.summary-input-text .multi-select-element,\n.summary-dropdown .multi-select-element,\n.summary-input-text .single-select-element,\n.summary-dropdown .single-select-element {\n\twidth: 75%;\n}\n\n.summary-input-text,\n.summary-dropdown {\n\tdisplay: flex;\n\talign-items: space-between;\n\t/* background-color: red; */\n\twidth: 100%;\n}\n\n.selecting-dropdown {\n\twidth: 100%;\n\theight: 30px;\n}\n\n.display-row {\n\tdisplay: flex;\n\tflex-direction: row;\n\talign-items: center;\n\tmargin-top: 10px;\n}\n\n.font-bold {\n\tfont-weight: 600 !important;\n}\n\n.font-600 {\n\tfont-weight: 600 !important;\n}\n\n.display-end {\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\tmargin-top: 20px;\n}\n\n.display-center {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n}\n\n.w-130 {\n\twidth: 130px;\n\tpadding-top: 7;\n}\n\n.w-230 {\n\twidth: 230px;\n\tpadding-top: 7;\n}\n\n.w-280 {\n\twidth: 280px;\n\tpadding-top: 7;\n}\n\n.fs-12 {\n\tfont-size: 12px !important;\n}\n\n.portfolio-menu-scrollable {\n\twidth: 30%;\n\toverflow-y: auto;\n\toverflow-x: hidden;\n\tmax-height: 100vh;\n\t/* Adjust as needed */\n\tmargin-left: -20px;\n}\n\n.portfolio-menu-content-scrollable {\n\twidth: 70%;\n\toverflow-y: hidden;\n\toverflow-x: hidden;\n\tmax-height: 100vh;\n\t/* Adjust as needed */\n}\n\n.portfolio-menu-scrollable::-webkit-scrollbar,\n.portfolio-menu-content-scrollable::-webkit-scrollbar {\n\twidth: 0;\n\theight: 0;\n}\n\n/* Hide scrollbar for other browsers */\n.portfolio-menu-scrollable,\n.portfolio-menu-content-scrollable {\n\t-ms-overflow-style: none;\n\t/* IE and Edge */\n\tscrollbar-width: none;\n\t/* Firefox */\n}\n\n.pb-100 {\n\tpadding-bottom: 100px;\n}\n\n.max-height {\n\tmax-height: 100%;\n\tmargin-bottom: -100px;\n}\n\n.w-200 {\n\twidth: 200px;\n}\n\n.w-190 {\n\twidth: 190px;\n\tborder-color: 'white' !important;\n}\n\n.logoSize {\n\twidth: 150px;\n\theight: 50px;\n}\n\n.h-44 {\n\theight: 44px;\n\tmargin-left: 10x;\n}\n\n.p-relative {\n\tposition: relative;\n}\n\n.b-white {\n\tborder: white;\n}\n\n.s-field {\n\tbackground-color: white;\n\tborder: 1px solid #ccc;\n\tpadding: 10px;\n\tdisplay: flex;\n\tflex-direction: row;\n\tposition: absolute;\n\tz-index: 1000;\n\theight: 'auto';\n\tmargin-top: 5px;\n\twidth: 500px;\n\tright: 1px;\n\tborder-radius: 4px;\n}\n\n.fontWeigth-600 {\n\tfont-weight: 600;\n}\n\n.mt-3 {\n\tmargin-top: 3px;\n}\n\n.ml-10 {\n\tmargin-left: 10px;\n}\n\n.dilog-box {\n\tfont-size: 1.5rem;\n\tpadding-top: 4px;\n\tmargin-right: 5px;\n}\n\n.color-red {\n\tcolor: red;\n}\n\n.color-green {\n\tcolor: green;\n}\n\n.width-35 {\n\twidth: 35%;\n}\n\n.p-field-container {\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.p-label-container {\n\twidth: 280px;\n\tpadding-top: 7px;\n}\n\n.p-label {\n\twidth: 230px;\n\tpadding-top: 7px;\n\tfont-size: 12px;\n}\n\n.p-inputgroup-container {\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.p-field-switch-container {\n\tdisplay: flex;\n\talign-items: center;\n\tmargin-right: 10px;\n}\n\n.p-field-switch-text {\n\tfont-size: 12px;\n}\n\n.p-field-switch-text-left {\n\tmargin-left: 7px;\n}\n\n.p-field-switch-text-right {\n\tmargin-right: 7px;\n}\n\n.flex-container {\n\tdisplay: flex;\n\tflex-direction: row;\n\talign-items: center;\n}\n\n.summary-dropdown {\n\tmargin-top: 10px;\n\tmargin-right: 20px;\n}\n\n.summary-dropdown label {\n\tfont-weight: 600;\n}\n\n.summary-dropdown .dropdown-container {\n\tmargin-top: 5px;\n}\n\n.last-summary-dropdown {\n\tmargin-right: 0;\n}\n\n.app-container {\n\tdisplay: flex;\n\tflex-direction: row;\n\talign-items: center;\n\twidth: 100%;\n}\n\n.flex-1 {\n\tflex: 1;\n}\n\n.height-50 {\n\theight: 50px !important;\n}\n\n.width-100 {\n\twidth: 100%;\n\tbox-sizing: border-box;\n}\n\n.width-50 {\n\twidth: 50%;\n}\n\n.summary-input-text {\n\tdisplay: flex;\n\n\tmargin-top: 20px;\n}\n\n#score>span>input {\n\theight: 35px !important;\n}\n\n#score>span {\n\t/* height: 29px !important; */\n\talign-items: center;\n}\n\n#score>span>span {\n\t/* margin-top: -6px; */\n\theight: 35px;\n}\n\n.group-table-row tr:last-child td {\n\tborder: 0.5px solid #f8f9fa;\n}\n\n.p-inputnumber-input {\n\tfont-size: 12px\n}\n\n/*  This*/\n\n.custom-dropdown {\n\n\tfont-size: 12px !important;\n\n\t/* Use !important to override other styles */\n\n}\n\n.custom-multiselect {\n\n\tfont-size: 12px;\n\n\tcolor: rgba(74, 74, 74, 0.5);\n\n\t/* Set font color */\n\n\tborder-color: #e7e6e6;\n\n\t/* Set border color */\n\n}\n\n\n\n.custom-multiselect .p-multiselect {\n\n\tborder-color: rgba(74, 74, 74, 0.5);\n\n\t/* Ensure the border color of the multiselect is light gray */\n\n}\n\n.custom-multiselect .p-multiselect-trigger {\n\n\tfont-size: 12px;\n\n\t/* Decrease the dropdown icon size */\n\n}\n\n\n\n.custom-multiselect .p-multiselect-filter-container .p-inputtext {\n\n\tcolor: rgba(74, 74, 74, 0.5);\n\n\t/* Set font color of the filter input */\n\n\tborder-color: #e7e6e6;\n\n\t/* Set border color of the filter input */\n\n}\n\n\n\n.custom-calendar {\n\n\tfont-size: 12px !important;\n\n\tcolor: rgba(74, 74, 74, 0.5) !important;\n\n}\n\n.summary-input-text label,\n\n.summary-dropdown label {\n\n\twidth: 25%;\n\n\tmargin-right: 10px;\n\n}\n\n.summary-input-text input,\n\n.summary-dropdown input,\n\n.summary-input-text .input-element,\n\n.summary-dropdown .input-element,\n\n.summary-input-text .multi-select-element,\n\n.summary-dropdown .multi-select-element,\n\n.summary-input-text .single-select-element,\n\n.summary-dropdown .single-select-element {\n\n\twidth: 75%;\n\n}\n\n\n\n.summary-input-text,\n\n.summary-dropdown {\n\n\tdisplay: flex;\n\n\talign-items: center;\n\n}\n\n.p-inputtext {\n\tmargin-top: 0px !important;\n\twidth: 100%;\n\tfont-size: 12px;\n}\n\n.p-dialog-header-icons>button>svg {\n\theight: 1.4rem;\n\twidth: 1.4rem;\n\tcolor: #6B7280;\n}\n\n.p-disabled,\n.p-component:disabled {\n\t/* opacity: 0.5; */\n}\n\n.p-accordion .p-accordion-tab .p-accordion-header.p-disabled .p-accordion-header-link>* {\n\topacity: 1;\n}\n\n/* LOGIN PAGE CSS  */\n.login-Component {\n\tdisplay: flex;\n\twidth: 100%;\n\tjustify-content: center;\n\talign-items: center;\n\theight: 95.5vh;\n\tbackground-repeat: no-repeat;\n\tbackground-size: 100vw 100vh;\n}\n\n.login-container {\n\tposition: relative;\n\twidth: 30%;\n\theight: 60%;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\t/* box-shadow: -7px 0px 1px 1px rgba(0, 0, 0, 0.193); */\n\tborder-top-left-radius: 10px;\n\tborder-bottom-left-radius: 10px;\n\tborder: 1px solid #2A9235;\n\t/* box-shadow: 0 0px 10px 1px rgba(251, 250, 250, 0.278) */\n\t/* background-color: blue; */\n\n}\n\n.login-Image {\n\tmargin: 1rem;\n\ttext-align: center;\n}\n\n.side-image {\n\twidth: 30%;\n\theight: 60%;\n\t/* box-shadow: 0 0px 1px 0px rgba(0, 0, 0, 0.5); */\n\t/* box-shadow: 7px 0px 1px 1px rgba(0, 0, 0, 0.193); */\n\tbackground-color: rgb(192, 252, 192);\n\tbackground-color: #2A9235;\n\tborder-top-right-radius: 10px;\n\tborder-bottom-right-radius: 10px;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\t/* box-shadow: 0 0px 10px 1px rgba(0, 0, 0, 0.193) */\n\n\t/* background-color: blue; */\n}\n\n.login-page {\n\tdisplay: flex;\n\twidth: 70%;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: left;\n\theight: max-content;\n\n\n\n}\n\n.input-style {\n\twidth: 100%;\n\theight: 100%;\n\tborder: none;\n\tfont-size: 16px;\n\tbackground: none;\n\tmargin: 0 !important;\n\tpadding: 8px;\n\n}\n\n.input-design i {\n\tmargin: auto;\n\tfont-size: 16px;\n\topacity: 7px;\n}\n\n.input-style:hover {\n\tborder: none !important;\n\toutline: none !important;\n}\n\n.input-design {\n\tdisplay: flex;\n\talign-items: center;\n\tpadding: 8px;\n\tjustify-content: space-between;\n\tbackground-color: #f3f8f1;\n\n}\n\n.design-container {\n\tposition: absolute;\n}\n\n.triangle {\n\twidth: 0;\n\theight: 0;\n\tborder-left: 50px solid transparent;\n\tborder-right: 50px solid transparent;\n\tborder-bottom: 100px solid #f3f8f1;\n\tposition: relative;\n\tright: -352px;\n\tbottom: -198px;\n\topacity: 0.2;\n\ttransform: rotate(110deg);\n}\n\n.circle {\n\twidth: 100px;\n\theight: 100px;\n\tbackground-color: #f3f8f1;\n\tborder-radius: 50%;\n\tposition: relative;\n\tright: -410px;\n\tbottom: 100px;\n\topacity: 0.2;\n}\n\n.square {\n\tbackground-color: #f3f8f1;\n\tposition: relative;\n\tright: -273px;\n\tbottom: 258px;\n\topacity: 0.2;\n\twidth: 50px;\n\theight: 50px;\n\ttransform: rotate(580deg);\n}\n\n.rectangle {\n\tposition: relative;\n\twidth: 50px;\n\theight: 25px;\n\tbackground-color: #f3f8f1;\n\topacity: 0.2;\n}\n\n\n\n\n.input-style:enabled:focus {\n\tbox-shadow: none !important;\n\tborder: none !important;\n\n}\n\n.login-content {\n\tmargin: 0 0 3rem 0;\n}\n\n.login-content p {\n\tmargin: 2px;\n}\n\n.login-content h2 {\n\tmargin: 0;\n\tcolor: #2A9235;\n}\n\n.login-image {\n\twidth: 70%;\n\t/* mix-blend-mode: multiply; */\n\tmargin: auto;\n\ttext-align: center;\n\tmargin-bottom: 1rem;\n\t/* background-color: red; */\n\n\n}\n\n.submit-button {\n\tmargin-top: 1rem;\n\tmargin-bottom: 0.5rem;\n\tbackground-color: #2A9235;\n\toutline: none;\n\tborder: none;\n\tcursor: pointer;\n}\n\n.forget-password {\n\tmargin: 0;\n\tmargin-bottom: 1.5rem;\n\ttext-align: center;\n\tmargin-top: 2rem;\n}\n\n.loader-div {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 100%;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tbackground-color: rgba(255, 255, 255, 0.648);\n\tz-index: 1105;\n}\n\n.p-dialog-mask {\n\tz-index: 1001;\n}\n\n.progress-spinner {\n\twidth: 50px;\n\theight: 50px;\n}\n\n.loader-img {\n\twidth: 50px;\n\tmix-blend-mode: multiply;\n}\n\n.footer {\n\theight: max-content;\n\tmargin: 0;\n\tpadding: 0;\n}\n\n.footer-content {\n\theight: max-content;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: end;\n\tpadding: 0 1rem;\n\tfont-size: 14px;\n}\n\n.side-content {\n\tcolor: white;\n\ttext-align: center;\n}\n\n.side-content h2 {\n\tcolor: white;\n\tmargin: 1rem 0;\n\tfont-size: 40px;\n}\n\n/* FORGET PASSWORD CSS  */\n\n.forget-text {\n\tfont-size: 12px;\n}\n\n/* MFA CSS  */\n\n.mfa-container {\n\twidth: 100%;\n\theight: 100vh;\n\n}\n\n.emailConatiner {\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 50%;\n\ttransform: translate(-50%, -50%);\n\twidth: 40%;\n\theight: 50%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n\tborder-radius: 10px;\n\tbox-shadow: 0 0px 10px 1px rgba(0, 0, 0, 0.193);\n\n}\n\n.emailConatiner h2 {\n\tcolor: #2A9235;\n\tmargin-bottom: 0;\n\n}\n\n.lock-icon {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\twidth: 60px;\n\theight: 60px;\n\ttext-align: center;\n\tfont-size: 25px;\n\tcolor: white;\n\tbackground-color: #2A9235;\n\tborder-radius: 50%;\n\tpadding: 30px;\n}\n\n.emailConatiner p {\n\tmargin-top: 0;\n}\n\n.verify-button {\n\tbackground-color: #2A9235;\n\toutline: none;\n\tborder: none;\n\tmargin-top: 1rem;\n}\n\n.sent-otp-button {\n\tbackground-color: #2A9235;\n\toutline: none;\n\tborder: none;\n}\n\n.resend-otp-button {\n\tbackground-color: #2A9235;\n\toutline: none;\n\tborder: none;\n}\n\n.verify-input {\n\tmargin: 1rem auto;\n\twidth: 40%;\n\theight: 25%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n\talign-items: center;\n\n}\n\n.verify-input-field {\n\toutline: none;\n\tmargin: 0;\n\tmargin-top: 0px !important;\n}\n\n.p-inputtext:hover,\n.p-inputnumber-input:hover {\n\tborder: 1px solid #4B5563;\n}\n\n.p-dropdown-label.p-inputtext:hover {\n\tborder: none !important;\n}\n\n/* RESET PASSWORD CSS */\n\n.password-text {\n\tfont-size: 12px;\n}\n\n.reset-pasword-button {\n\tmargin-top: 1rem;\n\tbackground-color: #2A9235;\n}\n\n.p-button {\n\tborder: none;\n}\n\n/* SECURITY POLICIES */\n\n.mm {\n\theight: 500px;\n\tline-height: 500px;\n\ttext-align: center;\n}\n\nspan {\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tline-height: normal;\n}\n\n.readType {\n\tfont-size: 15px !important;\n\tborder: 0px !important\n}\n\n.row {\n\tmargin-right: 0px !important;\n\tmargin-left: 0px !important;\n\tmargin-top: 2%;\n}\n\n.section-heading {\n\ttext-align: center;\n\tcolor: #1E12B9;\n\tfont-weight: 400;\n\tfont-size: 25px;\n}\n\n.section-header {\n\tcolor: #1E12B9;\n}\n\n.logo-image img {\n\twidth: 150px;\n}\n\n.container-fluid {\n\tmargin-top: 2%;\n\tmargin: auto 10%;\n}\n\n.table {\n\tfont-family: Arial, Helvetica, sans-serif;\n\tborder-collapse: collapse;\n\twidth: 100%;\n}\n\n.table td,\n.table th {\n\tborder: 1px solid #ddd;\n\tpadding: 8px;\n}\n\n\n/* PROMPTS CSS  */\n.popup-save-button {\n\tbackground-color: #2A9235;\n}\n\n.p-datatable-wrapper {\n\tmax-height: none !important;\n\t/* height: 65vh !important; */\n}\n\n/* DATA TABLE CSS  */\n.p-column-header-content {\n\tcolor: #2A9235;\n\tfont-weight: 500 !important;\n}\n\n.test:hover {\n\tcolor: blue;\n\ttext-decoration: underline;\n\tcursor: pointer;\n}\n\n/* Change the background color of the checkbox */\n.p-checkbox-box .p-checkbox-icon {\n\tbackground-color: #19486B !important;\n\tcolor: white;\n}\n\n/* Change the border color of the checkbox */\n.p-checkbox-box {\n\tborder: 0.5px solid #D1D5DB !important;\n\twidth: 15px !important;\n\theight: 15px !important;\n\tmargin-top: 1px;\n}\n\n.p-checkbox-icon {\n\twidth: 100%;\n\theight: 100%;\n\tpadding: 2px;\n}\n\n\n/* RESPONSIVE UI  */\n\n@media only screen and (max-width: 600px) {\n\n\t/* LOGIN PAGE CSS  */\n\n\t.login-container {\n\t\twidth: 100%;\n\t\tborder: none;\n\t\tborder-top-right-radius: 10px;\n\t\tborder-bottom-right-radius: 10px;\n\t}\n\n\t.side-image {\n\t\tdisplay: none;\n\t}\n\n\t.emailConatiner {\n\t\twidth: 100%;\n\t\tbox-shadow: none;\n\t}\n\n\n}\n\n@media only screen and (min-device-width: 601px) and (max-device-width: 1200px) and (-webkit-min-device-pixel-ratio: 1) {\n\n\t.login-container {\n\t\twidth: 60%;\n\t\tborder-top-right-radius: 10px;\n\t\tborder-bottom-right-radius: 10px;\n\t}\n\n\t.side-image {\n\t\tdisplay: none;\n\t}\n\n\t.emailConatiner {\n\t\twidth: 100%;\n\t\tbox-shadow: none;\n\t}\n}\n\n\n/* Tab view */\n.p-menuitem-link {\n\t/* border-color:#19486B; */\n\tcolor: #19486B;\n\ttext-decoration: none !important;\n\twhite-space: nowrap;\n}\n\n.p-tabmenu-ink-bar {\n\tbackground-color: #19486B;\n}\n\n.p-tabmenu .p-tabmenu-nav .p-tabmenuitem.p-highlight .p-menuitem-link {\n\tborder-color: #19486B;\n\tcolor: #19486B\n}\n\n\n\n\n.search-wrapper {\n\tposition: relative;\n\twidth: 100%;\n\tmax-width: 400px;\n}\n\n.search-input {\n\tpadding-left: 2.5rem;\n\t/* Adjust this value based on icon size */\n\tpadding-right: 2.5rem;\n\t/* Adjust this value based on button size */\n\twidth: 100%;\n}\n\n.p-input-icon-left {\n\tdisplay: flex;\n\talign-items: center;\n\tposition: relative;\n}\n\n.p-input-icon-left>.pi-search {\n\tposition: absolute;\n\tleft: 0.75rem;\n\t/* Adjust this value for desired left padding */\n\ttop: 50%;\n\ttransform: translateY(-50%);\n\tpointer-events: none;\n}\n\n.p-input-icon-right {\n\tdisplay: flex;\n\talign-items: center;\n\tposition: relative;\n}\n\n.cancel-button {\n\tposition: absolute;\n\tright: 0.75rem;\n\ttop: 50%;\n\ttransform: translateY(-50%);\n\tborder: none;\n\tbackground: transparent;\n\tcolor: var(--text-color-secondary);\n}\n\n.cancel-button:focus {\n\toutline: none;\n\t/* Remove outline on focus */\n\tbox-shadow: none;\n\t/* Remove any box-shadow */\n}\n\n/* Sidebar & Header */\n\n.sidebar {\n\tbackground: #FAFAFA;\n\t/* border-radius: 4px !important; */\n\t/* border: none !important; */\n\tborder-right: 0.5px solid rgba(0, 0, 0, 0.1);\n\theight: 100vh;\n\toverflow: hidden;\n}\n\n.sidebarMenu {\n\theight: 84vh;\n\toverflow-y: auto;\n\t/* border-right: 0.5px solid rgba(0, 0, 0, 0.1); */\n}\n\n.border-sidebar {\n\t/* border-right: 0.5px solid rgba(0, 0, 0, 0.1); */\n\tposition: fixed;\n    bottom: 0;\n    left: 0;\n    padding: 15px 0px 15px 28px;\n    width: 12.5%;\n\tz-index: 1;\n    background: #FAFAFA;\n\tborder-top: 0.5px solid rgba(0, 0, 0, 0.1);\n}\n\n.sidebar a {\n\ttext-decoration: none;\n}\n\n.sidebarMenu ol,\nul {\n\tpadding-left: 0px !important;\n}\n\n.sidebarMenuClosed {\n\theight: 84vh;\n\t/* border-right: 0.5px solid rgba(0, 0, 0, 0.1); */\n}\n\n.d-flex {\n\tdisplay: flex !important;\n}\n\n.justify-between {\n\tjustify-content: space-between;\n}\n\n.font-normal {\n\tfont-weight: normal;\n}\n\n.font-white {\n\tcolor: #4B5563;\n}\n\n.fs-14 {\n\tfont-size: 14px;\n}\n\n.mar-b-4 {\n\tmargin-bottom: 4px !important;\n}\n\n.ml-10 {\n\tmargin-left: 10px !important;\n}\n\n.ml-14 {\n\tmargin-left: 14px !important;\n}\n\n.m-0 {\n\tmargin: 0px !important;\n}\n\n.pointer {\n\tcursor: pointer;\n}\n\n@media only screen and (min-width: 769px) {\n\n\t.menu-icon,\n\t.close-sidebar {\n\t\tdisplay: none;\n\t}\n\n\t.content {\n\t\t/* padding: 15px; */\n\t\tmargin-left: 240px;\n\t\theight: 100vh;\n\t\toverflow: hidden auto;\n\t}\n\n\t.contentClosed {\n\t\tmargin-left: 62px;\n\t\theight: 100vh;\n\t\toverflow: hidden auto;\n\t}\n\n\t.header-content {\n\t\tbackground-color: #FAFAFA;\n\t\tborder-bottom: 0.5px solid rgba(0, 0, 0, 0.1);\n\t\tposition: sticky;\n        top: 0;\n\t\tz-index: 2;\n\t}\n\n\t.outlet-content {\n\t\tpadding: 0px 15px 15px 15px;\n\t\toverflow-y: auto;\n        height: 100%;\n\t}\n\n\t.sidebar {\n\t\twidth: 240px;\n\t\tfloat: left;\n\t}\n\n\t.sidebar.sidebarClosed {\n\t\twidth: 62px;\n        border-right: 0.5px solid rgba(0, 0, 0, 0.1);\n\t}\n\n\t.sidebar .sidenavClosed {\n\t\twidth: 62px;\n        border-right: 0.5px solid rgba(0, 0, 0, 0.1);\n\t}\n\n\t.p-dialog {\n\t\twidth: 40% !important;\n\t}\n\n\t.resource-planner .p-dialog {\n\t\twidth: 60% !important;\n\t\theight: 60% !important;\n\t}\n\n\t#surveyDialogView {\n\t\twidth: 80% !important;\n\t}\n\n\t#travelApproval {\n\t\twidth: 50% !important;\n\t}\n\n\t#visaApproval {\n\t\twidth: 53% !important;\n\t}\n}\n\n@media only screen and (max-width: 768px) {\n\t.sidebar {\n\t\tdisplay: none;\n\t\tposition: absolute;\n\t\tz-index: 2;\n\t\twidth: 186px;\n\t\tborder-right: 0.5px solid rgba(0, 0, 0, 0.1);\n\t}\n\n\t.menu-icon {\n\t\tdisplay: block;\n\t}\n\n\t.show {\n\t\tdisplay: block !important;\n\t}\n\n\t.hide {\n\t\tdisplay: none !important;\n\t}\n\n\t.hideMenuIcon {\n\t\tvisibility: hidden !important;\n\t}\n\n\t.close-sidebar {\n\t\tposition: fixed;\n\t\ttop: 20px;\n\t\tleft: 150px;\n\t}\n\n\t.close-sidebar .navIcon {\n\t\tcolor: #4B5563;\n\t}\n\n\t.navIcon {\n\t\tfont-size: 24px;\n\t\tcolor: #000000;\n\t}\n\n\t.p-breadcrumb {\n\t\tpadding: 0px !important;\n\t}\n\n\t.content {\n\t\twidth: 100%;\n\t\tpadding: 22px;\n\t}\n\n\t.outlet-content {\n\t\tpadding: 0px 15px 15px 15px;\n\t}\n\n\t.p-input-icon-left>.p-inputtext {\n\t\twidth: 50% !important;\n\t}\n\n\t.orderlist-demo .p-input-icon-left>.p-inputtext {\n\t\twidth: 100% !important\n\t}\n\n\t.p-dialog {\n\t\twidth: 70% !important;\n\t}\n}\n\n.p-icon.p-submenu-icon {\n\tposition: absolute !important;\n\tcolor: #4B5563;\n\tright: -3px !important;\n\tfont-size: 7px;\n}\n\n.p-panelmenu-content {\n\tborder: none;\n\tmargin-left: 15px;\n\tbackground-color: #FAFAFA;\n}\n\n.header-label {\n\tcolor: #2A9235;\n\tfont-weight: 600;\n\tfont-size: 20px;\n}\n\n.header-class .p-input-icon-left i {\n\tmargin-left: 0px !important;\n}\n\n.header-class {\n\tbackground-color: #FAFAFA;\n}\n\n.top-add-button {\n\theight: 34px;\n\t/* margin-top: -1px; */\n\tbackground-color: #243137;\n\tborder-radius: 4px;\n}\n\n.top-add-button .p-button-icon {\n\tfont-size: 13px;\n}\n\n.search-bar {\n\tcolor: #4B5563;\n\tfont-size: 13px;\n\twidth: 100%;\n}\n\n.sidebarMenu a:hover,\n.sidebarMenuClosed a:hover {\n\tcolor: transparent;\n}\n\n.p-menuitem.p-focus .p-menuitem-link,\n.sidebarMenu .p-panelmenu-header:active, .active-menu-item .p-menuitem-link {\n\t/* background-color: #5EBD6826 !important; */\n\tcolor: #4A4A4A !important;\n\ttext-decoration: none;\n}\n\n.active-menu-item .p-panelmenu-header-content, .p-submenu-list .active-menu-item .submenu-link, .p-menu .p-menuitem:not(.p-highlight):not(.p-disabled) > .p-menuitem-content:hover {\n\tbackground-color: #5EBD6826 !important;\n\tborder-left: 3px solid #5EBD68;\n\theight: max-content;\n}\n\n.p-menubar .p-menubar-root-list > .p-menuitem:not(.p-highlight):not(.p-disabled) > .p-menuitem-content:hover, .p-menubar .p-menuitem:not(.p-highlight):not(.p-disabled).p-focus > .p-menuitem-content, .p-panelmenu .p-panelmenu-content .p-menuitem:not(.p-highlight):not(.p-disabled).p-focus > .p-menuitem-content, .p-panelmenu .p-panelmenu-content .p-menuitem:not(.p-highlight):not(.p-disabled) > .p-menuitem-content:hover {\n\tbackground: none !important;\n}\n\n.p-menu {\n\tpadding: 0px;\n\tbackground: transparent;\n    color: transparent;\n    border: none;\n    border-radius: 0px;\n\tcursor: pointer;\n}\n\n.active-menu-item .p-menuitem-text, .active-menu-item .p-menuitem-icon, .active-menu-item .p-menuitem.p-focus .p-menuitem-icon,\n.active-menu-item .p-menuitem.p-focus .p-menuitem-text {\n\tcolor: #4A4A4A !important;\n\ttext-decoration: none;\n}\n\n.p-menuitem.p-focus .p-menuitem-icon,\n.p-menuitem.p-focus .p-menuitem-text {\n\t/* color: #FFFFFF !important; */\n}\n\n\n\n::-webkit-scrollbar {\n\twidth: 5px;\n\theight: 5px;\n}\n\n::-webkit-scrollbar-track {\n\t-webkit-box-shadow: inset 0 0 6px rgba(156, 26, 26, 0.1);\n\tborder-radius: 10px;\n}\n\n::-webkit-scrollbar-thumb {\n\tborder-radius: 10px;\n\t-webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);\n}\n\n.sidebar-footer {\n\tmargin-left: 0px !important;\n\tmargin-right: 18px !important;\n}\n\n.sidebar-footer:before {\n\tcontent: \"\";\n\ttop: 100%;\n\twidth: 100%;\n\theight: .5px;\n\tbackground: linear-gradient(43deg, rgba(255, 255, 255, 0) 2%, rgba(255, 255, 255, 0.7) 50%, rgba(255, 255, 255, 0) 99%);\n\tmargin-top: -10px;\n\tdisplay: block;\n}\n\n.sidenav {\n\ttransition: width 0.3s ease-in-out;\n\theight: 100vh;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n\t/* border-right: 0.5px solid rgba(0, 0, 0, 0.1); */\n}\n\n.sidenavClosed {\n\ttransition: width 0.3s ease-in-out;\n\twidth: 60px\n}\n\n.form-label {\n\tfont-size: 14px;\n\tcolor: #4B5563 !important;\n}\n\n.form-label-text {\n\tfont-size: 13px;\n\tcolor: #0467ae !important;\n}\n\n.p-inputwrapper:hover {\n\tborder: 1px solid green;\n}\n\n.p-inputwrapper:focus {\n\tborder: 1px solid green;\n}\n\n.p-inputwrapper:active {\n\tborder: 1px solid green;\n}\n\n.p-dropdown:not(.p-disabled).p-focus {\n\tbox-shadow: unset !important;\n\tborder: 1px solid green;\n}\n\n.radio-buttons-row {\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.field-radiobutton {\n\tdisplay: flex;\n\talign-items: center;\n\tmargin-right: 1rem;\n}\n\n.field-checkbox,\n.field-radiobutton {\n\tmargin-bottom: 0px !important;\n}\n\n.field-radiobutton label {\n\tmargin-left: 0.5rem;\n\tpadding-top: 5px;\n}\n\n.pi-plus::before {\n\tfont-size: 12px;\n}\n\n.p-inputnumber-button-down {\n\twidth: 15px;\n}\n\n.p-inputnumber-button-up {\n\talign-items: center;\n\tmargin-top: 7px;\n\twidth: 15px;\n}\n\n.p-dialog-header-icons>button>svg {\n\theight: 16px;\n\twidth: 16px;\n}\n\n.p-dialog .p-dialog-header .p-dialog-title {\n\tfont-size: 18px !important;\n\tcolor: #0467AE;\n}\n\n.timesheet-buttons .p-inputtext {\n\tpadding: 6px 9px;\n}\n\n.timesheet-buttons .p-button {\n\tborder-radius: 3px;\n\tpadding: 8px 8px;\n}\n\n.p-button:focus {\n\tbox-shadow: unset;\n}\n\n.p-button:focus {\n\toutline: #19486B;\n}\n\n.button:focus {\n\toutline: 5px auto #19486B;\n}\n\n.p-dialog .p-dialog-header-icons {\n\tborder: unset !important;\n\tbox-sizing: unset !important\n}\n\n/* Dialog */\n\n.p-dialog-header {\n\tpadding: 14px 14px 10px 14px;\n}\n\n.p-dialog-content {\n\tpadding: 10px 14px 14px 14px;\n}\n\n.new-field .p-inputtext {\n\tborder-color: #E5E7EB;\n\theight: 30px;\n\tborder-radius: 2px;\n}\n\n.new-field .p-dropdown {\n\tborder-color: #E5E7EB;\n\tborder-radius: 2px;\n}\n\n.new-field .p-dropdown-label.p-inputtext {\n\theight: max-content !important;\n}\n\n.new-field .p-inputtext.error-tab, .p-dropdown.error-tab, .p-inputtext.error-tab {\n\tborder-color: red !important;\n}\n\n.new-field .p-inputtextarea {\n\tborder-color: #E5E7EB;\n\theight: 56px;\n\tborder-radius: 2px;\n}\n\n.button-portfolio {\n\tborder: 1px solid #B2B2B2 !important;\n\tmargin-left: 20px;\n}\n\n.new-field .p-inputnumber-button-group {\n\tdisplay: none;\n}\n\n.radio-buttons-row {\n\tfont-size: 12px;\n}\n\n.label-text {\n\tfont-weight: 500;\n\tfont-size: 18px;\n\tcolor: #374151;\n}\n\n.sub-label-text {\n\tfont-weight: 500;\n\tfont-size: 18px;\n\tcolor: #218a31;\n}\n\n.new-option-button {\n\theight: 35px;\n\twidth: 127px;\n\tpadding: 11px;\n\tfont-size: 12px;\n\tbackground-color: unset;\n\tcolor: rgb(25, 72, 107);\n\tborder: 1px solid #19486B;\n\tborder-radius: 4px;\n}\n\n.new-option-button .p-button-icon {\n\tcolor: #19486B;\n\tfont-weight: 500;\n\tmargin-right: 7px;\n\tmargin-bottom: 2.5px;\n}\n\n.new-option-button .p-button-label {\n\tcolor: #19486B;\n\tfont-size: 14px;\n\tfont-weight: 500;\n}\n\n.edit-option-button {\n\theight: 35px;\n\twidth: 38px;\n\tpadding: 11px;\n\tfont-size: 12px;\n\tbackground-color: unset;\n\tcolor: rgb(25, 72, 107);\n\tborder: 1px solid #19486B;\n\tborder-radius: 4px;\n}\n\n.edit-option-button .p-button-icon {\n\tcolor: #19486B !important;\n\tfont-weight: 500;\n\tmargin-bottom: 1.5px;\n\tfont-size: 14px;\n}\n\n.edit-option-button .p-button-label {\n\tcolor: #19486B;\n\tfont-size: 14px;\n\tfont-weight: 500;\n}\n\n.group-table-component .p-button-label {\n\tcolor: #FFFFFF;\n\tfont-weight: 500;\n\tfont-size: 14px;\n}\n\n.group-table-component .new-button .p-button-label {\n\tcolor: #FFFFFF;\n\tfont-weight: 500;\n\tfont-size: 14px;\n\tmargin-left: 5px;\n}\n\n.group-table-component .p-button-icon {\n\tfont-size: 13px;\n\tcolor: #FFFFFF;\n}\n\n.new-field .header-datatable,\n.new-field .p-editable-column,\n.group-table-component .header-datatable,\n.group-table-component .p-editable-column {\n\ttext-align: left !important;\n\t/* width: 14em; */\n\tpadding: 8px 10px !important;\n\tfont-size: 14px;\n}\n\n.group-table-component .row-datatable,\n.new-field .row-datatable {\n\ttext-align: left;\n\t/* width: 14em; */\n\tpadding: 8px 10px !important;\n\tfont-size: 12px;\n\tcursor: pointer;\n}\n\n.group-table-component .p-input-icon-left i {\n\tmargin-left: 16px !important;\n}\n\n.new-field .p-column-header-content {\n\tfont-size: 14px;\n\tfont-weight: 400;\n}\n\n.new-field .p-datatable-tbody .p-inputtext {\n\tfont-size: 12px;\n\tpadding-left: 10px;\n\tcolor: #4B5563;\n\theight: 33px;\n}\n\n.cancel-new-button {\n\tbackground-color: #fff;\n\tborder: 1px solid #19486B;\n\tborder-radius: 4px;\n\theight: 40px;\n\tcolor: #19486B;\n\tfont-size: 13px;\n}\n\n.save-button {\n\tbackground-color: #19486B;\n    border: 1px solid #19486B;\n    border-radius: 4px;\n    height: 40px;\n    margin-left: 20px;\n}\n\n.add-button-portfolio {\n\tbackground-color: #19486B;\n\tborder: 1px solid #19486B;\n\tborder-radius: 4px;\n\theight: 31px;\n\tmargin-left: 18px;\n}\n\n.add-button-summary {\n\tbackground-color: #19486B;\n\tborder: 1px solid #19486B;\n\tborder-radius: 4px;\n\theight: 31px;\n\tmargin-left: 8px;\n\tpadding: 8px !important;\n}\n\n.save-button-add {\n\tbackground-color: #19486B;\n    border: 1px solid #19486B;\n    border-radius: 4px;\n    height: 33px;\n    margin-left: 20px;\n}\n\n.p-button-label {\n\tfont-size: 14px;\n}\n\n.cancel-footer .cancel-new-button .p-button-label {\n\tcolor: #19486B;\n\tfont-size: 14px;\n\tfont-weight: 500;\n}\n\n.delete-icon .cancel-new-button .p-button-icon,\n.approve-button.p-button .p-button-label {\n\tcolor: #19486B;\n\tfont-size: 14px;\n\tfont-weight: 500;\n}\n\n.approve-button {\n\tbackground-color: #FFFFFF;\n\tborder: 1px solid #19486B;\n\tborder-radius: 4px;\n\theight: 30px;\n}\n\n.cancel-footer .save-button .p-button-label {\n\tcolor: #FFFFFF;\n\tfont-size: 14px;\n\tfont-weight: 500;\n}\n\n.cancel-footer .save-button.p-disabled .p-button-label {\n\tcolor: #19486B;\n\tfont-size: 14px;\n\tfont-weight: 500;\n}\n\n.p-radiobutton.p-highlight .p-radiobutton-box {\n\tborder-color: #19486B;\n\tbackground: #19486B;\n}\n\n.p-radiobutton .p-radiobutton-input:hover {\n\tborder-color: #19486B;\n}\n\n.new-field .md\\:w-14rem {\n\twidth: 10.3rem !important;\n}\n\n.pi-check-circle {\n\tcolor: #2A9235 !important;\n\tfont-size: 13px !important;\n}\n\n/* Toaster CSS */\n\n.p-toast .p-toast-message {\n\tbackground: #fff !important;\n\theight: 46px;\n\tborder: none;\n}\n\n.p-toast-summary {\n\tcolor: #304563;\n\tline-height: 24px;\n}\n\n.p-toast-detail {\n\tfont-style: normal;\n\tfont-weight: normal;\n\tfont-size: 14px;\n\tline-height: 21px;\n\tcolor: #304563;\n\tmargin: 0 !important;\n}\n\n.p-toast-message-content {\n\talign-items: center !important;\n\theight: 20px;\n\tpadding: 6px;\n}\n\n.p-toast-message-text {\n\tmargin-left: 22px !important;\n}\n\n.p-toast-message-content:before {\n\tposition: absolute;\n\twidth: 4px;\n\theight: 38px;\n\tcontent: \"\\2223\";\n\tleft: 6px;\n\tborder-radius: 6px;\n\ttop: 4px;\n\tcolor: #7CCAAE;\n\tbackground: #7CCAAE;\n}\n\n.p-toast-message-success .p-toast-message-content:before {\n\tcolor: #7CCAAE;\n\tbackground: #7CCAAE;\n}\n\n.p-toast-message-error .p-toast-message-content:before {\n\tcolor: red;\n\tbackground: red;\n}\n\n.p-toast-message-icon {\n\tpadding-left: 8px;\n\tcolor: #fff !important;\n}\n\n.p-toast-message-icon::before {\n\twidth: 24px;\n\theight: 24px;\n\tdisplay: block;\n\tborder-radius: 50%;\n\ttext-align: center;\n\tfont-size: 14px;\n\tline-height: 1.5;\n}\n\n.p-toast-message-success .p-toast-message-icon::before {\n\tcontent: \"\\2714\";\n\tbackground: #7CCAAE;\n}\n\n.p-toast-message-error .p-toast-message-icon::before {\n\tcontent: \"\\2715\";\n\tbackground: red;\n}\n\n.p-toast-icon-close-icon {\n\tcolor: #304563;\n\tfont-size: 16px !important;\n}\n\n.p-toast-icon-close {\n\tmargin-top: 26px;\n}\n\n/* Tab View */\n\n.vertical-tabview .p-tabview {\n\tdisplay: flex;\n\tflex-direction: row;\n}\n\n.vertical-tabview .p-tabview-nav {\n\tflex-direction: column;\n\tmin-width: 150px;\n\t/* border-right: 1px solid #ccc; */\n}\n\n.vertical-tabview .p-tabview-panels {\n\tflex-grow: 1;\n}\n\n.p-tabview-title {\n\tcolor: #4B5563;\n\tfont-size: 14px;\n}\n\n.portfolio-tabs .p-tabview-title {\n\tcolor: #4A4A4A;\n\tfont-size: 13px;\n\tmargin-left: 11px;\n\tfont-weight: normal;\n}\n\n.p-tabview-nav-link,\n.p-tabview-nav-link:hover {\n\ttext-decoration: none;\n}\n\n.p-tabview-selected.p-highlight a {\n\tcolor: transparent;\n}\n\n.portfolio-tabs .p-tabview-selected.p-highlight a,\n.portfolio-tabs a {\n\tcolor: #19486B !important;\n}\n\n.p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link {\n\tborder-color: #19486B !important;\n}\n\n.custom-tabview.p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link {\n\tborder: none !important;\n\tbackground-color: #5EBD6826;\n}\n\n.custom-tabview .p-tabview-selected.p-highlight {\n\tborder-left: 3px solid #5EBD68;\n}\n\n.custom-tabview.p-tabview .p-tabview-nav li .p-tabview-nav-link {\n\tborder: none !important;\n}\n\n.custom-tabview.p-tabview .p-tabview-nav {\n\tborder-bottom: none !important;\n}\n\n.custom-tabview .p-tabview-selected.p-highlight.error-tab {\n\tborder-left: 3px solid red;\n}\n\n.custom-tabview .p-tabview-nav-link {\n\tpadding: 12px !important;\n}\n\n.p-tabview .p-tabview-nav li.p-highlight.error-tab .p-tabview-nav-link {\n\tborder-color: red !important;\n}\n\n.error-tab .p-menu {\n\tborder-left: 3px solid red !important;\n}\n\n.active-menu-item .p-menu {\n    border-left: 3px solid #5EBD68 !important;\n}\n\n.custom-tabview .p-tabview-nav {\n\tflex-direction: column;\n\tborder-left: 1px solid #5EBD6840;\n\tmargin-top: 20px;\n}\n\n.portfolio-tabs .p-tabview-selected.p-highlight.error-tab a, .portfolio-tabs .p-tabview-selected.p-highlight.error-tab .p-tabview-title, .portfolio-tabs .error-tab a, .portfolio-tabs .error-tab .p-tabview-title {\n\tcolor: red !important;\n}\n\n.p-tabview .p-tabview-nav .p-tabview-ink-bar {\n\tbackground-color: transparent;\n}\n\n.vertical-tabview .p-tabview-nav-container {\n\tborder-right: 1px solid #ccc;\n}\n\n.bread-crumb {\n\tfont-size: 14px;\n\tcolor: green;\n\tfont-weight: 500;\n\tmargin-bottom: 0px;\n}\n\n.b-bottom {\n\tborder-bottom: 1px solid #4B5563;\n}\n\n.p-accordion-header.p-highlight a,\n.p-accordion-header.p-highlight .p-icon,\n.p-accordion-header a,\n.p-accordion-header .p-icon {\n\tcolor: #243137 !important;\n\ttext-decoration: none;\n\tborder-bottom: 1px solid #5EBD6859 !important;\n}\n\n.custom-tabview.p-tabview .p-toggleable-content {\n\tmargin-top: 10px;\n}\n\n.p-accordion .p-accordion-header .p-accordion-header-link,\n.p-accordion-content {\n\tpadding: 10px;\n    width: 100%;\n\tborder: none;\n}\n\n.custom-tabview .p-tabview-panels {\n\tpadding: 10px;\n    border: 1px solid #2A923540;\n    border-radius: 3px;\n    margin-left: 20px; \n    margin-top: 15px;\n    flex-grow: 1; \n    overflow: auto; \n    min-width: 0; \n}\n\n.p-accordion-content .p-md-4 {\n\tpadding: 0px !important;\n}\n\n.p-tabview-nav {\n\tmargin-bottom: 5px;\n}\n\n.p-inputswitch {\n\twidth: 40px;\n\theight: 23px;\n}\n\n.p-inputswitch .p-inputswitch-slider:before {\n\twidth: 20px;\n\theight: 20px;\n\tleft: 0px;\n\tmargin-top: -10px;\n}\n\n.p-inputswitch.p-highlight .p-inputswitch-slider {\n\tbackground: #19486B !important;\n}\n\n.table-dialog .p-dialog-title {\n\tcolor: #182233;\n\tfont-weight: 500;\n}\n\n.table-dialog .table-description {\n\tcolor: #182233;\n\tfont-weight: 400;\n\tfont-size: 14px;\n}\n\n.p-dialog-header-icons>button>svg {\n\tcolor: #182233;\n}\n\n.p-datatable-header,\n.p-datatable .p-datatable-thead>tr>th {\n\t/* text-align: center; */\n\tpadding: 8px 10px !important;\n\tfont-size: 14px;\n\tcolor: #2A9235;\n\tfont-weight: 500 !important;\n}\n\n.data-submit .p-datatable-header, .p-datatable .p-datatable-thead > tr > th {\n\ttext-align: center;\n}\n\n.p-datatable .p-datatable-tbody>tr>td {\n\tpadding: 8px 10px !important;\n\tfont-size: 12px;\n}\n\n.p-datatable-emptymessage {\n\tcolor: #495057;\n\tfont-size: 13px;\n}\n\n.p-selectbutton .p-button.p-highlight,\n.p-selectbutton .p-button:focus.p-highlight {\n\tbackground: #19486B !important;\n\tborder-color: #19486B !important;\n}\n\n.p-selectbutton .p-button,\n.p-selectbutton .p-button:focus {\n\tborder: 1px solid #4B5563;\n}\n\n.p-selectbutton .p-button .p-button-label {\n\tcolor: #4B5563;\n\tfont-size: 12px;\n}\n\n.p-selectbutton .p-button.p-highlight .p-button-label {\n\tcolor: #FFFFFF;\n\tfont-size: 12px;\n}\n\n.p-input-icon {\n\tcolor: #19486B;\n    font-size: 16px;\n    margin-left: 10px;\n}\n\n.p-input-icon.angle-sidebar {\n\tposition: absolute;\n    top: 26px;\n    left: 219px;\n    background-color: #2A9235 !important;\n    border-radius: 50%;\n    width: 21px;\n    height: 21px;\n\tz-index: 3;\n}\n\n.angle-sidebar:before {\n\tpadding: 4px !important;\n    font-size: 12px !important;\n    color: white !important;\n}\n\n.p-input-icon.angle-right-sidebar {\n\tposition: absolute;\n    top: 26px;\n    left: 41px;\n    background-color: #2A9235 !important;\n    border-radius: 50%;\n    width: 21px;\n    height: 21px;\n\tz-index: 3;\n}\n\n.angle-right-sidebar:before {\n\tpadding: 5px !important;\n    font-size: 12px !important;\n    color: white !important;\n}\n\n.tab-element-wrapper {\n\tposition: relative;\n}\n\n.icon-container {\n\tposition: absolute;\n    top: 1%;\n    left: 176px;\n    transform: translateY(-50%);\n    z-index: 10;\n}\n\n.icon-left-container {\n\tposition: absolute;\n    top: 1%;\n    left: 41px;\n    transform: translateY(-50%);\n    z-index: 10;\n}\n\n.p-input-icon.angle-portfolio {\n    background-color: rgba(94, 189, 104, 1) !important;\n    border-radius: 50%;\n    width: 21px;\n    height: 21px;\n}\n\n.angle-portfolio:before {\n\tpadding: 4px !important;\n    font-size: 12px !important;\n    color: white !important;\n}\n\n/* Date Picker */\n\n.p-datepicker {\n\twidth: 339px !important;\n}\n\n.p-datepicker table th {\n\tfont-weight: 600;\n}\n\n.p-datepicker-header,\n.p-datepicker table th,\n.p-datepicker table td {\n\tpadding: 2px;\n\ttext-align: center;\n}\n\n.p-datepicker table th>span,\n.p-datepicker table td>span {\n\tcolor: #4B5563;\n\tfont-size: 14px;\n}\n\n.p-inputwrapper:hover {\n\tborder: 1px solid #19486B;\n}\n\n.p-inputtext:enabled:focus {\n\tbox-shadow: none !important;\n\tborder-color: #19486B !important;\n}\n\n.checkbox-label {\n\tmargin-bottom: 0px !important;\n\tfont-size: 14px;\n}\n\n/* login Vikas */\n.mc-input {\n\tborder-bottom: 1px solid #FFC42A;\n\tborder-right: unset;\n\tborder-top: unset;\n\tborder-left: unset;\n\tborder-radius: 0px;\n\tfont-size: 14px;\n\tpadding-left: 0px;\n\tpadding-bottom: 12px;\n}\n\n.mc-input:hover {\n\tbox-shadow: none;\n\toutline: none;\n\tborder: none;\n\tborder-bottom: 1px solid #FFC42A;\n}\n\n.mc-input:focus {\n\tbox-shadow: unset !important;\n\toutline: none !important;\n\tborder: none !important;\n\tborder-bottom: 1px solid #FFC42A !important;\n}\n\n.mc-input:enabled:focus {\n\tbox-shadow: unset !important;\n\toutline: none !important;\n\tborder: none !important;\n\tborder-bottom: 1px solid #FFC42A !important;\n\tfont-size: 14px;\n\n}\n\n.mc-input::placeholder {\n\tfont-size: 14px;\n\tcolor: #2A9235;\n\n}\n\n.welcome-heading {\n\tcolor: #2A9235;\n}\n\n.forgot-password {\n\tcolor: #001F54;\n\ttext-decoration: none;\n\tfont-size: 12px;\n\tbackground: none !important;\n}\n\n.forgot-password:hover {\n\ttext-decoration: underline;\n}\n\n.forgot-password:focus {\n\tborder: unset;\n\tbox-shadow: unset;\n}\n\n.login-btn {\n\tbackground-color: #2A9235;\n\tborder: 1px solid #2A9235;\n\tcolor: #fff;\n}\n\n.login-btn:hover {\n\tbackground-color: #218a31;\n\tborder-color: #218a31;\n}\n\n.p-button.p-button-help:not(:disabled):focus {\n\tbox-shadow: unset;\n}\n\n.gradient-bg {\n\tbackground: linear-gradient(#2A9235 0%, #007882 100%);\n\theight: 100vh !important;\n}\n\n.box-border {\n\tbox-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);\n\tmargin-bottom: 0;\n\tborder-radius: 4px;\n\tposition: relative;\n\ttransition: margin-bottom 225ms;\n\tpadding: 10px;\n\theight: 400px;\n\toverflow-y: scroll;\n}\n\n.border-service {\n\tborder-bottom: 1px solid #dee2e6;\n}\n\n.box-border-plan {\n\tbox-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);\n\tmargin-bottom: 0;\n\tborder-radius: 4px;\n\tposition: relative;\n\ttransition: margin-bottom 225ms;\n\tpadding: 10px;\n\theight: 300px;\n\toverflow-y: scroll;\n}\n\n.stakeholder .p-tabmenu-nav .p-menuitem-text {\n\twhite-space: nowrap;\n}\n\n.group-table-component .clear-filter .p-button-icon {\n\tcolor: #4B5563 !important;\n}\n\n.p-multiselect-panel {\n\twidth: 400px;\n\tleft: 620px;\n}\n\n.p-multiselect-panel .p-multiselect-items .p-multiselect-item-group,\n.p-multiselect-panel .p-multiselect-items .p-multiselect-item {\n\tpadding: 6px 10px;\n\tfont-size: 12px;\n}\n\n.p-multiselect-token-label,\n.p-multiselect .p-multiselect-label.p-placeholder {\n\tfont-size: 13px;\n}\n\n.stakeplan .p-field-checkbox {\n\ttext-align: center;\n}\n\n.tooltip-font {\n\tfont-size: 15px;\n\tcursor: pointer;\n}\n\n.p-accordion-toggle-icon {\n\tdisplay: none;\n}\n\n.font-text .p-button-label {\n\tcolor: #19486B !important;\n}\n\n.list-height {\n\theight: 35px;\n\toverflow: auto;\n\toverflow: hidden auto;\n\tmargin-bottom: 0px !important;\n}\n\n.active-button {\n\theight: 27px;\n\tfont-size: 14px;\n\tcolor: #fff;\n\tborder-color: #E5E7EB !important;\n\tbackground-color: #0dcaf0 !important;\n\tborder-radius: 5px !important;\n}\n\n.in-active-button {\n\theight: 27px;\n\tfont-size: 14px;\n\tcolor: #fff;\n\tborder-color: #E5E7EB !important;\n\tbackground-color: grey !important;\n\tborder-radius: 5px !important;\n}\n\n.won-button {\n\theight: 27px;\n\tfont-size: 14px;\n\tcolor: #fff;\n\tborder-color: #E5E7EB !important;\n\tbackground-color: #5cb85c !important;\n\tborder-radius: 5px !important;\n}\n\n.lost-button {\n\theight: 27px;\n\tfont-size: 14px;\n\tcolor: #fff;\n\tborder-color: #E5E7EB !important;\n\tbackground-color: #d43f3a !important;\n\tborder-radius: 5px !important;\n}\n\n.stop-button, .stop-button.p-disabled {\n\theight: 27px;\n    font-size: 14px;\n    color: #fff;\n    border-color: #E5E7EB !important;\n    background-color: #f0ad4e !important;\n\tborder-radius: 5px !important;\n\topacity: 1 !important;\n}\n\n.default-button {\n\theight: 27px;\n\tfont-size: 14px;\n\tcolor: #4B5563;\n\tborder-color: #E5E7EB !important;\n\tbackground-color: #fff !important;\n\tborder-radius: 5px !important;\n}\n\n.btn-info {\n\tcolor: #fff;\n\tbackground-color: #5bc0de;\n\tborder-color: #46b8da;\n}\n\n.btn-default {\n\tcolor: #333;\n\tbackground-color: #fff;\n\tborder: 1px solid #000;\n\t/* Corrected syntax */\n}\n\n.btn-success {\n\tcolor: #fff;\n\tbackground-color: #5cb85c;\n\tborder-color: #4cae4c;\n}\n\n.btn-danger {\n\tcolor: #fff;\n\tbackground-color: #d9534f;\n\tborder-color: #d43f3a;\n}\n\n.btn-default-stat {\n\tcolor: #fff !important;\n\tbackground-color: grey !important;\n\tborder-color: #adadad !important;\n}\n\n.btn-info {\n\tcolor: #fff;\n\tbackground-color: #5bc0de;\n\tborder-color: #46b8da;\n}\n\n.btn-default {\n\tcolor: #333;\n\tbackground-color: #fff;\n\tborder: 1px solid #000;\n}\n\n.btn-success {\n\tcolor: #fff;\n\tbackground-color: #5cb85c;\n\tborder-color: #4cae4c;\n}\n\n.btn-danger {\n\tcolor: #fff;\n\tbackground-color: #d9534f;\n\tborder-color: #d43f3a;\n}\n\n.btn-danger:hover,\n.btn-danger:focus,\n.btn-danger:active,\n.btn-danger.active {\n\tcolor: #fff;\n\tbackground-color: #c9302c;\n\tborder-color: #ac2925;\n}\n\n/* .btn-warning {\n\tcolor: #fff;\n\tbackground-color: #f0ad4e;\n\tborder-color: #eea236;\n  } */\n\n.btn-default-stat {\n\tcolor: #333;\n\tbackground-color: #CCC;\n\tborder-color: #adadad;\n}\n\n.grid-container {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(2, 1fr);\n\t/* 2 columns */\n\tgap: 10px;\n\t/* Adjust the gap between items if needed */\n}\n\n.grid-display {\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 1fr;\n\tgap: 10px;\n}\n\n.grid-display :nth-child(1),\n.grid-display :nth-child(2) {\n\tgrid-column: span 2;\n}\n\n.grid-display-metrics {\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 1fr;\n\tgap: 10px;\n}\n\n.grid-display-metrics :nth-child(1),\n.grid-display-metrics :nth-child(2),\n.grid-display-metrics :nth-child(3),\n.grid-display-metrics :nth-child(4),\n.grid-display-metrics :nth-child(5) {\n\tgrid-column: span 2;\n}\n\n.grid-display-target {\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 1fr;\n\tgap: 10px;\n}\n\n.grid-display-target :nth-child(1) {\n\tgrid-column: span 2;\n}\n\n.p-autocomplete {\n\twidth: 100% !important;\n}\n\n.p-autocomplete-item {\n\tfont-size: 12px !important;\n\tcolor: #4B5563 !important;\n}\n\n.project-address {\n\tborder-color: #E5E7EB;\n\theight: 30px;\n\tborder-radius: 2px !important;\n\tcolor: #495057;\n\tbackground: #ffffff;\n\tpadding-left: 0.5rem;\n\tborder: 1px solid #E5E7EB;\n\ttransition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;\n\tappearance: none;\n\toutline-color: transparent;\n\tfont-size: 12px !important;\n}\n\n.project-address:focus-visible {\n\tborder-color: #E5E7EB;\n\theight: 30px;\n\tborder-radius: 2px !important;\n\tcolor: #495057;\n\tbackground: #ffffff;\n\tpadding-left: 0.5rem;\n\tborder: 2px solid #E5E7EB;\n\ttransition: background-color 0.2s, color 0.2s, border-color 0.2s, box-shadow 0.2s;\n\tappearance: none;\n\toutline-color: transparent;\n\tfont-size: 12px !important;\n}\n\n.color_red_new {\n\tcolor: red\n}\n\n.color_red {\n\tcolor: red;\n\tfont-size: 12px !important;\n\tfont-weight: 500 !important;\n\tmargin: 0px !important;\n}\n\n.color_amber {\n\tcolor: #ffbf00;\n\tfont-size: 12px !important;\n\tfont-weight: 500 !important;\n\tmargin: 0px !important;\n}\n\n.color_green {\n\tcolor: green;\n\tfont-size: 12px !important;\n\tfont-weight: 500 !important;\n\tmargin: 0px !important;\n}\n\n\n/* chat box  */\n.chatbox {\n\tbox-shadow: 0 2px 1px -1px rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 1px 3px 0 rgba(0, 0, 0, 0.12);\n\tborder-radius: 3px;\n\tborder: 1px solid black;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n\theight: 100% !important;\n}\n\n.h-max-content {\n\theight: max-content;\n}\n\n.icon-font {\n\tfont-size: 24px;\n}\n\n.emoji-style {\n\tposition: absolute;\n\tbottom: 40px;\n\tright: 0px\n}\n\n/* Hide the number inside a step item when the lock icon is present */\n.p-steps-item .pi-lock~.p-steps-number {\n\tdisplay: none;\n}\n\n/* Optionally, adjust the alignment of the lock icon */\n.p-steps-item .pi-lock {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tborder: 2px solid rgba(94, 189, 104, 1) !important;\n\tbackground-color: rgba(94, 189, 104, 1) !important;\n\tcolor: rgba(255, 255, 255, 1) !important;\n\tfont-size: 0.7rem;\n\tpadding: 7px 10px;\n\tmargin-top: 24px;\n\tborder-radius: 50%;\n\tmin-width: 2rem;\n\theight: 2rem;\n\tz-index: 1;\n}\n\n.p-tooltip .p-tooltip-text {\n\tfont-size: 11px !important;\n\tbackground-color: rgba(94, 189, 104, 1) !important;\n}\n\n.cp-container {\n    height: 100vh;\n}\n\n.cp-container .form-wrapper {\n    padding: 30px;\n    max-width: 350px; \n    width: 100%;\n    background: white;\n    border-radius: 10px;\n    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n    box-sizing: border-box;\n}\n\n.cp-container .form-group-cp {\n    margin-bottom: 20px;\n    display: flex;\n    flex-direction: column;\n}\n\n.cp-container .label-text {\n    margin-bottom: 5px;\n    font-weight: 500;\n    font-size: 14px;\n}\n\n.cp-container .form-control {\n    padding: 10px;\n    border-radius: 5px;\n    border: 1px solid #ced4da;\n    font-size: 14px;\n    color: #4a4a4a;\n    width: 100%; \n}\n\n.cp-container .update-button {\n    width: 100%;\n    padding: 10px;\n    font-size: 16px;\n    font-weight: 600;\n    background-color: #007bff;\n    border: none;\n    color: white;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: background-color 0.3s;\n}\n\n.cp-container .update-button:hover {\n    background-color: #0056b3;\n}\n.usage-filter{\n\theight:35px !important;\n\twidth: 200px !important;\n}\n.branch-container {\n\tdisplay: flex;\n\talign-items: center; /* Align items vertically center */\n  }\n  \n  .branch-label {\n\tmargin-right: 10px; /* Adjust spacing between label and select element */\n  }\n  \n/* Chat */\n\n.chat-box-adjustment {\n\tz-index: 2;\n    position: absolute;\n    bottom: 0px;\n    right: 6px;\n    width: 550px;\n    height: 600px;\n}\n\n.overflow-auto {\n\toverflow: auto;\n}\n\n.chat .cancel-new-button {\n\theight: 33px;\n    width: 30px;\n\tborder: none;\n}\n\n.text-center {\n\ttext-align: center !important;\n}\n.tooltip-span{\n\tmargin-left: 20px;\n}\n\n.text-right {\n\ttext-align: right;\n}\n\n.message-input-box::placeholder {\n\tfont-size: 13px;\n}\n\n.file-upload {\n\tpadding: 10px !important;\n}\n.uploaded-files{\n\tdisplay: flex;\n\tjustify-content: left;\n\talign-items: center;\n\tbackground-color: rgba(94, 189, 103, 0.185) !important;\n\tpadding: 0.5rem;\n}\n.uploaded-file{\n\tdisplay: flex;\n\talign-items: flex-start;\n\tmargin-left: 10px ;\n}\n.sender{\n\tbox-shadow: 0 2px 1px -1px rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 1px 3px 0 rgba(0, 0, 0, 0.12);\n\tpadding: 0.5rem 1rem;\n\tbackground-color: rgba(94, 189, 103, 0.185);\n\tmargin: 0.2rem;\n\tborder-radius: 3px;\n}\n.receiver{\n\tbox-shadow: 0 2px 1px -1px rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 1px 3px 0 rgba(0, 0, 0, 0.12);\n\tpadding: 0.5rem 1rem;\n\tmargin: 0.2rem;\n\tborder-radius: 3px;\n}\n.emoji-button {\n\tpadding: 0px;\n    display: block;\n    min-width: 30px;\n}\n.uploaded-image{\n\twidth: 200px;\n}\n\n.send-button {\n\tborder: none;\n    padding-bottom: 11px;\n    padding-left: 9px !important;\n    padding-right: 10px !important;\n    display: block;\n    width: 35px;\n}\n\n.editing-icon {\n\tposition: absolute;\n    z-index: 2;\n    bottom: 70px;\n    right: 15px;\n    width: 45px;\n    height: 45px;\n    border: none;\n    box-shadow: inset 0 0 0 1px #2A9235, inset 0 0 0 1px #2A9235, inset 0 0 0 1px #2A9235, inset 0 0 0 1px #2A9235 !important;\n\tbackground-color: #2A9235;\n\tborder-radius: 50%;\n\tcolor: #ffffff;\n}\n\n.pi-comment {\n\tfont-size: 18px;\n}\n.w-cp {\n\twidth: 100%;\n\tpadding-right: 2.5rem; \n}\n\n.notification-icon .p-button-icon {\n\tcolor: #19486B;\n    font-size: 18px !important;\n}\n\n.p-badge-danger {\n\tfont-size: 11px;\n    position: absolute;\n    min-width: 15px;\n    height: 15px;\n    top: 2px;\n    right: 0px;\n}\n.p-badge-success {\n\tfont-size: 11px;\n    position: absolute;\n    min-width: 15px;\n    height: 15px;\n    top: -6px;\n    right: -6px;\n\tbackground-color: #19486B;\n}\n\n\n.container {\n\tdisplay: flex;\n\tjustify-content: center;  \n\talign-items: center;      \n\theight: 100vh; \n}\n\n/* .custom-tabview .p-tabview-nav {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n}\n\n.custom-tabview .p-tabview-nav li {\n    flex: 1 1 16.6%; \n}\n\n.custom-tabview .p-tabview-nav li:nth-child(n+7) {\n    margin-top: 0px; \n} */\n\n.avatar-img {\n\twidth: 30px !important;\n    height: 30px !important;\n    background: rgba(94, 189, 104, 1) !important;\n}\n.login-icon{\n\tposition: relative;\n}\n.cp-icon {\n  position: relative;\n  display: inline-block;\n  width: 30%;\n}\n.eye-icon {\n\tposition: absolute;\n\ttop: 50%;\n\tright: 10px;\n\ttransform: translateY(-50%);\n\tcursor: pointer;\n\tcolor: #888; \n  }\n  \n  .eye-icon:hover {\n\tcolor: #333;\n  }\n\niframe {\n\twidth: 100%;\n    height: 92vh;\n}\n\n.sidebar-link {\n\tcolor: #4B5563 !important; /* Default color */\n\ttext-decoration: none; /* Remove underline */\n  }\n  \n  .sidebar-link:hover {\n\tcolor: #4B5563 !important; /* Maintain color on hover */\n\tcursor: default; /* Change cursor to default */\n  }\n\n  .submenu-link {\n    color: #4B5563 !important; /* Default color */\n    text-decoration: none; /* Remove underline */\n    display: flex; /* Make the entire area clickable */\n\talign-items: center; /* Vertically center the items */\n\tpadding: 12px 16px; \n\tfont-size: 13px; /* Ajust the font size */\n}\n\n.submenu-link i {\n    margin-right: 8px; /* Adjust the value for the desired space */\n\tfont-size: 14px;\n}\n\n.submenu-link:hover {\n    color: #4B5563 !important; /* Maintain color on hover */\n    cursor: pointer; /* Change cursor to pointer */\n}\n\n.password-input {\n\twidth: 100%;\n\tpadding-right: 30px;\n}\n\n.logo-icon-dashboard {\n\twidth: 34px !important;\n    cursor: pointer;\n    height: 34px;\n    position: absolute;\n    right: 15px;\n    z-index: 1001;\n    top: 84px;\n    background-color: #2A9235;\n    padding: 6px;\n    border-radius: 35%;\n}\n\n.scroll-top{\n\tposition: absolute;\n\tz-index: 2;\n\tbottom: 15px;\n\tright: 15px;\n\twidth: 45px;\n\theight: 45px;\n\tpadding: 10px 20px;\n\tborder-radius: 50%;\n\tcursor: pointer;\n\tfont-size: 16px;\n}\n\n.target-div{\n\tmargin-top: -60px;\n\tmargin-bottom: 80px;\n}\n\n.target-cal .p-inputtext {\n\twidth: 84px !important;\n}\n\n\n@media only screen and (min-width: 769px) {\n\t/* Target the specific modal (video modal) */\n\t#videoModal {\n\t  width: 80% !important;   /* Set the width of this specific modal */\n\t  height: 90% !important;  /* Adjust height for this specific modal */\n\t}\n  \n\n\t/* .p-dialog {\n\t  width: 80% !important;   \n\t} */\n  \n\t/* Example for a resource planner modal, which can be left unchanged */\n\t.resource-planner .p-dialog {\n\t  width: 60% !important;\n\t  height: 60% !important;\n\t}\n  \n\t/* Specific adjustments for other modals, if needed */\n\t#surveyDialogView {\n\t  width: 80% !important;\n\t}\n  \n\t#travelApproval {\n\t  width: 50% !important;\n\t}\n  \n\t#visaApproval {\n\t  width: 53% !important;\n\t}\n  }\n  \n  /* Adjust for smaller screens */\n  @media only screen and (max-width: 768px) {\n\t/* Apply these styles only to the video modal */\n\t#videoModal {\n\t  width: 95% !important;    /* Full width on small screens */\n\t  height: auto !important;  /* Auto height for responsiveness */\n\t}\n  \n\t/* General modal settings for smaller screens */\n\t.p-dialog {\n\t  width: 95% !important;\n\t  height: auto !important;\n\t}\n  \n\t/* Other modals */\n\t#surveyDialogView,\n\t#travelApproval,\n\t#visaApproval {\n\t  width: 90% !important;\n\t}\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
